<template>
  <!--  -->
  <div>
    <!--  -->
    <div-filter
      v-if="
        config.name != 'shippingsHistories' &&
          config.name != 'stockHistories' &&
          config.name != 'statusHistories'
      "
      :name="config.name"
      :config="config"
      :filters="filters"
      :currentUser="currentUser"
      @reset="reset"
      @filtrer="filtrer"
      @search="search"
      @searchSellers="searchSellers"
      @searchCouriers="searchCouriers"
    ></div-filter>
    <!--  -->

    <!--  -->
    <div :class="config.class">
      <!--  -->
      <div class="bg-white w-full flex flex-col gap-2 rounded-lg shadow">
        <!--  -->
        <div
          v-if="
            (config.name == 'expeditions' &&
              (currentUser.type == 'Admin' || currentUser.type == 'CEO')) ||
              config.name == 'products'
          "
        >
          <!--  -->
          <div
            @click="openAnalytics = !openAnalytics"
            class="py-4 cursor-pointer bg-grey-lighter hover:bg-grey-light text-indigo-darker rounded rounded-t-none text-center uppercase font-bold flex items-center justify-center text-primary-600"
          >
            <!--  -->
            <span class="block border border-gray-400 w-1/3 mr-2"></span>
            <!--  -->

            <!--  -->
            <button
              class="text-base md:text-lg border border-orange-500 text-orange-500 rounded-lg font-bold py-2 md:py-4 px-4 md:px-6 flex items-center hover:bg-orange-500 hover:text-white"
            >
              <!--  -->
              Show analytics
              <!--  -->
              <i class="material-icons text-primary-600 ml-3">timeline</i>
              <!--  -->
            </button>
            <!--  -->

            <!--  -->
            <span class="block border border-gray-400 w-1/3 ml-2"></span>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <chart-expeditions
            v-if="openAnalytics && config.name == 'expeditions'"
            :currentUser="currentUser"
          />
          <!--  -->

          <!--  -->
          <chart-products
            v-if="openAnalytics && config.name == 'products'"
            :currentUser="currentUser"
          />
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div
          v-if="config.title"
          class="flex flex-row gap-4 items-center justify-between border-gray-200 py-2 px-3 md:py-3 md:px-6"
        >
          <!--  -->
          <div class="flex item-center gap-4">
            <!--  -->
            <i
              v-if="config.icone"
              class="material-icons p-3 text-primary-400"
              >{{ config.icone }}</i
            >
            <!--  -->

            <!--  -->
            <span
              class="flex items-center text-lg md:text-xl lg:text-2xl font-bold text-primary-600 capitalize"
            >
              {{ $t(config.title) }}
            </span>
            <!--  -->

            <!--  -->
            <div
              v-on-clickaway="awayLimit"
              v-if="config.name == 'shippings' || config.name == 'orders'"
            >
              <!--  -->
              <button
                @click="openLimit = !openLimit"
                class="vs-con-dropdown parent-dropdown cursor-pointer"
              >
                <!--  -->
                <div
                  class="p-2 shadow rounded-lg cursor-pointer flex items-end justify-center text-sm font-medium"
                >
                  <!--  -->
                  <span class="mr-2"
                    >{{ paginate.currentpage }} - {{ data.length }} /
                    <!--  -->
                    {{ paginate.total }}
                    <!--  -->
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="feather-icon select-none relative">
                    <!--  -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down h-4 w-4"
                    >
                      <!--  -->
                      <polyline points="6 9 12 15 18 9"></polyline>
                      <!--  -->
                    </svg>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </button>
              <!--  -->

              <!--  -->
              <div class="relative">
                <!--  -->
                <div
                  v-if="openLimit"
                  class="absolute focus:ring-2 focus:ring-orange-600 right-0 dropdown-action-limit w-auto mt-3 z-10 origin-top-right rounded-md shadow-lg"
                >
                  <!--  -->
                  <div
                    class="bg-white rounded-md shadow dark-mode:bg-gray-800 dropdown-limit"
                  >
                    <!--  -->
                    <a
                      @click="Changelimit(50)"
                      class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      >50</a
                    >
                    <!--  -->

                    <!--  -->
                    <a
                      @click="Changelimit(100)"
                      class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      >100</a
                    >
                    <!--  -->

                    <!--  -->
                    <a
                      @click="Changelimit(200)"
                      class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      >200</a
                    >
                    <!--  -->

                    <!--  -->
                    <a
                      @click="Changelimit(300)"
                      class="block cursor-pointer px-2 text-center py-1 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      >300</a
                    >
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="vs-dropdown--limit--after"></div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="flex gap-4 relative justify-end">
            <!--  -->
            <div
              class="flex justify-end"
              v-if="
                config.options.actions.isActive &&
                  (!config.options.actions.method ||
                    config.options.actions.link) &&
                  getAccess('create', null, null, true) &&
                  (currentUser.type !== 'Seller' ||
                    currentUser.type === 'Seller')
              "
            >
              <!--  -->
              <router-link
                v-for="(item, index) in config.options.actions.buttons"
                :key="index"
                :to="item.link"
                class="text-base rounded flex gap-2 focus:outline-none outline-none text-gray-100 w-fit py-1 md:py-2 px-1 md:px-3 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              >
                <!--  -->
                <i class="material-icons">{{ item.icon }}</i>
                <!--  -->

                <!--  -->
                <span class="hidden md:flex">{{ $t(item.text) }}</span>
                <!--  -->
              </router-link>
              <!--  -->
            </div>
            <!--  -->
            <div class=" hidden lg:flex lg:gap-2 lg:block">
              <!--  -->
              <div
                v-if="
                  config.name == 'orders' ||
                    (config.name == 'shippings' && (currentUser.type == 'CEO' || currentUser.role.name == 'Teamleader' || currentUser.role.name == 'super admin' || currentUser.type == 'Teamleader')) ||
                    config.name == 'expeditions'
                "
                @click="downloadExcel"
                :class="dataExcel.loading ? 'noselect' : ''"
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 py-2 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300 loidingconfirm relative"
              >
                <!--  -->
                <loading
                  :active.sync="dataExcel.loading"
                  :is-full-page="fullPage"
                ></loading>
                <!--  -->

                <!--  -->
                <i class="material-icons">file_download</i>
                <!--  -->

                <!--  -->
                <span
                  v-if="dataExcel.loading"
                  class="inline-block loading-excel"
                >
                  <!--  -->
                  Exporting ({{ timer }}/ {{ paginate.total }}) <span>.</span
                  ><span>.</span><span>.</span>
                </span>
                <!--  -->

                <!--  -->
                <span v-else>Excel</span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                v-if="
                  config.name == 'shippings' &&
                    (currentUser.type == 'Admin' ||
                      currentUser.type == 'CEO' ||
                      currentUser.type == 'StockManager')
                "
                @click="OpenClosePopupModal('open', 'dauchette')"
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              >
                <!--  -->
                <i class="material-icons mr-2">perm_scan_wifi </i> Douchette
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                v-if="
                  config.name == 'shippings' &&
                    (currentUser.type == 'Admin' || currentUser.type == 'CEO')
                "
                @click="OpenClosePopupModal('open', 'Refund')"
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              >
                <!--  -->
                <img
                  style="height: 24px"
                  class="material-icons mr-1"
                  src="https://img.icons8.com/ios/100/FFFFFF/refund-2.png"
                />
                <!--  -->
                Remboursement
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                v-if="
                  config.name == 'shippings' &&
                    ['Admin', 'CEO', 'StockManager'].includes(currentUser.type)
                "
                @click="OpenClosePopupModal('open', 'Echange')"
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-orange-500 hover:shadow-inner hover:bg-orange-700 transition-all duration-300"
              >
                <!--  -->
                <i class="material-icons mr-1">sync </i> Echange
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <router-link
                to="/shippings/verify"
                v-if="
                  config.name == 'shippings' &&
                    (currentUser.type == 'Admin' ||
                      currentUser.type == 'CEO' ||
                      currentUser.type == 'Support' ||
                      currentUser.type == 'CallcenterManager')
                "
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-orange-700 hover:shadow-inner hover:bg-orange-900 transition-all duration-300"
              >
                <!--  -->
                Verify shipments
                <!--  -->
              </router-link>
              <!--  -->

              <!--  -->
              <div
                v-if="
                  config.name == 'orders' &&
                    (currentUser.type == 'CEO' || currentUser.type == 'Admin')
                "
                @click="OpenClosePopupModal('open', 'toShipp')"
                class="cursor-pointer flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-green-600 hover:shadow-inner hover:bg-green-700 transition-all duration-300"
              >
                <!--  -->
                Send to Shipp
                <!--  -->
                <svg
                  class="fill-current ml-1"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <!--  -->
                  <path
                    d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"
                  />
                  <!--  -->
                </svg>
                <!--  -->
              </div>
              <!--  -->
            </div>

            <!--  -->
            <div
              v-on-clickaway="away"
              v-if="
                config.options.actions.isActive &&
                  config.options.actions.method &&
                  ['shippings', 'payments', 'products', 'orders'].includes(
                    config.name,
                  ) &&
                  getAccessLinks(null)
              "
            >
              <!--  -->
              <button
                @click="open = !open"
                class="vs-con-dropdown parent-dropdown cursor-pointer"
              >
                <!--  -->
                <div
                  class="p-3 shadow rounded-lg cursor-pointer flex items-end justify-center text-lg font-medium"
                >
                  <!--  -->
                  <span class="feather-icon select-none relative">
                    <!--  -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-more-vertical h-4 w-4"
                    >
                      <!--  -->
                      <circle cx="12" cy="12" r="1"></circle>
                      <!--  -->

                      <!--  -->
                      <circle cx="12" cy="5" r="1"></circle>
                      <!--  -->

                      <!--  -->
                      <circle cx="12" cy="19" r="1"></circle>
                      <!--  -->
                    </svg>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </button>
              <!--  -->

              <!--  -->
              <div
                v-if="open"
                x-transition:enter="transition ease-out duration-100"
                x-transition:enter-start="transform opacity-0 scale-95"
                x-transition:enter-end="transform opacity-100 scale-100"
                x-transition:leave="transition ease-in duration-75"
                x-transition:leave-start="transform opacity-100 scale-100"
                x-transition:leave-end="transform opacity-0 scale-95"
                class="absolute focus:ring-2 focus:ring-green-600 right-0 dropdown-action mt-5 z-10 origin-top-right rounded-md shadow-lg"
              >
                <!--  -->
                <div class="bg-white rounded-md shadow dark-mode:bg-gray-800">
                  <!--  -->
                  <a
                    v-for="(item, index) in config.options.actions.buttons"
                    :key="index"
                    v-show="getAccessLinks(item.action)"
                    @click="EmitMethodAction(item.action)"
                    class="flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <!--  -->
                    <i class="material-icons">{{ item.icon }}</i>
                    <!--  -->
                    {{ $t(item.text) }}
                    <!--  -->
                  </a>
                  <!--  -->

                  <a
                    v-if="
                      config.name == 'orders' ||
                      (config.name == 'shippings' && (currentUser.type == 'CEO' || currentUser.role.name == 'Teamleader' || currentUser.role.name == 'super admin' || currentUser.type == 'TeamLeader') ) ||
                      config.name == 'expeditions'
                    "
                    @click="downloadExcel"
                    :class="dataExcel.loading ? 'noselect' : ''"
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <i class="material-icons">file_download</i>
                    <span
                      v-if="dataExcel.loading"
                      class="inline-block loading-excel"
                      >Exporting ({{ timer }}/ {{ paginate.total }})
                      <span>.</span><span>.</span><span>.</span></span
                    >
                    <span v-else>Excel</span>
                  </a>

                  <a
                    v-if="
                      config.name == 'shippings' &&
                        (currentUser.type == 'Admin' ||
                          currentUser.type == 'CEO' ||
                          currentUser.type == 'StockManager')
                    "
                    @click="OpenClosePopupModal('open', 'dauchette')"
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <i class="material-icons mr-2">perm_scan_wifi</i> Douchette
                  </a>

                  <a
                    v-if="
                      config.name == 'shippings' &&
                        (currentUser.type == 'Admin' ||
                          currentUser.type == 'CEO')
                    "
                    @click="OpenClosePopupModal('open', 'Refund')"
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <img
                      style="height: 24px"
                      class="material-icons mr-1"
                      src="https://img.icons8.com/ios/100/FFFFFF/refund-2.png"
                    />
                    Remboursement
                  </a>

                  <a
                    v-if="
                      config.name == 'shippings' &&
                        ['Admin', 'CEO', 'StockManager'].includes(
                          currentUser.type,
                        )
                    "
                    @click="OpenClosePopupModal('open', 'Echange')"
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <i class="material-icons mr-1">sync</i> Echange
                  </a>

                  <router-link
                    to="/shippings/verify"
                    v-if="
                      config.name == 'shippings' &&
                        (currentUser.type == 'Admin' ||
                          currentUser.type == 'CEO' ||
                          currentUser.type == 'Support' ||
                          currentUser.type == 'CallcenterManager')
                    "
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <i class="material-icons mr-1">check_circle</i> Verify
                    shipments
                  </router-link>

                  <a
                    v-if="
                      config.name == 'orders' &&
                        (currentUser.type == 'CEO' ||
                          currentUser.type == 'Admin')
                    "
                    @click="OpenClosePopupModal('open', 'toShipp')"
                    class="lg:hidden flex items-center gap-4 cursor-pointer px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      class="fill-current ml-1"
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                    >
                      <path
                        d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"
                      />
                    </svg>
                    Send to Shipp
                  </a>
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>

            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div
            class="w-1/2 flex justify-end space-x-4"
            v-if="
              config.options.actions.isActive &&
                config.options.actions.method &&
                config.name == 'statusHistories'
            "
          >
            <!--  -->
            <button
              @click="downloadAnalytics"
              v-for="(item, index) in config.options.actions.buttons"
              :key="index"
              class="rounded flex focus:outline-none outline-none text-gray-100 px-3 w-fit md:w-1/7 py-2 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
            >
              <!--  -->
              <i class="material-icons mr-2">{{ item.icon }}</i>
              <!--  -->
              {{ $t(item.text) }}
              <!--  -->
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div
          v-if="isFilterCourier && config.name == 'shippings'"
          class="flex justify-center border-gray-200"
        >
          <!--  -->
          <div
            class="w-5/12 bg-primary-100 border-t-4 border-green-600 rounded-b text-teal-darkest px-4 py-3 shadow-md my-2"
            role="alert"
          >
            <!--  -->
            <div class="flex">
              <!--  -->
              <i class="large material-icons mr-5">account_balance_wallet</i>
              <!--  -->
              <div>
                <!--  -->
                <p class="font-bold">
                  {{ $t('courier') }} :
                  <!--  -->
                  <span>{{ CourierInfo.courier || 'No Courier' }}</span>
                  <!--  -->
                </p>
                <!--  -->

                <!--  -->
                <p class="font-bold">
                  <!--  -->
                  {{ $t('total_orders') }} <span>{{ CourierInfo.count }}</span>
                  <!--  -->
                </p>
                <!--  -->

                <!--  -->
                <p class="font-bold">
                  <!--  -->
                  {{ $t('total') }} : <sup>{{ currency }}</sup>
                  <!--  -->
                  {{ CourierInfo.total }}
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div style="overflow-x:auto;">
          <!--  -->
          <table id="loading" class="min-w-full w-full">
            <!--  -->
            <thead class="relative sticky-table">
              <!--  -->
              <tr
                class="bg-slate-200 text-slate-600 uppercase text-sm leading-normal"
              >
                <!--  -->
                <th
                  v-for="(item, key) in config.columns"
                  :key="key"
                  :class="[item.class]"
                  class="px-6 py-3 border-b bg-slate-200 border-slate-200 text-slate-600 text-center text-xs leading-4 font-medium uppercase tracking-wider"
                >
                  <!--  -->
                  <label
                    v-if="
                      item.type &&
                        config.name != 'products' &&
                        currentUser.type != 'Seller'
                    "
                    class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-slate-200 px-2 py-2 rounded-lg cursor-pointer"
                  >
                    <!--  -->
                    <input
                      type="checkbox"
                      @click="selectAllCheckbox($event)"
                      class="form-checkbox checkallbbox focus:outline-none focus:shadow-outline"
                    />
                    <!--  -->
                  </label>
                  <!--  -->

                  <!--  -->
                  <span v-else> {{ item.name }}</span>
                  <!--  -->
                </th>
                <!--  -->

                <!--  -->
                <th
                  v-if="
                    config.actions &&
                      config.actions.elements &&
                      config.actions.elements.length != 0
                  "
                  style="position: sticky; right: 0px;"
                  class="px-3 py-3 border-b bg-slate-200 border-slate-200 text-center text-xs leading-4 font-medium text-slate-600 uppercase tracking-wider sticky-table-header-right sticky-table-header-right-first"
                >
                  {{ config.actions.name }}
                </th>
                <!--  -->
              </tr>
              <!--  -->
            </thead>
            <!--  -->

            <!--  -->
            <tbody v-for="(item, index) in data" :key="index" class="relative">
              <!--  -->
              <loading
                class="tab-trr"
                v-if="
                  (oldData.data &&
                    oldData.data._id &&
                    oldData.data._id.toString() === item._id.toString()) ||
                    (paymentData.loading &&
                      index.toString() === paymentData.index.toString())
                "
                :active.sync="oldData.loading || paymentData.loading"
                :is-full-page="fullPage"
              ></loading>
              <!--  -->

              <!--  -->
              <tr
                :class="[
                  index % 2 != 0 ? 'bg-gray-100' : '',
                  config.name == 'shippings' &&
                  currentUser.type != 'Seller' &&
                  data[index].externalId &&
                  data[index].externalId.indexOf('MRK') != -1
                    ? 'chrono_diali'
                    : '',
                  config.name == 'shippings' &&
                  currentUser.type != 'Seller' &&
                  data[index].shipping_source &&
                  data[index].shipping_source === 'EDCO'
                    ? 'st_edco'
                    : '',
                  config.name == 'shippings' &&
                  currentUser.type != 'Seller' &&
                  data[index].externalId &&
                  data[index].externalId &&
                  data[index].trackingNumber.indexOf('CRD') != -1
                    ? 'chrono_diali_seller'
                    : '',
                  config.name == 'shippings' &&
                  currentUser.type != 'Seller' &&
                  data[index].trackingNumber &&
                  isNumeric(data[index].trackingNumber)
                    ? 'aramex'
                    : '',
                  config.name == 'orders' && data[index].source
                    ? data[index].source
                    : '',
                  (config.name == 'orders' || config.name == 'expeditions') &&
                  data[index].traitBy
                    ? data[index].traitBy
                    : '',
                  getCourierClass(data[index].courier),
                  data[index].totalPrice == 0 ? 'orange-orders' : '',
                ]"
                class="border-b border-gray-200 hover:bg-gray-100"
              >
                <!--  -->
                <td
                  v-for="(col, ind) in config.columns"
                  :key="ind"
                  class="px-5 py-2 whitespace-no-wrap border-b border-gray-300 text-center"
                  :class="[
                    ind == 0 || ind == 1
                      ? col.type == 'checkbox'
                        ? 'px-1-imp text-left-imp'
                        : 'text-left-imp'
                      : '',
                    col.name,
                  ]"
                  v-if="col.name !== 'shipper' || currentUser.type === 'CEO'"
                >
                  <!--  -->
                  <div
                    class="text-xs leading-5 capitalize rounded-full text-gray-900"
                  >
                    <!--  -->
                    <div
                      v-for="(element, indElm) in col.elements"
                      :key="indElm"
                    >
                      <!--  -->
                      <div
                        v-for="(itemst, itemIndex) in element.items"
                        :key="itemIndex"
                      >
                        <!--  -->
                        <div v-if="!itemst.elements">
                          <!--  -->
                          <div
                            v-if="
                              itemst.name == 'status' ||
                                itemst.name == 'previousStatus'
                            "
                          >
                            <!--  -->
                            <div v-if="!itemst.data">
                              <!--  -->
                              <div
                                class="relative"
                                v-if="
                                  config.name != 'shippingsHistories' &&
                                    config.name != 'payments'
                                "
                              >
                                <!--  -->
                                <button
                                  @click="
                                    ShowPopUpInformation(
                                      index,
                                      data[index][itemst.name],
                                      item,
                                    )
                                  "
                                  :class="itemst.class"
                                  :style="
                                    itemst.options(data[index][itemst.name])
                                  "
                                >
                                  {{ data[index][itemst.name] }}
                                </button>
                                <!--  -->

                                <!-- Whatsapp Image -->
                                <div
                                  class="share_button"
                                  v-if="
                                    config.name === 'shippings' &&
                                      currentUser.type !== 'Seller'
                                  "
                                >
                                  <!--  -->
                                  <div
                                    class="btn-whats btn-whats-ship"
                                    @click="
                                      openWhatsApp(
                                        data[index]['orderObjet']['customer'],
                                      )
                                    "
                                  >
                                    <!--  -->
                                    <img
                                      width="96"
                                      height="96"
                                      src="https://storeno.b-cdn.net/stores/9-2024/1726677320464.png"
                                      alt="whatsapp"
                                    />
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!-- Whatsapp Image -->

                                <!--  -->
                                <div
                                  v-if="
                                    config.name === 'shippings' &&
                                      data[index].orderObjet
                                        .teleConsultantConfirm &&
                                      data[index].orderObjet
                                        .teleConsultantConfirm.fullName &&
                                      currentUser.type !== 'Seller'
                                  "
                                  class="flex call-post"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    class="fill-current mr-2"
                                  >
                                    <path
                                      d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"
                                    ></path>
                                  </svg>
                                  {{
                                    data[index].orderObjet.teleConsultantConfirm
                                      .fullName
                                  }}
                                </div>
                                <!--  -->

                                <!--  -->
                                <div
                                  v-if="
                                    config.name === 'shippings' &&
                                      data[index].echange &&
                                      data[index].echange.date
                                  "
                                  class="flex call-post"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    class="fill-current mr-1 inline"
                                  >
                                    <path
                                      d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 20l-1.359-2.038c-1.061.653-2.305 1.038-3.641 1.038-3.859 0-7-3.14-7-7h2c0 2.757 2.243 5 5 5 .927 0 1.786-.264 2.527-.708l-1.527-2.292h5.719l-1.719 6zm0-8c0-2.757-2.243-5-5-5-.927 0-1.786.264-2.527.708l1.527 2.292h-5.719l1.719-6 1.359 2.038c1.061-.653 2.305-1.038 3.641-1.038 3.859 0 7 3.14 7 7h-2z"
                                    ></path></svg
                                  >Echange({{
                                    data[index].echange.trackingNumber
                                  }})
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <span
                                class="jvectormap-tip label-success text-white"
                                v-if="
                                  config.name === 'shippings' &&
                                    data[index].api_status &&
                                    ((currentUser.type === 'Seller' &&
                                      !data[index].shipping_source) ||
                                      currentUser.type !== 'Seller')
                                "
                                v-html="
                                  !data[index].shipping_source
                                    ? 'Dernier statut: (' +
                                      data[index].api_status +
                                      ')'
                                    : data[index].api_status
                                "
                              ></span>
                              <!--  -->

                              <!--  -->
                              <span
                                class="jvectormap-tip text-white"
                                v-if="
                                  config.name == 'shippings' &&
                                    currentUser &&
                                    currentUser.type &&
                                    currentUser.type != 'Seller' &&
                                    data[index].status == 'delivered' &&
                                    !data[index].isProcessed &&
                                    (data[index].is_paid == 'valid' ||
                                      data[index].is_paid == 'accept')
                                "
                                :class="
                                  data[index].is_paid == 'accept'
                                    ? 'label-accept'
                                    : 'label-warning'
                                "
                              >
                                {{
                                  'paid (' +
                                    $moment(data[index].paidAt).format(
                                      'DD-MM-YYYY',
                                    ) +
                                    ')'
                                }}
                                <span class="block"
                                  ><svg
                                    v-if="data[index].is_paid == 'accept'"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 24 24"
                                    class="inline-block fill-current"
                                  >
                                    <path
                                      d="M0 11.386l1.17-1.206c1.951.522 5.313 1.731 8.33 3.597 3.175-4.177 9.582-9.398 13.456-11.777l1.044 1.073-14 18.927-10-10.614z"
                                    ></path>
                                  </svg>
                                  invoiced: {{ data[index].is_paid }}</span
                                >
                              </span>
                              <!--  -->

                              <!--  -->
                              <span
                                class="jvectormap-tip label-success text-white"
                                v-if="
                                  config.name == 'shippings' &&
                                    (data[index].status == 'delivered' ||
                                      data[index].status == 'cancelled' ||
                                      data[index].status == 'rembourser' ||
                                      data[index].status == 'refused') &&
                                    data[index].isProcessed
                                "
                              >
                                {{
                                  'Processed (' +
                                    $moment(data[index].processedAt).format(
                                      'DD-MM-YYYY',
                                    ) +
                                    ')'
                                }}
                              </span>
                              <!--  -->

                              <!--  -->
                              <span
                                class="jvectormap-tip label-danger text-white"
                                v-if="
                                  config.name == 'shippings' &&
                                    (data[index].status == 'cancelled' ||
                                      data[index].status == 'refused') &&
                                    !data[index].isProcessed &&
                                    data[index].type == 'return'
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="inline-block fill-current"
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    d="M17.026 22.957c10.957-11.421-2.326-20.865-10.384-13.309l2.464 2.352h-9.106v-8.947l2.232 2.229c14.794-13.203 31.51 7.051 14.794 17.675z"
                                  />
                                </svg>
                                {{
                                  'returned (' +
                                    $moment(data[index].paidAt).format(
                                      'DD-MM-YYYY',
                                    ) +
                                    ')'
                                }}
                              </span>
                              <!--  -->

                              <!--  -->
                              <div v-else>
                                <!--  -->
                                <template v-if="config.name === 'payments'">
                                  <p
                                    v-if="
                                      currentUser && currentUser.type === 'CEO'
                                    "
                                  >
                                    <select
                                      id="type"
                                      name="status"
                                      :style="
                                        itemst.options(data[index][itemst.name])
                                      "
                                      autocomplete="type"
                                      v-model="data[index][itemst.name]"
                                      @change="
                                        ChangeStatus(
                                          data[index],
                                          index,
                                          'payments',
                                        )
                                      "
                                      class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                                    >
                                      <option selected disabled :value="null"
                                        >Status</option
                                      >
                                      <option
                                        v-for="(value,
                                        index) in paymentData.status"
                                        :key="index"
                                        :value="value"
                                      >
                                        {{ value }}
                                      </option>
                                    </select>
                                  </p>
                                  <p v-else>{{ data[index][itemst.name] }}</p>
                                </template>
                                <!--  -->

                                <!--  -->
                                <!-- <button v-else :class="itemst.class" :style="itemst.options(data[index][itemst.name])">
                                  {{ data[index][itemst.name] }}
                                </button> -->
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->

                            <!--  -->
                            <div class="relative" v-else>
                              <!-- Status Orders -->
                              <button
                                :disabled="
                                  !currentUser.type == 'Admin' ||
                                    !currentUser.type == 'CEO' ||
                                    !currentUser.type == 'TeleConsultant'
                                "
                                @click="ShowPopUpInformation(index, null, item)"
                                :class="
                                  oldData.loading
                                    ? 'noselect ' + itemst.class
                                    : itemst.class
                                "
                                v-bind:style="{
                                  color: data[index][itemst.name]
                                    ? data[index][itemst.name][
                                        itemst.champs.color
                                      ]
                                    : '',
                                  borderColor: data[index][itemst.name]
                                    ? data[index][itemst.name][
                                        itemst.champs.color
                                      ]
                                    : '',
                                }"
                              >
                                {{
                                  data[index][itemst.name]
                                    ? data[index][itemst.name][
                                        itemst.champs.name
                                      ]
                                    : ''
                                }}
                              </button>
                              <!--  -->

                              <!--  -->
                              <div
                                v-if="
                                  config.name === 'orders' &&
                                    data[index][itemst.name] &&
                                    data[index][itemst.name][itemst.champs.name]
                                "
                              >
                                <!-- Whatsapp Image -->
                                <div
                                  class="share_button"
                                  v-if="currentUser.type !== 'Seller'"
                                >
                                  <!--  -->
                                  <div
                                    class="btn-whats btn-whats-order"
                                    @click="
                                      openWhatsApp(data[index]['customer'])
                                    "
                                  >
                                    <!--  -->
                                    <img
                                      width="96"
                                      height="96"
                                      src="https://storeno.b-cdn.net/stores/9-2024/1726677320464.png"
                                      alt="whatsapp"
                                    />
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!-- Whatsapp Image -->

                                <!--  -->
                                <span
                                  v-if="data[index]['lastUnreachedDate']"
                                  class="flex items-center justify-center sous-s"
                                >
                                  <svg
                                    class="fill-current mr-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M18.48 22.926l-1.193.658c-6.979 3.621-19.082-17.494-12.279-21.484l1.145-.637 3.714 6.467-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zm-9.808-22.926l-1.68.975 3.714 6.466 1.681-.975-3.715-6.466zm8.613 14.997l-1.68.975 3.714 6.467 1.681-.975-3.715-6.467z"
                                    />
                                  </svg>
                                  <span
                                    >Unreached ({{
                                      data[index]['sameOrderUnreached'].length
                                    }})</span
                                  >
                                </span>
                                <!--  -->

                                <!--  -->
                                <span
                                  v-if="data[index]['remind']"
                                  class="flex items-center justify-center sous-s"
                                >
                                  <svg
                                    class="fill-current mr-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z"
                                    />
                                  </svg>
                                  <span
                                    >Reminded (To:
                                    {{
                                      $moment(data[index]['remind']).format(
                                        'DD-MM-YYYY HH:mm',
                                      )
                                    }})</span
                                  >
                                </span>
                                <!--  -->

                                <!--  -->
                                <span
                                  v-if="
                                    currentUser.type !== 'Seller' &&
                                      data[index]['skippedBy'] &&
                                      data[index]['skippedBy'].date
                                  "
                                  class="flex flex-col items-center sous-s"
                                  style="background-color: #f2b88061;"
                                >
                                  <!--  -->
                                  <span
                                    class="flex items-center justify-center gap-1"
                                  >
                                    <!--  -->
                                    <img
                                      src="https://uxwing.com/wp-content/themes/uxwing/download/controller-and-music/skip-icon.png"
                                      width="20"
                                      height="20"
                                      alt="Skip icon"
                                      title="Skip icon"
                                    />
                                    <!--  -->
                                    <span>
                                      (date:
                                      {{
                                        $moment(
                                          data[index]['skippedBy'].date,
                                        ).format('DD-MM-YYYY HH:mm')
                                      }})</span
                                    >
                                    <!--  -->
                                  </span>
                                  <!--  -->

                                  <!--  -->
                                  <span v-if="data[index]['comment']">
                                    {{
                                      data[index]['comment'].length > 30
                                        ? data[index]['comment'].slice(0, 30) +
                                          '...'
                                        : data[index]['comment']
                                    }}
                                  </span>
                                  <!--  -->
                                </span>
                                <!--  -->

                                <!--  -->
                                <span
                                  v-if="
                                    data[index]['teleConsultant'] &&
                                      data[index]['teleConsultant']._id &&
                                      currentUser._id &&
                                      currentUser._id.toString() !=
                                        data[index][
                                          'teleConsultant'
                                        ]._id.toString() &&
                                      data[index]['status'] &&
                                      data[index]['status'].name !== 'Confirmed'
                                  "
                                  class="flex items-center justify-center relative text-www"
                                >
                                  <!--  -->
                                  <span class="pulse bg-warning"></span> En cour
                                  de traitement
                                  <!--  -->
                                  <span
                                    class="ml-1"
                                    v-if="currentUser.type != 'Seller'"
                                  >
                                    (<i
                                      style=" font-size: 12px; vertical-align: sub;"
                                      class="material-icons"
                                      >person</i
                                    >
                                    {{
                                      data[index]['teleConsultant'].fullName
                                    }})
                                  </span>
                                  <!--  -->
                                </span>
                                <!--  -->

                                <!--  -->
                                <span
                                  v-if="
                                    data[index][itemst.name] &&
                                      data[index][itemst.name].name ===
                                        'Cancelled' &&
                                      data[index]['comment'] &&
                                      data[index]['comment'].length > 0
                                  "
                                  class="flex items-center justify-center gap-2 sous-s"
                                >
                                  <!--  -->
                                  <svg
                                    class="w-4 h-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20px"
                                    height="20px"
                                    viewBox="0 0 48 48"
                                  >
                                    <!--  -->
                                    <path
                                      d="M44,5.1V14a2,2,0,0,1-2,2H33a2,2,0,0,1-2-2.3A2.1,2.1,0,0,1,33.1,12h4.3A18,18,0,0,0,6.1,22.2a2,2,0,0,1-2,1.8h0a2,2,0,0,1-2-2.2A22,22,0,0,1,40,8.9V5a2,2,0,0,1,2.3-2A2.1,2.1,0,0,1,44,5.1Z"
                                      fill="currentColor"
                                    />
                                    <!--  -->
                                    <path
                                      d="M4,42.9V34a2,2,0,0,1,2-2h9a2,2,0,0,1,2,2.3A2.1,2.1,0,0,1,14.9,36H10.6A18,18,0,0,0,41.9,25.8a2,2,0,0,1,2-1.8h0a2,2,0,0,1,2,2.2A22,22,0,0,1,8,39.1V43a2,2,0,0,1-2.3,2A2.1,2.1,0,0,1,4,42.9Z"
                                      fill="currentColor"
                                    />
                                    <!--  -->
                                    <path
                                      d="M24,28a2,2,0,0,0,2-2V16a2,2,0,0,0-4,0V26A2,2,0,0,0,24,28Z"
                                      fill="currentColor"
                                    />
                                    <!--  -->
                                    <circle
                                      cx="24"
                                      cy="32"
                                      r="2"
                                      fill="currentColor"
                                    />
                                    <!--  -->
                                  </svg>
                                  <!--  -->

                                  <!--  -->
                                  <span>
                                    {{
                                      data[index]['comment'].length > 30
                                        ? data[index]['comment'].slice(0, 30) +
                                          '...'
                                        : data[index]['comment']
                                    }}
                                  </span>
                                  <!--  -->
                                </span>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->

                          <!--  -->
                          <div
                            v-else-if="
                              itemst.name == 'type' &&
                                config.name != 'stockHistories'
                            "
                          >
                            <span
                              :style="itemst.options(data[index][itemst.name])"
                              >{{ data[index][itemst.name] }}</span
                            >
                          </div>
                          <!--  -->

                          <!--  -->
                          <div v-else :class="itemst.class">
                            <!--  -->
                            <div v-if="itemst.array">
                              {{ data[index][itemst.name].length }}
                            </div>
                            <!--  -->

                            <!--  -->
                            <div v-else-if="itemst.date">
                              {{
                                formattedDate(
                                  data[index][itemst.name],
                                  itemst.name,
                                )
                              }}
                            </div>
                            <!--  -->

                            <!--  -->
                            <div v-else-if="itemst.history">
                              <span
                                :class="
                                  data[index]['status'] == 'in'
                                    ? 'text-primary-600'
                                    : 'text-red-600'
                                "
                              >
                                <span v-if="data[index]['status'] == 'in'">
                                  <i class="material-icons"
                                    >arrow_drop_up</i
                                  ></span
                                ><span v-else>
                                  <i class="material-icons"
                                    >arrow_drop_down</i
                                  ></span
                                >
                                {{ data[index][itemst.name] }}
                              </span>
                            </div>
                            <!--  -->

                            <!--  -->
                            <div v-else-if="itemst.type == 'checkbox'">
                              <label
                                class="text-lg text-teal-500 flex justify-center items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  :class="'rowCheckboxProduct-' + item._id"
                                  :typeshipp="item.type ? item.type : ''"
                                  :courier="item.courier ? item.courier : ''"
                                  :trackingNumber="item.trackingNumber || ''"
                                  :date="item.date || ''"
                                  :status="
                                    item.status
                                      ? item.status.name || item.status
                                      : ''
                                  "
                                  :orderObjet="
                                    config.name == 'shippings'
                                      ? item.order
                                        ? JSON.stringify(item.order)
                                        : ''
                                      : JSON.stringify(item)
                                  "
                                  :externalId="
                                    item.order
                                      ? item.order.externalId || ''
                                      : item.externalId
                                  "
                                  :order="item.order ? item.order._id : ''"
                                  :seller="
                                    item.seller && item.seller.source
                                      ? item.seller.source
                                      : item.seller.company || 'nosource'
                                  "
                                  :id="item._id"
                                  @click="getRowDetail(item, item._id)"
                                  class="form-checkbox rowCheckbox focus:outline-none focus:shadow-outline"
                                />
                              </label>
                            </div>
                            <!--  -->

                            <!--  -->
                            <div v-else>
                              <!--  -->
                              <div
                                v-if="
                                  itemst.name == 'country' ||
                                    itemst.name == 'country_to'
                                "
                              >
                                <img
                                  v-if="itemst.name == 'country'"
                                  :src="
                                    $f.getCountryCode(data[index][itemst.name])
                                  "
                                  class="h-4 w-5 blob inline-block mr-2"
                                  :alt="data[index][itemst.name]"
                                />
                                {{
                                  $f.getCountryNameByCode(
                                    dataCountry,
                                    data[index][itemst.name],
                                  )
                                }}
                              </div>
                              <!--  -->

                              <!--  -->
                              <div
                                v-else-if="
                                  itemst.name == 'address' ||
                                    itemst.name == 'name'
                                "
                                :class="
                                  itemst.name == 'name' &&
                                  config.name == 'warehouses' &&
                                  data[index]['parent']
                                    ? 'parent-warehouse'
                                    : ''
                                "
                              >
                                {{ exceptText(data[index][itemst.name]) }}
                              </div>
                              <!--  -->

                              <!--  -->
                              <div v-else>
                                <!--  -->
                                <div v-if="itemst.arrayD" class="text-center">
                                  <!--  -->
                                  <span
                                    v-if="
                                      itemst.name != 'outOfStock' &&
                                        itemst.name != 'stock' &&
                                        itemst.name != 'upsells'
                                    "
                                    class="bg-primary-200 text-primary-600 py-1 px-3 rounded-full text-xs"
                                  >
                                    Total:
                                    {{
                                      data[index][itemst.name]
                                        ? data[index][itemst.name]
                                        : 0
                                    }}
                                  </span>
                                  <!--  -->

                                  <!--  -->
                                  <div
                                    v-for="(wharhouse, i) in data[index][
                                      itemst.arrayD
                                    ].filter(
                                      item =>
                                        (idWharhouse &&
                                          item.warehouse &&
                                          item.warehouse.country ==
                                            idWharhouse.country &&
                                          currentUser.type != 'Seller') ||
                                        (item.warehouse &&
                                          item.warehouse.country ===
                                            idWharhouse.country &&
                                          item.warehouse.is_primary &&
                                          currentUser.type == 'Seller'),
                                    )"
                                    :key="i"
                                    :class="
                                      data[index][itemst.arrayD].filter(
                                        item =>
                                          item.warehouse &&
                                          item.warehouse.country ==
                                            idWharhouse.country,
                                      ).length > 1 &&
                                      data[index][itemst.arrayD].filter(
                                        item =>
                                          item.warehouse &&
                                          item.warehouse.country ==
                                            idWharhouse.country,
                                      ).length -
                                        1 !=
                                        i &&
                                      itemst.name != 'outOfStock' &&
                                      itemst.name != 'stock'
                                        ? 'border-b border-gray-600 border-dashed'
                                        : ''
                                    "
                                    class="flex justify-center items-center py-1"
                                  >
                                    <!--  -->
                                    <span
                                      v-if="itemst.name == 'outOfStock'"
                                      :class="
                                        i == 0 &&
                                        data[index][itemst.arrayD].filter(
                                          item =>
                                            item.warehouse &&
                                            item.warehouse.country ===
                                              idWharhouse.country,
                                        ).length > 1
                                          ? 'mttt-18'
                                          : ''
                                      "
                                    >
                                      <span
                                        v-if="wharhouse.warehouse.is_primary"
                                        :class="
                                          wharhouse.outOfStock
                                            ? 'status-inactive'
                                            : 'status-active'
                                        "
                                        class="statusP"
                                      >
                                        <span>{{
                                          wharhouse.outOfStock
                                            ? 'Inactive'
                                            : 'Active'
                                        }}</span>
                                      </span>
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span
                                      v-else-if="itemst.name == 'stock'"
                                      :class="
                                        i == 0 &&
                                        data[index][itemst.arrayD].filter(
                                          item =>
                                            item.warehouse &&
                                            item.warehouse.country ===
                                              idWharhouse.country,
                                        ).length > 1
                                          ? 'mttt-18'
                                          : ''
                                      "
                                    >
                                      <span
                                        v-if="wharhouse.warehouse.is_primary"
                                        :class="
                                          checkDataStock(wharhouse) <= 0
                                            ? 'badge-light-danger'
                                            : 'badge-light-primary'
                                        "
                                        class=""
                                      >
                                        <span>
                                          {{
                                            checkDataStock(wharhouse) <= 0
                                              ? 'Out of Stock'
                                              : 'In Stock'
                                          }}
                                        </span>
                                      </span>
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span v-else-if="itemst.name == 'upsells'">
                                      <span
                                        v-if="wharhouse.warehouse.is_primary"
                                        class="statusP"
                                      >
                                        <span
                                          style="background-color:#fce7e7;color:rgba(237,94,94,1);padding:0.35em 0.65em;font-size:0.75em;font-weight:500"
                                          v-if="
                                            !wharhouse.upsells ||
                                              (wharhouse.upsells &&
                                                wharhouse.upsells.length === 0)
                                          "
                                          >Non utilisé</span
                                        >
                                        <svg
                                          class="fill-current text-green-600"
                                          v-else
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z"
                                          />
                                        </svg>
                                      </span>
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <template v-else>
                                      <template>
                                        <button
                                          v-if="
                                            checkDataByType(
                                              'variantes',
                                              data[index][itemst.arrayD],
                                            )
                                          "
                                          @click="showProductsVariantes(index)"
                                          :class="$colors.newColor"
                                          class="bg-gray-100 hover:bg-primary-100 hover:text-white rounded-full flex items-center text-2xl focus:outline-none p-1 ml-1"
                                        >
                                          <i
                                            class="material-icons"
                                            style="transition: 0.3s"
                                            :style="
                                              showVar &&
                                              showVar.toString() ==
                                                data[index]['_id'].toString()
                                                ? 'transform: rotate(180deg)'
                                                : ''
                                            "
                                            >keyboard_arrow_down</i
                                          >
                                        </button>
                                        <svg
                                          v-if="wharhouse.warehouse.is_primary"
                                          class="fill-current mr-2"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"
                                          />
                                        </svg>
                                        <img
                                          class="w-4 h-4 rounded-full"
                                          :src="wharhouse.flag"
                                        />
                                      </template>
                                      <div class="pl-1 flex">
                                        {{
                                          checkDataByType(
                                            'variantes',
                                            data[index][itemst.arrayD],
                                          )
                                            ? checkDataByType(
                                                'variantes',
                                                data[index][itemst.arrayD],
                                              ).reduce(
                                                (n, { quantity }) =>
                                                  n +
                                                  parseInt(
                                                    quantity[itemst.name],
                                                  ),
                                                0,
                                              ) +
                                              wharhouse.quantity[itemst.name]
                                            : wharhouse.quantity[itemst.name]
                                        }}
                                        <span
                                          class="mx-1 px-1 ware-name"
                                          v-if="wharhouse.warehouse.parent"
                                          >({{
                                            wharhouse.warehouse.name
                                          }})</span
                                        >
                                      </div>
                                    </template>
                                    <!--  -->
                                  </div>

                                  <!--  -->
                                  <template
                                    v-if="
                                      checkDataByType(
                                        'variantes',
                                        data[index][itemst.arrayD],
                                      ) &&
                                        [
                                          'inStock',
                                          'total',
                                          'defective',
                                        ].includes(itemst.name)
                                    "
                                  >
                                    <div
                                      v-if="
                                        showVar &&
                                          showVar.toString() ===
                                            data[index]['_id'].toString()
                                      "
                                      v-for="(variante, j) in checkDataByType(
                                        'variantes',
                                        data[index][itemst.arrayD],
                                      )"
                                      :key="'variante-' + j"
                                      class="flex justify-center items-center"
                                    >
                                      <div class="pl-1 flex">
                                        {{ variante.quantity[itemst.name] }}
                                        <span class="mx-1 px-1 ware-name"
                                          >({{ variante.name }})</span
                                        >
                                      </div>
                                    </div>
                                  </template>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div
                                  :class="
                                    itemst.name == 'id' ||
                                    itemst.name == 'order_id'
                                      ? 'normal-case'
                                      : ''
                                  "
                                  v-else
                                >
                                  <!--  -->
                                  <span
                                    v-if="
                                      itemst.name === 'is_primary' ||
                                        itemst.name === 'is_paid'
                                    "
                                  >
                                    <!--  -->
                                    <svg
                                      v-if="
                                        data[index][itemst.name] &&
                                          itemst.name === 'is_primary'
                                      "
                                      class="fill-current"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="15"
                                      height="15"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        d="M10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591zm5.959-17v2h-8v-2h8zm0 24v-2h-8v2h8zm2-22h4v4h2v-6h-6v2zm-18 14h2v-8h-2v8zm2-10v-4h4v-2h-6v6h2zm22 2h-2v8h2v-8zm-2 10v4h-4v2h6v-6h-2zm-16 4h-4v-4h-2v6h6v-2z"
                                      />
                                    </svg>
                                    <!--  -->

                                    <!--  -->
                                    <span
                                      v-if="
                                        itemst.name === 'is_paid' &&
                                          (data[index]['status'] == 'paid' ||
                                            data[index]['status'] ==
                                              'processed')
                                      "
                                      class="font-bold"
                                    >
                                      <span
                                        v-if="data[index][itemst.name]"
                                        class="text-primary-500"
                                      >
                                        <svg
                                          class="inline-block fill-current"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            d="M0 11.386l1.17-1.206c1.951.522 5.313 1.731 8.33 3.597 3.175-4.177 9.582-9.398 13.456-11.777l1.044 1.073-14 18.927-10-10.614z"
                                          />
                                        </svg>
                                        Invoiced
                                      </span>
                                      <span v-else> Not invoiced</span>
                                    </span>
                                    <!--  -->
                                  </span>
                                  <!--  -->

                                  <!--  -->
                                  <span v-else>
                                    <!--  -->
                                    <span
                                      v-if="
                                        itemst.name === 'oldObject' ||
                                          itemst.name === 'newObject'
                                      "
                                    >
                                      <!--  -->
                                      <span
                                        v-if="
                                          data[index][itemst.name] &&
                                            data[index][itemst.name].settings &&
                                            data[index][itemst.name].settings
                                              .length
                                        "
                                      >
                                        <!--  -->
                                        <div
                                          v-for="(setting, i) in data[index][
                                            itemst.name
                                          ].settings"
                                          :key="i"
                                          class="flex flex-col lg:flex-row mb-2 items-center"
                                        >
                                          <!--  -->
                                          <img
                                            :src="setting.flag"
                                            class="w-4 h-4 rounded-full mr-2"
                                          />
                                          <!--  -->

                                          <!--  -->
                                          <div
                                            id="confirmation"
                                            style="transform: inherit"
                                            :class="
                                              setting.confirmation
                                                ? 'active'
                                                : ''
                                            "
                                            class="intro-y mr-1 flex-1 box-1 py-1"
                                          >
                                            <div
                                              class="text-smmm font-medium text-center"
                                            >
                                              Confirmation
                                            </div>
                                          </div>
                                          <!--  -->

                                          <!--  -->
                                          <div
                                            style="transform: inherit"
                                            id="Warehouse"
                                            :class="
                                              setting.fulfillement
                                                ? 'active'
                                                : ''
                                            "
                                            class="intro-y mr-1 flex-1 box-1 py-1"
                                          >
                                            <div
                                              class="text-smmm font-medium text-center"
                                            >
                                              Warehouse
                                            </div>
                                          </div>
                                          <!--  -->

                                          <!--  -->
                                          <div
                                            id="Shipping"
                                            style="transform: inherit"
                                            :class="
                                              setting.shipping ? 'active' : ''
                                            "
                                            class="intro-y flex-1 box-1 py-1"
                                          >
                                            <div
                                              class="text-smmm font-medium text-center"
                                            >
                                              Shipping
                                            </div>
                                          </div>
                                          <!--  -->
                                        </div>
                                        <!--  -->
                                      </span>
                                      <!--  -->

                                      <!--  -->
                                      <span
                                        v-else-if="
                                          data[index][itemst.name] &&
                                            data[index][itemst.name]
                                              .countries &&
                                            data[index][itemst.name].countries
                                              .length
                                        "
                                        class="flex"
                                      >
                                        <span
                                          v-for="(images, r) in data[index][
                                            itemst.name
                                          ].countries"
                                          :key="r"
                                        >
                                          <img
                                            :src="
                                              'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +
                                                images.toLowerCase() +
                                                '.svg'
                                            "
                                            class="w-4 h-4 rounded-full mr-2"
                                          />
                                        </span>
                                      </span>
                                      <!--  -->

                                      <!--  -->
                                      <span
                                        v-else-if="
                                          data[index][itemst.name] &&
                                            data[index][itemst.name]
                                              .permissions &&
                                            data[index][itemst.name].permissions
                                              .length
                                        "
                                      >
                                        <!--  -->
                                        <table class="table w-full text-center">
                                          <!--  -->
                                          <thead class="bg-gray-100 text-black">
                                            <tr>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Model
                                              </th>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Create
                                              </th>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Watch
                                              </th>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Read
                                              </th>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Update
                                              </th>
                                              <th
                                                class="px-1 py-1 border-gray-200 text-left text-smmm font-medium text-gray-700 capitalize tracking-wider"
                                              >
                                                Delete
                                              </th>
                                            </tr>
                                          </thead>
                                          <!--  -->

                                          <!--  -->
                                          <tbody>
                                            <!--  -->
                                            <tr
                                              v-for="(el, mm) in data[index][
                                                itemst.name
                                              ].permissions"
                                              :key="mm"
                                              :class="
                                                mm % 2 == 0 ? 'bg-gray-100' : ''
                                              "
                                            >
                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-700 capitalize"
                                                  style="font-size: 11px"
                                                >
                                                  {{ el.model }}
                                                </p>
                                              </td>
                                              <!--  -->

                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-600 ml-3 text-semibold capitalize"
                                                >
                                                  <label
                                                    class="inline-flex text-sm items-center capitalize"
                                                  >
                                                    <input
                                                      v-model="el.access.create"
                                                      disabled
                                                      type="checkbox"
                                                      class="form-checkbox border-gray-500 h-4 w-4 text-primary-500"
                                                    />
                                                  </label>
                                                </p>
                                              </td>
                                              <!--  -->

                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-600 ml-3 text-semibold capitalize"
                                                >
                                                  <label
                                                    class="inline-flex text-sm items-center capitalize"
                                                  >
                                                    <input
                                                      v-model="el.access.watch"
                                                      type="checkbox"
                                                      disabled
                                                      class="form-checkbox border-gray-500 h-4 w-4 text-primary-500"
                                                    />
                                                  </label>
                                                </p>
                                              </td>
                                              <!--  -->

                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-600 ml-2 text-semibold capitalize"
                                                >
                                                  <label
                                                    class="inline-flex text-sm items-center capitalize"
                                                  >
                                                    <input
                                                      v-model="el.access.read"
                                                      type="checkbox"
                                                      disabled
                                                      class="form-checkbox border-gray-500 h-4 w-4 text-primary-500"
                                                    />
                                                  </label>
                                                </p>
                                              </td>
                                              <!--  -->

                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-600 ml-3 text-semibold capitalize"
                                                >
                                                  <label
                                                    class="inline-flex text-sm items-center capitalize"
                                                  >
                                                    <input
                                                      v-model="el.access.update"
                                                      type="checkbox"
                                                      disabled
                                                      class="form-checkbox border-gray-500 h-4 w-4 text-primary-500"
                                                    />
                                                  </label>
                                                </p>
                                              </td>
                                              <!--  -->

                                              <!--  -->
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-600 ml-3 text-semibold capitalize"
                                                >
                                                  <label
                                                    class="inline-flex text-sm items-center capitalize"
                                                  >
                                                    <input
                                                      v-model="el.access.delete"
                                                      type="checkbox"
                                                      disabled
                                                      class="form-checkbox border-gray-500 h-4 w-4 text-primary-500"
                                                    />
                                                  </label>
                                                </p>
                                              </td>
                                              <!--  -->
                                            </tr>
                                          </tbody>
                                          <!--  -->
                                        </table>
                                        <!--  -->
                                      </span>
                                      <!--  -->

                                      <!--  -->
                                      <span
                                        v-else-if="
                                          data[index][itemst.name] &&
                                            data[index][itemst.name].details &&
                                            data[index][itemst.name].details
                                              .length
                                        "
                                      >
                                        <table class="table w-full text-center">
                                          <!--  -->
                                          <thead class="bg-gray-100 text-white">
                                            <tr
                                              class="bg-primary-400 text-smmm font-medium flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0"
                                            >
                                              <th class="text-left">
                                                Products
                                              </th>
                                              <th class="text-left">
                                                Quantity
                                              </th>
                                              <th class="text-left">Total</th>
                                            </tr>
                                          </thead>
                                          <!--  -->

                                          <!--  -->
                                          <tbody>
                                            <tr
                                              v-for="(el, mm) in data[index][
                                                itemst.name
                                              ].details"
                                              :key="mm"
                                              :class="
                                                mm % 2 == 0 ? 'bg-gray-100' : ''
                                              "
                                            >
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-700 capitalize"
                                                  style="font-size: 11px"
                                                >
                                                  {{ el.product }}
                                                </p>
                                              </td>
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-700 capitalize"
                                                  style="font-size: 11px"
                                                >
                                                  {{ el.quantity }}
                                                </p>
                                              </td>
                                              <td
                                                class="px-1 py-1 pt-1 text-left border-gray-200 bg-white text-sm"
                                              >
                                                <p
                                                  class="text-gray-700 capitalize"
                                                  style="font-size: 11px"
                                                >
                                                  {{ el.unitPrice }}
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                          <!--  -->
                                        </table>
                                      </span>
                                      <!--  -->

                                      <!--  -->
                                      <span v-else>
                                        {{ data[index][itemst.name] }}
                                      </span>
                                      <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span v-else>
                                      <!--  -->
                                      <div v-if="itemst.name == 'totalPrice'">
                                        <div>
                                          {{
                                            data[index][itemst.name].toFixed(2)
                                          }}
                                        </div>
                                      </div>
                                      <!--  -->

                                      <!--  -->
                                      <div v-else>
                                        <!--  -->
                                        <router-link
                                          v-if="itemst.name === 'order_id'"
                                          :to="
                                            `/orders?name=${
                                              data[index][itemst.name]
                                            }`
                                          "
                                          class="hover:text-orange-500 hover:underline"
                                        >
                                          {{ data[index][itemst.name] }}
                                        </router-link>
                                        <!--  -->

                                        <!--  -->
                                        <span
                                          v-else-if="
                                            itemst.name === 'trackingNumber'
                                          "
                                          class="flex items-center justify-center"
                                        >
                                          <router-link
                                            v-if="config.name == 'orders'"
                                            :to="
                                              `/shippings?name=${
                                                data[index][itemst.name]
                                              }`
                                            "
                                            class="hover:text-orange-500 hover:underline"
                                          >
                                            {{ data[index][itemst.name] }}
                                          </router-link>
                                          <span v-else>{{
                                            data[index][itemst.name]
                                          }}</span>
                                        </span>
                                        <!--  -->

                                        <!--  -->
                                        <div
                                          v-else-if="itemst.name === 'source'"
                                        >
                                          <!--  -->
                                          <a
                                            v-if="
                                              data[index][itemst.name] &&
                                                data[index][
                                                  itemst.name
                                                ].startsWith('https')
                                            "
                                            :href="data[index][itemst.name]"
                                            target="_blank"
                                            class="flex items-center justify-center hover:text-orange-500 hover:underline"
                                            :title="data[index][itemst.name]"
                                          >
                                            <!--  -->
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24px"
                                              height="24px"
                                              viewBox="0 0 32 32"
                                              fill="none"
                                            >
                                              <!--  -->
                                              <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M22 3h7v7M27.5 4.5L20 12M17 5H8a3 3 0 00-3 3v16a3 3 0 003 3h16a3 3 0 003-3v-9"
                                              />
                                              <!--  -->
                                            </svg>
                                            <!--  -->
                                          </a>
                                          <!--  -->

                                          <!--  -->
                                          <span
                                            v-else-if="
                                              data[index][itemst.name] ===
                                                'STOREINO'
                                            "
                                            class="flex items-center justify-center"
                                          >
                                            <img
                                              class="h-8 w-fit object-fit"
                                              src="https://storeno.b-cdn.net/stores/9-2024/1727428835050.png"
                                            />
                                          </span>
                                          <!--  -->

                                          <!--  -->
                                          <span v-else>{{
                                            data[index][itemst.name]
                                          }}</span>
                                          <!--  -->
                                        </div>
                                        <!--  -->

                                        <!-- The Table Tree -->
                                        <div
                                          v-else
                                          v-html="data[index][itemst.name]"
                                        ></div>
                                        <!-- The Table Tree -->
                                      </div>
                                      <!--  -->

                                      <!--  -->
                                      <small
                                        class="font-bold"
                                        v-if="
                                          config.name == 'shippings' &&
                                            itemst.name === 'trackingNumber' &&
                                            data[index]['echangeTrack']
                                        "
                                      >
                                        <!--  -->
                                        <svg
                                          class="fill-current mr-1 inline"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                        >
                                          <!--  -->
                                          <path
                                            d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5 20l-1.359-2.038c-1.061.653-2.305 1.038-3.641 1.038-3.859 0-7-3.14-7-7h2c0 2.757 2.243 5 5 5 .927 0 1.786-.264 2.527-.708l-1.527-2.292h5.719l-1.719 6zm0-8c0-2.757-2.243-5-5-5-.927 0-1.786.264-2.527.708l1.527 2.292h-5.719l1.719-6 1.359 2.038c1.061-.653 2.305-1.038 3.641-1.038 3.859 0 7 3.14 7 7h-2z"
                                          />
                                          <!--  -->
                                        </svg>
                                        <!--  -->
                                        {{ data[index]['echangeTrack'] }}
                                      </small>
                                      <!--  -->
                                    </span>
                                    <!--  -->
                                  </span>
                                  <!--  -->

                                  <!--  -->
                                  <sup
                                    class="text-black uppercase"
                                    v-if="
                                      itemst.name == 'totalPrice' ||
                                        (itemst.name == 'amount' &&
                                          config.name == 'payments')
                                    "
                                  >
                                    {{ currency }}
                                  </sup>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else>
                          <!--  -->
                          <div
                            v-for="(ele, itemelem) in itemst.elements"
                            :key="itemelem"
                          >
                            <!--  -->
                            <div v-for="(refit, ind) in ele.items" :key="ind">
                              <!--  -->
                              <div :class="refit.class">
                                <!--  -->
                                <div v-if="refit.name == 'picture'">
                                  <!--  -->
                                  <img
                                    :src="
                                      data[index][itemst.name][refit.name] ||
                                        'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                    "
                                    class="h-12 w-12"
                                  />
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div v-else>
                                  <!--  -->
                                  <div
                                    class="flex flex-col"
                                    v-if="
                                      refit.name == 'city' &&
                                        config.name == 'shippings'
                                    "
                                  >
                                    <!--  -->
                                    <div class="flex items-center gap-2">
                                      <!--  -->
                                      <i
                                        v-if="refit.icone"
                                        class="material-icons tiny"
                                        >{{ refit.icone }}</i
                                      >
                                      <!--  -->

                                      <!--  -->
                                      <div
                                        v-if="
                                          (currentUser.type == 'CEO' ||
                                          currentUser.role.name == 'super admin') &&
                                          !data[index]['courier']
                                        "
                                        class="w-full border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded"
                                      >
                                        <p>
                                          <!-- -->
                                          <v-select
                                            @input="
                                              city =>
                                                setSelectedCity(
                                                  data[index][itemst.name][
                                                    '_id'
                                                  ],
                                                  city,
                                                )
                                            "
                                            v-model="
                                              data[index][itemst.name][
                                                'customer'
                                              ][refit.name]
                                            "
                                            :options="cities"
                                          >
                                          </v-select>
                                          <!--  -->
                                        </p>
                                        <!--  -->
                                      </div>
                                      <!--  -->

                                      <!--  -->
                                      <span
                                        class="flex items-center gap-2"
                                        v-else
                                      >
                                        {{
                                          data[index][itemst.name]['customer'][
                                            refit.name
                                          ]
                                        }}
                                      </span>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->

                                  <!--  -->
                                  <span v-else>
                                    <!--  -->
                                    <span
                                      v-if="
                                        data[index][itemst.name] &&
                                          !isEmpty(
                                            data[index][itemst.name][
                                              refit.name
                                            ],
                                          )
                                      "
                                    >
                                      <!--  -->
                                      <span
                                        :class="
                                          refit.icone &&
                                          refit.icone === 'warning'
                                            ? 'c-warning'
                                            : ''
                                        "
                                      >
                                        <!--  -->
                                        <i
                                          v-if="refit.icone"
                                          class="material-icons tiny pr-1"
                                          >{{ refit.icone }}</i
                                        >
                                        <!--  -->
                                        <span
                                          v-if="refit.name == 'shippingAddress'"
                                          >{{
                                            exceptText(
                                              data[index][itemst.name][
                                                refit.name
                                              ],
                                            )
                                          }}</span
                                        >
                                        <!--  -->
                                        <span v-else>{{
                                          data[index][itemst.name][refit.name]
                                        }}</span>
                                        <!--  -->
                                      </span>
                                      <!--  -->
                                    </span>
                                    <!--  -->

                                    <!--  -->
                                    <span v-else>
                                      <!--  -->
                                      <span v-if="refit.name == 'city'">
                                        <!--  -->
                                        <div
                                          id="alert-4"
                                          class="flex items-center justify-center p-2 bg-yellow-300 rounded-lg dark:bg-yellow-500"
                                          role="alert"
                                        >
                                          <!--  -->
                                          <svg
                                            aria-hidden="true"
                                            class="flex-shrink-0 w-5 h-5 text-yellow-700 dark:text-yellow-800"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <!--  -->
                                            <path
                                              fill-rule="evenodd"
                                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                              clip-rule="evenodd"
                                            ></path>
                                            <!--  -->
                                          </svg>
                                          <!--  -->

                                          <!--  -->
                                          <span class="sr-only">Info</span>
                                          <!--  -->

                                          <!--  -->
                                          <div
                                            class="ml-3 text-sm font-medium text-yellow-700 dark:text-yellow-800"
                                            style="font-size: 12px"
                                          >
                                            NOT DEFINED
                                          </div>
                                          <!--  -->
                                        </div>
                                        <!--  -->
                                      </span>
                                      <!--  -->
                                    </span>
                                    <!--  -->
                                  </span>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->

                            <!--  -->
                            <span
                              v-if="
                                ['orders', 'shippings'].includes(config.name) &&
                                  itemst.name &&
                                  itemst.name.toLowerCase() === 'seller' &&
                                  data[index]['seller'] &&
                                  data[index]['seller']._id.toString() ===
                                    '64d60cfc05f818068c8f4750'
                              "
                            >
                              <!--  -->
                              {{
                                config.name === 'orders'
                                  ? data[index]['ThirdParty']
                                  : data[index]['orderObjet'].ThirdParty
                              }}
                              <!--  -->
                            </span>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div
                      v-if="
                        (col.model && col.model == 'expedition') ||
                          (col.model && col.model == 'internalexpeditions') ||
                          (col.model && col.model == 'order') ||
                          (col.model && col.model == 'payments') ||
                          (col.model && col.model == 'shippings')
                      "
                    >
                      <!--  -->
                      <div class="flex">
                        <!--  -->
                        <div
                          v-if="
                            (col.model && col.model == 'expedition') ||
                              (col.model &&
                                col.model == 'internalexpeditions') ||
                              (col.model && col.model == 'payments')
                          "
                        >
                          <!--  -->
                          <p>
                            <!--  -->
                            <span class="font-semibold mr-1 text-primary-600">
                              <!--  -->
                              <span v-if="col.model == 'order'">{{
                                QuantityTotalProductOrderOnly(
                                  data[index][col.name],
                                )
                              }}</span>
                              <!--  -->
                              <span v-else>{{
                                data[index][col.name].length
                              }}</span>
                              <!--  -->
                            </span>
                            <!--  -->

                            <!--  -->
                            <b>{{ $t(col.title) }}</b>
                            <!--  -->
                          </p>
                          <!--  -->

                          <!--  -->
                          <span class="font-light text-gray-700">
                            {{
                              $moment(data[index]['date']).format('DD-MM-YYYY')
                            }}
                          </span>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else-if="col.model && col.model == 'order'">
                          <!--  -->
                          <p>
                            <!--  -->
                            <span class="font-bold mr-1 text-primary-600">
                              {{ data[index][col.name].length }} </span
                            >{{ $t('product')
                            }}{{ data[index][col.name].length > 1 ? 's' : '' }}
                            <!--  -->
                          </p>
                          <!--  -->
                          <span class="font-light text-gray-700"
                            >{{ $t('quantity') }}:
                          </span>
                          <!--  -->
                          <b>{{
                            QuantityTotalProductOrder(data[index][col.name])
                          }}</b>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else>
                          <!--shppings -->
                          <!--  -->
                          <p>
                            <!--  -->
                            <span class="font-bold mr-1 text-primary-600">
                              <!--  -->
                              {{ data[index].order.details.length }}
                              <!--  -->
                            </span>
                            <!--  -->
                            {{ $t('product')
                            }}{{
                              data[index].order.details.length > 1 ? 's' : ''
                            }}
                            <!--  -->
                          </p>
                          <!--  -->
                          <span class="font-light text-gray-700"
                            >{{ $t('quantity') }}: </span
                          ><b>{{
                            QuantityTotalProductOrder(data[index].order.details)
                          }}</b>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <button
                          v-if="config.sousTable"
                          @click="showSousTable(index)"
                          :class="$colors.newColor"
                          class="bg-gray-100 hover:bg-primary-100 hover:text-white rounded-full flex items-center text-2xl focus:outline-none p-1 ml-1"
                        >
                          <!--  -->
                          <i
                            class="material-icons"
                            style="transition: 0.3s"
                            :style="
                              element && element._id == item._id
                                ? 'transform: rotate(180deg)'
                                : ''
                            "
                            >keyboard_arrow_down</i
                          >
                          <!--  -->
                        </button>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </td>
                <!--  -->

                <!--  -->
                <td
                  v-if="
                    config.actions &&
                      config.actions.elements &&
                      config.actions.elements.length != 0
                  "
                  style="position: sticky; right: 0px; align-items: stretch;"
                  class="flex px-6 py-4 min-height-full whitespace-no-wrap border-b border-gray-200 sticky-table-body-right sticky-table-body-right-first"
                >                 
                 
                 <!-- messages button -->
                        <button v-if="config.name === 'orders' || config.name === 'shippings'"  @click="emitFunction('messages', data[index]['_id'], data[index])" class="relative loidingconfirm px-2" >
                                                      
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="text-orange-500 fill-current">
                            <path d="M12 0c-6.627 0-12 4.975-12 11.111 0 3.497 1.745 6.616 4.472 8.652v4.237l4.086-2.242c1.09.301 2.246.464 3.442.464 6.627 0 12-4.974 12-11.111 0-6.136-5.373-11.111-12-11.111zm1.193 14.963l-3.056-3.259-5.963 3.259 6.559-6.963 3.13 3.259 5.889-3.259-6.559 6.963z"></path></svg>
                            <!--  -->
                           
                            <span v-if="config.name === 'orders' && ordersWithUnreadMessages.includes(data[index]['_id'])"
                                  class="absolute top-0 w-2 h-2 bg-red-500 rounded-full animate-gentle-pulse"
                                  style="right:5.5px;">
                            </span>

                            <span v-if="config.name === 'shippings' && ordersWithUnreadMessages.includes(data[index]['_id'])"
                                  class="absolute top-0 w-2 h-2 bg-red-500 rounded-full animate-gentle-pulse"
                                  style="right:5.5px;">
                            </span>
                            <!--  -->
                          </button>
                  <!--  -->
                  <div class="w-full flex gap-2" :class="config.actions.class">
                    <!--  -->
                     
                    <div
                      v-for="(action, ind) in config.actions.elements"
                      :key="ind"
                    >

                      <!--  -->
                      <div
                        @click="
                          getAccess(
                            action.key,
                            data[index]['status'],
                            data[index]['type'],
                            action.role,
                          )
                        "
                        v-if="
                          getAccess(
                            action.key,
                            data[index]['status'],
                            data[index]['type'],
                            action.role,
                          ) && action.role
                        "
                        :class="$colors.actionTable"
                      >

                      
                        <!--  -->
                        <div
                          v-if="action.link"
                          class="flex items-center justify-center border-2 border-solid border-state-300 rounded-md p-1"
                        >
                        
                          <!--  -->
                          <router-link
                            :target="
                              config.name == 'statusHistories' ? '_blank' : ''
                            "
                            :to="
                              config.name == 'statusHistories'
                                ? {
                                    path: `${action.link}/${data[index]['order']['_id']}`,
                                  }
                                : {
                                    path: `${action.link}/${data[index]['_id']}`,
                                  }
                            "
                            class="flex items-center justify-center"
                          >
                            <!--  -->
                            <i class="material-icons" style="font-size: 17px;">
                              {{ action.icone }}
                            </i>
                            <!--  -->
                          </router-link>
                          <!--  -->
                        </div>
                        <!--  -->
                        <div v-else class="flex">



                          <!--  -->
                          <button
                            v-if="action.icone != 'refresh'"
                            @click="
                              emitFunction(
                                action.key,
                                data[index]['_id'],
                                data[index],
                              )
                            "
                            :class="config.actions.class"
                            class="flex items-center justify-center border-2 border-solid border-state-300 rounded-md p-1"
                          >
                            <!--  -->
                            <i
                              class="material-icons"
                              style="font-size: 17px;"
                              >{{ action.icone }}</i
                            >
                            <!--  -->
                          </button>
                          <!--  -->
                          <button
                            :disabled="oldData.loading"
                            v-if="
                              action.icone == 'refresh' &&
                                config.name == 'shippings' &&
                                !data[index].externalId &&
                                data[index].trackingNumber.indexOf('CRD') != -1
                            "
                            @click="
                              emitFunction(
                                action.icone,
                                data[index]['_id'],
                                data[index],
                              )
                            "
                            :class="config.actions.class"
                            class="flex items-center justify-center border-2 border-solid border-state-300 rounded-md p-1"
                          >
                            <!--  -->
                            <i
                              class="material-icons"
                              style="font-size: 17px;"
                              >{{ action.icone }}</i
                            >
                            <!--  -->
                          </button>
                          <!--  -->

                          

                          
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                    <GeneratePDFButton
                      v-if="config.name === 'expeditions'"
                      :expedition="data[index]"
                    />
                    
                    <!--  -->
                  </div>
                  <!--  -->
                </td>
                <!--  -->
              </tr>
              <!--  -->

              <!--  -->
              <tr
                v-if="
                  config.sousTable &&
                    element &&
                    element._id == data[index]['_id']
                "
              >
                <td :colspan="config.columns.length + 1" class="border">
                  <div class="w-full rounded-2xl">
                    <table
                      class="table w-full text-center"
                      :class="config.name == 'shippings' ? 'table-shipp' : ''"
                    >
                      <!--  -->
                      <thead class="bg-gray-100 text-black">
                        <tr>
                          <th
                            v-for="(col, ind) in config.columnsDialog.elements"
                            :key="ind"
                            class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t(col.name) }}
                          </th>
                        </tr>
                      </thead>
                      <!--  -->

                      <!--  -->
                      <tbody
                        v-if="
                          config.name == 'expeditions' ||
                            config.name == 'orders' ||
                            config.name == 'payments' ||
                            config.name == 'internalexpeditions'
                        "
                      >
                        <tr
                          v-for="(row, j) in element[
                            config.columnsDialog.details
                          ]"
                          :key="j"
                          class="bg-light-green-200"
                        >
                          <td
                            v-for="(col, ind) in config.columnsDialog.elements"
                            :key="ind"
                            class="text-xs leading-5 capitalize text-gray-900"
                          >
                            <div
                              v-for="(item, indeitem) in col.items"
                              :key="indeitem"
                            >
                              <div v-if="config.name == 'expeditions'">
                                <!-- Expedition sous table -->
                                <span v-if="col.attribut == 'product'">
                                  <div v-if="item.name == 'picture'">
                                    <img
                                      :src="
                                        [row.product][0][item.name] ||
                                          'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                      "
                                      class="w-8 h-8 object-contain my-2 rounded-md mx-auto"
                                    />
                                  </div>
                                  <div v-else>
                                    {{ [row.product][0][item.name] }}
                                  </div>
                                </span>

                                <span v-else>
                                  <div v-if="item.name == 'received'">
                                    <table class="min-w-full">
                                      <thead>
                                        <tr>
                                          <th
                                            class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                          >
                                            {{ $t('ok_good') }}
                                          </th>
                                          <th
                                            class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                          >
                                            {{ $t('defective') }}
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody class="bg-white">
                                        <tr class="bg-light-green-200">
                                          <td
                                            class="text-xs leading-5 capitalize text-gray-900"
                                          >
                                            {{ [row.quantity][0][item.name] }}
                                          </td>
                                          <td
                                            class="text-xs leading-5 capitalize text-gray-900"
                                          >
                                            {{ [row.quantity][0][item.name_1] }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <div v-else>
                                    <div
                                      v-if="item.name == 'merchandise_value'"
                                    >
                                      {{ [row][0][item.name] }}
                                      <sup class="text-black uppercase">
                                        {{ currency }}</sup
                                      >
                                    </div>
                                    <div v-else>
                                      {{ [row.quantity][0][item.name] }}
                                    </div>
                                  </div>
                                </span>
                              </div>

                              <div
                                v-else-if="config.name == 'internalexpeditions'"
                              >
                                <!-- internalexpeditions sous table -->
                                <span v-if="col.attribut == 'product'">
                                  <div v-if="item.name == 'picture'">
                                    <img
                                      :src="
                                        [row.product][0][item.name] ||
                                          'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                      "
                                      class="w-8 h-8 object-contain my-2 rounded-md mx-auto"
                                    />
                                  </div>

                                  <div v-else>
                                    <span
                                      v-if="
                                        item.name == 'name' &&
                                          idWharhouse &&
                                          idWharhouse._id
                                      "
                                    >
                                      <a
                                        class="text-orange-600"
                                        target="_blank"
                                        :href="
                                          `/products?name=${
                                            [row.product][0].id
                                          }&limit=10&details.warehouse=${
                                            idWharhouse._id
                                          }`
                                        "
                                      >
                                        {{ [row.product][0][item.name] }}
                                      </a>
                                    </span>
                                    <span v-else>
                                      {{ [row.product][0][item.name] }}
                                    </span>
                                  </div>
                                </span>

                                <span v-else>
                                  <table
                                    class="min-w-full border border-green-500"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          class="text-center bg-primary-500 px-6 py-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                        >
                                          {{ $t('warehouse') }}
                                        </th>
                                        <th
                                          class="text-center bg-primary-500 px-6 py-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                        >
                                          {{ $t('quantity_sent') }}
                                        </th>
                                        <th
                                          class="text-center bg-primary-500 px-6 py-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                        >
                                          {{ $t('quantity_received') }}
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody class="bg-white">
                                      <tr
                                        v-for="(ware, inddd) in row.warehouses"
                                        :key="inddd"
                                        class="bg-light-green-200"
                                      >
                                        <td
                                          class="text-xs leading-5 capitalize text-gray-900"
                                        >
                                          {{ ware.warehouse.name }}
                                        </td>

                                        <td
                                          class="text-xs leading-5 capitalize text-gray-900"
                                        >
                                          {{ ware.quantity.sent }}
                                        </td>

                                        <td
                                          class="text-xs leading-5 capitalize text-gray-900"
                                        >
                                          <table class="min-w-full">
                                            <thead>
                                              <tr>
                                                <th
                                                  class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                                >
                                                  {{ $t('ok_good') }}
                                                </th>
                                                <th
                                                  class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                                >
                                                  {{ $t('defective') }}
                                                </th>
                                              </tr>
                                            </thead>

                                            <tbody class="bg-white">
                                              <tr class="bg-light-green-200">
                                                <td
                                                  class="text-xs leading-5 capitalize text-gray-900"
                                                >
                                                  {{ ware.quantity.received }}
                                                </td>
                                                <td
                                                  class="text-xs leading-5 capitalize text-gray-900"
                                                >
                                                  {{ ware.quantity.defective }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </span>
                              </div>

                              <div v-else-if="config.name == 'orders'">
                                <!-- Order sous table -->
                                <div v-if="col.referent">
                                  <span v-if="col.referent == 'product'">
                                    <div v-if="item.name == 'picture'">
                                      <img
                                        :src="
                                          row.variante && row.variante.picture
                                            ? row.variante.picture
                                            : [row.product][0][item.name] ||
                                              'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                        "
                                        class="w-8 h-8 object-contain my-2 rounded-md mx-auto"
                                      />
                                    </div>

                                    <div v-else>
                                      <span
                                        v-if="
                                          item.name == 'name' &&
                                            idWharhouse &&
                                            idWharhouse._id
                                        "
                                      >
                                        <a
                                          class="text-orange-600"
                                          target="_blank"
                                          :href="
                                            `/products?name=${
                                              [row.product][0].id
                                            }&limit=10&details.warehouse=${
                                              idWharhouse._id
                                            }`
                                          "
                                          >{{ [row.product][0][item.name] }}
                                        </a>
                                        <template
                                          v-if="row.variante && row.variante.id"
                                          >(Variante:
                                          <b>{{ row.variante.name }}</b
                                          >)</template
                                        >
                                      </span>
                                      <span v-else>
                                        {{ [row.product][0][item.name] }}
                                      </span>
                                    </div>
                                  </span>

                                  <span v-else>{{
                                    [row.category][0][item.name]
                                  }}</span>
                                </div>

                                <div v-else>
                                  {{ [row][0][item.name] }}
                                  <sup
                                    class="text-black uppercase"
                                    v-if="item.name == 'unitPrice'"
                                    >{{ currency }}</sup
                                  >
                                </div>
                              </div>

                              <div v-else>
                                <!-- payament sous tabl -->
                                <div v-if="item.referent">
                                  <div v-if="item.field">
                                    {{
                                      row[item.referent][item.field][item.name]
                                    }}
                                  </div>

                                  <div v-else>
                                    {{ row[item.referent][item.name] }}
                                    <sup
                                      class="text-black uppercase"
                                      v-if="
                                        item.name == 'totalPrice' &&
                                          config.name == 'payments'
                                      "
                                      >{{ currency }}</sup
                                    >
                                  </div>
                                </div>

                                <div v-else>
                                  <div
                                    :class="
                                      (item.name == 'shipping_refund_vat' ||
                                        item.name == 'shipping_cancel_vat') &&
                                      row[item.name] == 0 &&
                                      config.name == 'payments'
                                        ? 'empty-row'
                                        : ''
                                    "
                                  >
                                    {{ row[item.name] }}
                                    <sup
                                      class="text-black uppercase"
                                      v-if="config.name == 'payments'"
                                      >{{ currency }}</sup
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>

                      <tbody v-else>
                        <!--Shipping sous table order info-->
                        <tr class="bg-light-green-200">
                          <!--  -->
                          <td
                            v-for="(col, ind) in config.columnsDialog.elements"
                            :key="ind"
                            class="text-xs leading-5 capitalize text-gray-900"
                          >
                            <!--  -->
                            <div
                              v-for="(item, indeitem) in col.items"
                              :key="indeitem"
                            >
                              <!--  -->
                              <div v-if="col.attribut">
                                <!--  -->
                                <div v-if="!item.elements">
                                  <span>{{
                                    data[index][col.referent][col.attribut][
                                      item.name
                                    ]
                                  }}</span>
                                </div>
                                <!--  -->

                                <!--  -->
                                <div v-else>
                                  <!-- Show two fields (Custumer) -->
                                  <div
                                    v-for="(ele, itemelem) in item.elements"
                                    :key="itemelem"
                                  >
                                    <!--  -->
                                    <div
                                      v-for="(refit, ind) in ele.items"
                                      :key="ind"
                                    >
                                      <!--  -->
                                      <div :class="ele.class">
                                        <!--  -->
                                        <div v-if="col.attribut != 'seller'">
                                          <i
                                            v-if="refit.icone"
                                            class="material-icons tiny"
                                            >{{ refit.icone }}</i
                                          >
                                          {{
                                            data[index][col.referent][
                                              col.attribut
                                            ][refit.name]
                                          }}
                                        </div>
                                        <!--  -->

                                        <!--  -->
                                        <div v-else>
                                          <span
                                            v-if="
                                              !isEmpty(
                                                data[index][
                                                  config.columnsDialog.details
                                                ][config.columnsDialog.name][0]
                                                  .product.seller[refit.name],
                                              )
                                            "
                                          >
                                            <i
                                              v-if="refit.icone"
                                              class="material-icons tiny"
                                              >{{ refit.icone }}</i
                                            >
                                            {{
                                              data[index][
                                                config.columnsDialog.details
                                              ][config.columnsDialog.name][0]
                                                .product.seller[refit.name]
                                            }}
                                          </span>
                                        </div>
                                        <!--  -->
                                      </div>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <div v-else>
                                {{ data[index][col.referent][item.name] }}
                                <sup
                                  class="text-black uppercase"
                                  v-if="item.name == 'totalPrice'"
                                  >{{ currency }}</sup
                                >
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </tbody>
                      <thead class="bg-gray-100 text-black">
                        <!--Shipping sous table product order info-->
                        <tr>
                          <th
                            v-for="(col, ind) in config.columnsDialog
                              .sousElements"
                            :key="ind"
                            class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t(col.name) }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(prod, k) in data[index][
                            config.columnsDialog.details
                          ][config.columnsDialog.name]"
                          :key="k"
                          class="bg-light-green-200"
                        >
                          <!-- Sous table products in order -->
                          <td
                            v-for="(col, ind) in config.columnsDialog
                              .sousElements"
                            :key="ind"
                            class="text-xs leading-5 capitalize text-gray-900"
                          >
                            <div
                              v-for="(item, indeitem) in col.items"
                              :key="indeitem"
                            >
                              <div v-if="col.referent">
                                <div v-if="item.name == 'picture'">
                                  <img
                                    :src="
                                      prod.variante && prod.variante.picture
                                        ? prod.variante.picture
                                        : prod[col.referent][item.name] ||
                                          'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                    "
                                    class="w-8 h-8 object-contain my-2 rounded-md mx-auto"
                                  />
                                </div>

                                <div v-else>
                                  <span
                                    v-if="
                                      item.name == 'name' &&
                                        idWharhouse &&
                                        idWharhouse._id
                                    "
                                  >
                                    <a
                                      class="text-orange-600"
                                      target="_blank"
                                      :href="
                                        `/products?name=${
                                          [prod.product][0].id
                                        }&limit=10&details.warehouse=${
                                          idWharhouse._id
                                        }`
                                      "
                                    >
                                      {{ [prod.product][0][item.name] }}
                                    </a>
                                    <template
                                      v-if="prod.variante && prod.variante.id"
                                    >
                                      (Variante: <b>{{ prod.variante.name }}</b
                                      >)
                                    </template>
                                  </span>
                                  <span v-else>
                                    {{ prod[col.referent][item.name] }}
                                  </span>
                                </div>
                              </div>

                              <div v-else>
                                <span>
                                  <span v-if="item.name == 'unitPrice'">
                                    {{ prod.unitPrice.toFixed(2) }}
                                    <sup class="text-black uppercase">
                                      {{ currency }}</sup
                                    >
                                  </span>
                                  <span v-else>{{ prod[item.name] }}</span>
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
              <!--  -->

              

              <!--  -->
              <vue-modal-2
                class="tab-datas"
                v-if="config.name == 'orders'"
                :name="'modal1_' + item._id"
                :headerOptions="{ title: $t('order_information') }"
                :noFooter="true"
                modalSize="xl"
              >
                <modal-info-order
                  :item="item"
                  :index="index"
                  :currency="currency"
                  :cities="cities"
                  @getFeesShippBycity="getFeesShippBycity"
                  :feesShipp="feesShipp"
                  :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist"
                  @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder"
                  :courier="courier"
                  :currentUser="currentUser"
                  @getCourierZone="getCourierZone"
                  @OrderChange="OrderChange"
                  :shipping="shipping"
                  :config="config"
                  :statusOrder="statusOrder"
                  :zones="zones"
                  :idWharhouse="idWharhouse"
                />
                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="closePopUpInformation(item._id, item)"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
                    :disabled="loadingcreateShipp"
                  >
                    <loading
                      :active.sync="loadingcreateShipp"
                      :is-full-page="fullPage"
                    ></loading
                    >Cancel
                  </button>
                  <button
                    @click="ConfirmOperationUpdate(item, item._id)"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
                    :disabled="loadingcreateShipp"
                  >
                    <loading
                      :active.sync="loadingcreateShipp"
                      :is-full-page="fullPage"
                    ></loading
                    >Confirm
                  </button>
                </div>
              </vue-modal-2>
              <!--  -->

                
                <!-- messages modal -->
                    <vue-modal-2 name="messages" :headerOptions="{ title: 'Info messages' }" :noFooter="true" modalSize="lg"
                      @on-close="closePopup('messages')">
                      <div class="bg-white rounded-lg p-2">
                        <!--  -->
                        <div v-if="!messagesInfo.previous" class="rounded-lg">
                          <!--  -->
                          <!-- <span v-if="messagesInfo.messages.length > 0">
                            <p v-for="(msg, ll) in messagesInfo.messages" :key="ll" class="Note mx-2">
                              <strong>Note</strong>: {{ msg }}
                            </p>
                          </span> -->
                          <!--  -->

                          <!--  -->
                          <!-- <div v-if="messagesInfo.info.length > 0" class="overflow-x-auto w-full px-4">
                            <table class="table w-full table-messages">
                              <thead>
                                <tr class="bg-gray-700 dark:bg-dark-1 text-white text-left">
                                  <th class="whitespace-nowrap p-2">Warehouse</th>
                                  <th class="whitespace-nowrap p-2">Product</th>
                                  <th class="whitespace-nowrap p-2">Quantity {{ messagesInfo.status == 'paid' ? 'Total' : 'in Stock'
                                    }}</th>
                                  <th class="whitespace-nowrap p-2">NB orders</th>
                                  <th class="whitespace-nowrap p-2">NB quantity orders</th>
                                  <th class="whitespace-nowrap p-2">Info</th>
                                  <th class="whitespace-nowrap p-2">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in messagesInfo.info" :key="index" :class="'bg-' + item.type">
                                  <td class="border-b dark:border-dark-5 p-2">{{ item.warehouse }}</td>
                                  <td class="border-b dark:border-dark-5 p-2">{{ item.productName }}</td>
                                  <td class="border-b dark:border-dark-5 p-2">{{ item.inStock }}</td>
                                  <td class="border-b dark:border-dark-5 p-2">{{ item.count }}</td>
                                  <td class="border-b dark:border-dark-5 p-2">{{ item.qte }}</td>
                                  <td class="border-b p-2 dark:border-dark-5" :class="item.type">{{ item.text }}</td>
                                  <td class="border-b p-2 dark:border-dark-5" :class="item.type">{{ item.type }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div> -->
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div v-else style="overflow-x: auto;">
                          <table v-for="(msg, ll) in messagesInfo.messages" :key="ll" class="min-w-full w-full">
                            <div
                              v-if="msg.datas.filter(function (item) { return item.status && item.status === 'delivered' }).length > 0"
                              class="w-full border-gray-200" style="display: table-caption;">
                              <div role="alert"
                                class="w-full bg-green-100 border-t-4 border-green-600 rounded-b text-teal-darkest px-4 py-3 shadow-md">
                                <div class="flex justify-center"><i class="large material-icons mr-5">account_balance_wallet</i>
                                  <div>
                                    <p class="font-bold">Total Orders Delivered: <span>{{ msg.datas.filter(function (item) {
                                      return
                                      item.status && item.status === 'delivered'
                                    }).length }}</span></p>
                                    <p class="font-bold">Total: {{ msg.datas.filter(function (item) {
                                      return item.status && item.status
                                        ===
                                        'delivered' && item.totalPrice
                                    }).map(item => item.totalPrice).reduce((prev, next) => prev +
                                      next) }}
                                      <sup>{{ idWharhouse.currency }}</sup>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <caption style="background-color: #20827b; color: #fff; margin-bottom: 10px; text-transform: uppercase;">
                              {{
                                msg.module }} </caption>

                            <thead class="relative">
                              <tr v-if="msg.module == 'shippings'" class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Order id </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Traking number </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Old Status </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> status </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Message </span>
                                </th>
                                <th
                                  class="px-3 text-center py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Action </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> View </span>
                                </th>
                              </tr>
                              <tr v-if="msg.module == 'payments'" class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal">
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Payment id </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Old data </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> New data </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Message </span>
                                </th>
                                <th
                                  class="px-3 text-center py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> Action </span>
                                </th>
                                <th
                                  class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                                  <span> View </span>
                                </th>
                              </tr>
                            </thead>
                            <loading :active.sync="loadingdatashipp" :is-full-page="fullPage"></loading>
                            <tbody v-if="msg.module == 'shippings'">
                              <tr v-for="(item, index) in msg.datas" :key="index" class="border-b border-gray-200 hover:bg-gray-100">
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ item.orderId }}</div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ item.trackingNumber }}</div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900"><button
                                      class="border capitalize rounded-full text-gray-600  text-xs px-2 bg-white hover:border-gray-500 focus:outline-none appearance-none"
                                      :style="$f.ColorsStatusShippings(item.oldStatus) + ';font-size: 10px;line-height: 15px;'">{{
                                        item.oldStatus }}</button>
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900"><button
                                      class="border capitalize rounded-full text-gray-600  text-xs px-2 bg-white hover:border-gray-500 focus:outline-none appearance-none"
                                      :style="$f.ColorsStatusShippings(item.status) + ';font-size: 10px;line-height: 15px;'">{{
                                        item.status
                                      }}</button>
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div style="font-size: 10px;" class="text-xs leading-5 capitalize rounded-full text-gray-900">
                                    {{ item.text }}</div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900" :class="item.type">
                                    {{ item.type }}
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900"><router-link target="_blank"
                                      :to="{ path: `/shippings?name=${item.trackingNumber}&country=${idWharhouse.country}` }"><i
                                        class="material-icons"> remove_red_eye</i></router-link></div>
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-if="msg.module == 'payments'">
                              <tr v-for="(item, index) in msg.datas" :key="index" class="border-b border-gray-200 hover:bg-gray-100">
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ item.id }}</div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ item.oldCount }} orders
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900">{{ item.newCount }} orders
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div style="font-size: 10px;" class="text-xs leading-5 capitalize rounded-full text-gray-900">
                                    {{ item.text }}</div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div class="text-xs leading-5 capitalize rounded-full text-gray-900" :class="item.type">
                                    {{ item.type }}
                                  </div>
                                </td>
                                <td class="px-3 py-1 whitespace-no-wrap border-b border-gray-300">
                                  <div v-if="!item.isDeleted" class="text-xs leading-5 capitalize rounded-full text-gray-900">
                                    <router-link target="_blank" :to="{ path: `/payments/detail/${item._id}` }"><i
                                        class="material-icons">
                                        remove_red_eye</i></router-link>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="px-4 py-2 flex float-right space-x-4">
                          <a href="#" @click="closePopup('messages')"
                            class="px-10 py-2 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">OK</a>
                        </div>
                        <!--  -->
                      </div>
                    </vue-modal-2>
              <!--  -->


              <!--  -->
              <vue-modal-2
                class="tab-datas"
                v-if="config.name == 'expeditions'"
                :name="'modal1_' + index"
                :headerOptions="{ title: $t('expedition_information') }"
                :noFooter="true"
                modalSize="xl"
              >
                <modal-info-expo
                  :item="item"
                  :index="index"
                  :config="config"
                  :CheckExpeditionRecived="CheckExpeditionRecived"
                  @CheckQteSentExist="CheckQteSentExist"
                  :statusExpedition="statusExpedition"
                  :transports="transports"
                />
                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="closePopUpInformation(index, item)"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                    Cancel
                  </button>
                  <button
                    @click="ConfirmOperationUpdate(item, index)"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative"
                    :class="loadingcreateShipp ? 'noselect' : ''"
                  >
                    <loading
                      :active.sync="loadingcreateShipp"
                      :is-full-page="fullPage"
                    ></loading
                    >Confirm
                  </button>
                </div>
              </vue-modal-2>

              <!--  -->
              <vue-modal-2
                class="tab-datas"
                v-if="config.name == 'internalexpeditions'"
                :name="'modal1_' + index"
                :headerOptions="{ title: $t('expedition_information') }"
                :noFooter="true"
                modalSize="xl"
              >
                <modal-info-internalexpo
                  :item="item"
                  :index="index"
                  :config="config"
                  :CheckExpeditionRecived="CheckExpeditionRecived"
                  @CheckQteSentExist="CheckQteSentExist"
                  :statusExpedition="statusExpedition"
                />
                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="closePopUpInformation(index, item)"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                    Cancel
                  </button>
                  <button
                    @click="ConfirmOperationUpdate(item, index)"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative"
                    :class="loadingcreateShipp ? 'noselect' : ''"
                  >
                    <loading
                      :active.sync="loadingcreateShipp"
                      :is-full-page="fullPage"
                    ></loading
                    >Confirm
                  </button>
                </div>
              </vue-modal-2>
              <!--  -->

              <!--  -->
              <vue-modal-2
                class="tab-datas"
                v-if="config.name == 'shippings'"
                :name="'modal1_' + index"
                :headerOptions="{ title: $t('shipping_informations') }"
                :noFooter="true"
                modalSize="xl"
              >
                <modal-info-shipp
                  :item="item"
                  :index="index"
                  :dataCountry="dataCountry"
                  :feesShipp="feesShipp"
                  :paidtatus="paidtatus"
                  :currency="currency"
                  :couriers="couriers"
                  @searchCouriers="searchCouriers"
                  :currentUser="currentUser"
                  :config="config"
                  @OpenClosePopupModalReporte="OpenClosePopupModalReporte"
                  :CheckQteDefecteuseexist="CheckQteDefecteuseexist"
                  :CheckQteReturnedexist="CheckQteReturnedexist"
                  @CheckQteDefecteuse="CheckQteDefecteuse"
                  @CheckQteReturned="CheckQteReturned"
                  :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist"
                  @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder"
                  :zones="zones"
                  :statusShipp="statusShipp"
                  :typesShipp="typesShipp"
                  :idWharhouse="idWharhouse"
                />
                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="closePopUpInformation(index, item)"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                    Cancel
                  </button>
                  <button
                    @click="ConfirmOperationUpdate(item, index)"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative"
                    :class="loadingcreateShipp ? 'noselect' : ''"
                  >
                    <loading
                      :active.sync="loadingcreateShipp"
                      :is-full-page="fullPage"
                    ></loading
                    >Confirm
                  </button>
                </div>
              </vue-modal-2>
              <!--  -->

              <!--  -->
              <vue-modal-2
                v-if="config.name == 'shippings'"
                class="printing"
                name="print-shippings-delivry"
                :headerOptions="{ title: $t('shipping_informations') }"
                :noFooter="true"
                modalSize="xl"
              >
                <modal-info-shipp-print
                  :item="item"
                  :currency="currency"
                  :index="index"
                  :idWharhouse="idWharhouse"
                  :feesShipp="feesShipp"
                  :config="config"
                />
              </vue-modal-2>
              <!--  -->
            </tbody>
            <!--  -->
          </table>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div
          v-if="!data || data.length <= 0"
          class="bg-primary-100 py-8 relative"
        >
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <span
            class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base"
          >
            <p class="font-semibold flex text-primary-500 whitespace-no-wrap">
              <i class="material-icons mx-3">error</i>
              <span v-if="loading">
                Loading Data ...
                <svg
                  version="1.1"
                  viewBox="0 0 64 64"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                  id="spinner22"
                >
                  <circle
                    class="path-gradient"
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke="url(#sGD)"
                    stroke-width="8"
                  ></circle>
                  <path
                    class="path-solid"
                    d="M 32,4 A 28 28,0,0,0,32,60"
                    fill="none"
                    stroke="#000"
                    stroke-width="8"
                    stroke-linecap="round"
                  ></path>
                  <defs>
                    <linearGradient
                      id="sGD"
                      gradientUnits="userSpaceOnUse"
                      x1="32"
                      y1="0"
                      x2="32"
                      y2="64"
                    >
                      <stop
                        stop-color="#000"
                        offset="0.1"
                        stop-opacity="0"
                        class="stop1"
                      ></stop>
                      <stop
                        stop-color="#000"
                        offset=".9"
                        stop-opacity="1"
                        class="stop2"
                      ></stop>
                    </linearGradient>
                  </defs>
                  <animateTransform
                    values="0,0,0;360,0,0"
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="750ms"
                  ></animateTransform>
                  --&gt;
                </svg>
              </span>
              <span v-else> No {{ config.name }} Found </span>
            </p>
          </span>
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="p-1" v-if="paginate.lastpage > 1">
        <div class="flex flex-col items-center my-12">
          <div-paginate :paginate="paginate" @paginatation="paginatation" />
        </div>
      </div>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'shippings' || config.name == 'orders'"
        class="modalreporteshipp"
        name="ModalReporteShipp"
        :headerOptions="{
          title:
            config.name == 'shippings'
              ? $t('postponed_shippings')
              : 'To rmind order',
        }"
        :noFooter="true"
        modalSize="lg"
        @on-close="OpenClosePopupModalReporte('close', 'postponed')"
      >
        <div class="w-full bg-white rounded-lg px-4 pt-2">
          <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full md:w-full px-3 mb-2 mt-2">
              <datetime-v2
                v-if="config.name == 'shippings'"
                :min-datetime="$moment(Date.now()).format('DD-MM-YYYY')"
                v-model="postponed.date"
                :placeholder="
                  config.name == 'shippings'
                    ? $t('postponed_date')
                    : 'Remind date'
                "
                input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
              ></datetime-v2>
              <datetime-v2
                v-else
                type="datetime"
                :min-datetime="$moment(Date.now()).format('DD-MM-YYYY')"
                v-model="postponed.date"
                :placeholder="
                  config.name == 'shippings'
                    ? $t('postponed_date')
                    : 'Remind date'
                "
                input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"
              ></datetime-v2>
            </div>
            <div class="w-full md:w-full px-3 mb-2 mt-2">
              <textarea
                class="bg-gray-100 rounded border border-gray-400 leading-normal resize-none w-full h-20 py-2 px-3 font-medium placeholder-gray-700 focus:outline-none focus:bg-white"
                v-model="postponed.comment"
                placeholder="Your Comment"
              ></textarea>
            </div>
            <div class="w-full md:w-full flex items-start px-3">
              <div class="-mr-1">
                <button
                  @click="ConfirmReporte('reporte')"
                  class="rounded flex focus:outline-none outline-none text-gray-100 px-3 w-fit md:w-1/7 py-2 bg-primary-500 hover:shadow-inner hover:bg-primary-700 transition-all duration-300 loidingconfirm relative"
                  :class="loadingcreateShipp ? 'noselect' : ''"
                >
                  <loading
                    :active.sync="loadingcreateShipp"
                    :is-full-page="fullPage"
                  ></loading
                  >Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="['shippings', 'orders'].includes(config.name)"
        name="ModalChangeStatus"
        :headerOptions="{ title: $t('change_status') }"
        :noFooter="true"
        modalSize="lg"
        @on-close="OpenClosePopupModal('close')"
      >
        <!--  -->
        <loading
          :active.sync="loadingChange"
          :is-full-page="fullPage"
        ></loading>
        <!--  -->
        <div class="bg-white rounded-lg">
          <!--  -->
          <div class="rounded-lg flex">
            <!--  -->
            <div class="w-1/5 flex justify-center items-center">
              <!--  -->
              <span
                class="w-16 h-16 bg-primary-600 text-white p-3 rounded-full"
              >
                <i class="material-icons" style="font-size: 40px"
                  >update</i
                ></span
              >
            </div>
            <!--  -->

            <!--  -->
            <div
              class="w-full pt-9 pr-4"
              :class="config.name == 'orders' ? 'mb-130' : ''"
            >
              <!--  -->
              <h3 class="font-bold text-primary-700 mb-8">
                {{ $t('change_status') }}
              </h3>
              <!--  -->

              <!--  -->
              <div
                class="mb-5 border hover:border-green-400 focus-within:border-green-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
              >
                <!--  -->
                <div
                  class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                >
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="status" class="bg-white text-gray-700 px-1">{{
                      $t('status')
                    }}</label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <p>
                  <!--  -->

                  <v-select
                    v-if="config.name == 'shippings'"
                    v-model="change_status.statusTochange"
                    :options="statusShippChange"
                  ></v-select>
                  <v-select
                    v-else
                    label="name"
                    v-model="change_status.statusTochange"
                    :options="statusShippChange"
                  ></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                v-if="config.name === 'shippings'"
                class="flex items-center mb-5 justify-between"
              >
                <!--  -->

                <!--  -->
                <span
                  class="w-1/5 border-b dark:border-gray-600 md:w-1/4"
                ></span>
                <!--  -->

                <!--  -->
                <span
                  @click="displayCourier()"
                  class="text-xs text-primary-600 font-bold cursor-pointer uppercase dark:text-orange-500 hover:underline"
                >
                  <i
                    class="material-icons mr-2"
                    style="vertical-align: sub; font-size: 15px"
                    >person_add</i
                  >
                  {{ $t('select_courier') }}
                </span>
                <!--  -->

                <!--  -->
                <span
                  class="w-1/5 border-b dark:border-gray-600 md:w-1/4"
                ></span>
                <!--  -->
              </div>
              <!--  -->

              <div
                v-if="showcourier && config.name === 'shippings'"
                class="border mb-2 h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
              >
                <div
                  class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                >
                  <p>
                    <label for="category" class="bg-white text-gray-700 px-1"
                      >{{ $t('courier') }}
                      <span :class="$colors.required">*</span></label
                    >
                  </p>
                </div>
                <p>
                  <v-select
                    label="fullName"
                    @search="searchCouriers($event, 'Courier')"
                    v-model="change_status.courier"
                    :options="couriers"
                  ></v-select>
                </p>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <ChangeStatusRoles v-if="config.name == 'shippings'" />
          <!--  -->

          <!--  -->
          <div class="p-4 modal-footer flex space-x-4">
            <!--  -->
            <a
              href="#"
              @click="OpenClosePopupModal('close')"
              class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm"
              >{{ $t('cancel') }}</a
            >
            <!--  -->
            <a
              href="#"
              @click="confirmChange"
              class="w-1/2 px-4 py-3 text-center text-primary-100 bg-primary-600 rounded-lg hover:bg-primary-700 hover:text-white font-bold text-sm"
              >{{ $t('confirm') }}</a
            >
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'shippings'"
        name="ModalChangeStatusByDauchette"
        :headerOptions="{
          title:
            $t('change_status') +
            ` (${newShipp.status} : ${newShipp.shippings.length} orders)`,
        }"
        :noFooter="true"
        modalSize="xl"
        @on-close="OpenClosePopupModal('close', 'dauchette')"
      >
        <div class="bg-white rounded-lg mb-20">
          <div class="border mb-2 px-3 mx-3 p-4 rounded-lg bg-white flex">
            <div class="w-1/5 flex justify-center items-center">
              <span
                class="w-16 h-16 bg-primary-600 text-white p-3 rounded-full"
              >
                <i class="material-icons" style="font-size: 40px">update</i>
              </span>
            </div>
            <div class="w-full pt-9 pr-4">
              <h3 class="font-bold text-primary-700 mb-6">
                {{ $t('change_status') }}
              </h3>
              <div
                class="mb-2 border hover:border-green-400 focus-within:border-green-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
              >
                <div
                  class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                >
                  <p>
                    <label for="status" class="bg-white text-gray-700 px-1">{{
                      $t('status')
                    }}</label>
                  </p>
                </div>
                <p>
                  <v-select
                    v-model="newShipp.status"
                    :options="statusShippChange"
                  ></v-select>
                </p>
              </div>
            </div>
          </div>
          <div v-if="newShipp.status" class="bg-white rounded-lg mb-14">
            <div
              class="flex flex-col border px-3 mx-3 p-4 rounded-lg bg-white border-green-400"
            >
              <div class="flex flex-row">
                <div class="flex w-full mb-5">
                  <input
                    id="inputshipping"
                    @input="searchShippByTrack($event)"
                    placeholder="Scan qr code here ..."
                    v-model="searchTextShipp"
                    type="search"
                    autofill="off"
                    class="border-t border-green-400 text-gray-700 text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4"
                  />
                </div>
              </div>

              <div style="overflow-x: auto">
                <table class="min-w-full w-full">
                  <thead class="relative">
                    <tr
                      class="bg-gray-400 text-gray-600 uppercase text-sm leading-normal"
                    >
                      <th
                        class="px-3 w-10 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <label
                          class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer"
                          ><input
                            type="checkbox"
                            @click="selectAllCheckboxShipp($event)"
                            class="form-checkbox checkallbboxShipp focus:outline-none focus:shadow-outline"
                        /></label>
                      </th>
                      <th
                        class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <span> Shipping Address </span>
                      </th>
                      <th
                        class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <span> Shipping Date </span>
                      </th>
                      <th
                        class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <span> Traking number </span>
                      </th>
                      <th
                        class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <span> Order </span>
                      </th>
                      <th
                        class="px-3 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
                      >
                        <span> Status </span>
                      </th>
                    </tr>
                  </thead>

                  <loading
                    :active.sync="newShipp.loading"
                    :is-full-page="fullPage"
                  ></loading>
                  <tbody>
                    <tr
                      v-for="(item, index) in newShipp.shippings"
                      :key="index"
                      class="border-b border-gray-200 hover:bg-gray-100"
                    >
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"
                      >
                        <label
                          class="text-lg text-teal-500 inline-flex justify-between items-center hover:bg-gray-200 px-2 py-2 rounded-lg cursor-pointer"
                          ><input
                            type="checkbox"
                            @click="getRowDetailShipp($event, item, item._id)"
                            :status="item.status ? item.status : ''"
                            :typeshipp="item.type ? item.type : ''"
                            :courier="item.courier ? item.courier : ''"
                            :id="item._id"
                            :orderobjet="
                              item.order ? JSON.stringify(item.order) : ''
                            "
                            :externalId="
                              item.order
                                ? item.order.externalId || ''
                                : item.externalId
                            "
                            :order="item.order ? item.order._id : ''"
                            :seller="
                              item.seller && item.seller.source
                                ? item.seller.source
                                : item.seller.company || 'nosource'
                            "
                            :class="'rowProduct-' + item._id"
                            class="form-checkbox rowCheckboxShipp focus:outline-none focus:shadow-outline"
                        /></label>
                      </td>
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"
                      >
                        <div
                          class="text-xs leading-5 capitalize rounded-full text-gray-900"
                        >
                          {{ exceptText(item.address) }}
                        </div>
                      </td>
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"
                      >
                        <div
                          class="text-xs leading-5 capitalize rounded-full text-gray-900"
                        >
                          {{ $moment(item.date).format('DD-MM-YYYY') }}
                        </div>
                      </td>
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"
                      >
                        <div
                          class="text-xs leading-5 capitalize rounded-full text-gray-900"
                        >
                          {{ item.trackingNumber }}
                        </div>
                      </td>
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300"
                      >
                        <div
                          class="text-xs leading-5 capitalize rounded-full text-gray-900"
                        >
                          <span
                            v-if="item.order"
                            class="font-bold mr-1 text-orange-600"
                            >{{ item.order.details.length }} Products</span
                          >
                        </div>
                      </td>
                      <td
                        class="px-3 py-1 whitespace-no-wrap border-b border-gray-300 text-center"
                      >
                        <div
                          class="text-xs leading-5 capitalize rounded-full text-gray-900"
                        >
                          <button
                            class="border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none"
                            style=" color: rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                          >
                            {{ item.status }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  v-if="newShipp.shippings.length == 0"
                  class="bg-orange-100 py-8"
                >
                  <span
                    class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base"
                  >
                    <img alt="..." class="w-20 ml-4" :src="imageScannerShipp" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="p-4 flex space-x-4 modal-footer">
            <a
              href="#"
              @click="OpenClosePopupModal('close', 'dauchette')"
              class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm"
              >{{ $t('cancel') }}
            </a>
            <a
              href="#"
              @click="EmitActionNewShipp('dauchette')"
              class="w-1/2 px-4 py-3 text-center text-primary-100 bg-primary-600 rounded-lg hover:bg-primary-700 hover:text-white font-bold text-sm loidingconfirm relative"
            >
              <loading
                :active.sync="loadingdatashipp"
                :is-full-page="fullPage"
              ></loading>
              {{ $t('confirm') }}
            </a>
          </div>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'shippings'"
        name="Echange"
        :headerOptions="{ title: `Echange` }"
        :noFooter="true"
        modalSize="lg"
        @on-close="OpenClosePopupModal('close', 'Echange')"
      >
        <!--  -->
        <div class="rounded-lg mb-14">
          <!--  -->
          <div
            class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative"
          >
            <!--  -->
            <loading
              :active.sync="newShipp.loading"
              :is-full-page="fullPage"
            ></loading>
            <!--  -->

            <!--  -->
            <div
              class="border border-gray-700 mb-5 animation-pulse  w-full h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
            >
              <p>
                <v-select
                  v-model="newShipp.echange.type"
                  :options="newShipp.echange.types"
                ></v-select>
              </p>
            </div>
            <!--  -->

            <!--  -->
            <div
              v-if="
                newShipp.echange.type &&
                  newShipp.echange.type === 'Echange track'
              "
              class="grid lg:grid-cols-2 gap-6"
            >
              <!--  -->
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  for="grid-password"
                >
                  {{ $t('Ancien trackingNumber') }}</label
                >
                <input
                  v-model="newShipp.echange.oldTrack"
                  type="text"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 border border-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                />
              </div>
              <!--  -->

              <!--  -->
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  for="grid-password"
                >
                  {{ $t('Nouveau trackingNumber') }}
                </label>
                <input
                  :disabled="!newShipp.echange.oldTrack"
                  v-model="newShipp.echange.newTrack"
                  type="text"
                  class="px-3 py-3 border border-gray-700 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                />
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              v-if="
                newShipp.echange.type &&
                  newShipp.echange.type === 'Echange shipping'
              "
              class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative"
            >
              <!--  -->
              <div class="flex flex-row">
                <div class="flex w-full mb-5">
                  <input
                    id="inputshipping"
                    @input="searchShippByTrack_01($event, 'Echange')"
                    placeholder="Scan qr code OR copier traking number here ..."
                    v-model="searchTextShipp"
                    type="search"
                    autofill="off"
                    class="border-t  text-gray-700 border-gray-500  text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4"
                  />
                </div>
              </div>
              <!--  -->

              <!--  -->
              <div
                v-if="newShipp.echange.data && newShipp.echange.data._id"
                style="overflow-x: auto;"
              >
                <!--  -->
                <div class="grid lg:grid-cols-2 gap-6">
                  <!--  -->
                  <div class="data-ss">
                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Seller</span>
                      <div class="content-1">
                        {{ newShipp.echange.data.seller.fullName }}
                      </div>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Order ID</span>
                      <div class="content-1">
                        {{ newShipp.echange.data.orderObjet.id }}
                      </div>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Customer</span>
                      <div class="content-1">
                        {{ newShipp.echange.data.orderObjet.customer.fullName }}
                      </div>
                      <div class="content-1">
                        {{ newShipp.echange.data.orderObjet.customer.phone }}
                      </div>
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="data-ss">
                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Traking number</span>
                      <div class="content-1">
                        {{ newShipp.echange.data.trackingNumber }}
                      </div>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Shipping date</span>
                      <div class="content-1">
                        {{
                          $moment(newShipp.echange.data.date).format(
                            'DD-MM-YYYY',
                          )
                        }}
                      </div>
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="row-data">
                      <span class="title-1">Status</span>
                      <div
                        class="content-1 status"
                        :style="colorStatus(newShipp.echange.data.status)"
                      >
                        {{ newShipp.echange.data.status }}
                      </div>
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div></div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full data-ss">
                  <!--  -->
                  <div class="header-1">
                    <!--  -->
                    <div class="content">
                      <!--  -->
                      <span class="title">Orders details</span>
                      <!--  -->
                      <button
                        @click="getProducts('Echange')"
                        class="ml-5 text-white mx-auto max-w-sm rounded-md text-center bg-primary-600 py-2 px-8 items-center focus:outline-none md:float-right"
                      >
                        {{ $t('select_product') }}
                      </button>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div
                    v-if="
                      newShipp.echange.data &&
                        newShipp.echange.data.details &&
                        newShipp.echange.data.details.length > 0
                    "
                    class="w-full"
                  >
                    <!--  -->
                    <div class="overflow-x-auto">
                      <!--  -->
                      <table class="min-w-full leading-normal">
                        <!--  -->
                        <thead>
                          <!--  -->
                          <tr>
                            <!--  -->
                            <th
                              class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                            >
                              {{ $t('name') }}
                            </th>
                            <!--  -->
                            <th
                              class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                            >
                              {{ $t('unit_price') }}
                            </th>
                            <!--  -->
                            <th
                              class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                            >
                              {{ $t('quantity') }}
                            </th>
                            <!--  -->
                            <th
                              class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                            >
                              {{ $t('total') }}
                            </th>
                            <!--  -->
                            <th
                              class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                            >
                              {{ $t('actions') }}
                            </th>
                            <!--  -->
                          </tr>
                          <!--  -->
                        </thead>
                        <!--  -->

                        <!--  -->
                        <tbody
                          v-for="(item, index) in newShipp.echange.data.details"
                          :key="index"
                        >
                          <!--  -->
                          <tr>
                            <!--  -->
                            <td
                              class="px-2 py-2 whitespace-no-wrap border-b border-gray-200"
                            >
                              <!--  -->
                              <div
                                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                              >
                                {{ item.product.name }}
                                <!--  -->
                                <p
                                  v-if="
                                    (item.product.details.length > 0 &&
                                      item.product.details[0].variantes &&
                                      item.product.details[0].variantes.length >
                                        0 &&
                                      item.product.source) ||
                                      (item.variante && item.variante.id)
                                  "
                                >
                                  <!--  -->
                                  <small class="font-bold"
                                    >Varinate:
                                    {{
                                      item.variante
                                        ? item.variante.name
                                        : item.product.source.name
                                    }}</small
                                  >
                                  <!--  -->
                                </p>
                                <!--  -->
                              </div>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              class="px-2 py-2 whitespace-no-wrap border-b border-gray-200"
                            >
                              <div>
                                <input
                                  min="0"
                                  type="number"
                                  v-model="item.unitPrice"
                                  class="border border-green-600 py-2 text-xs px-2 outline-none block h-full w-full"
                                />
                              </div>
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              class="px-2 py-2 whitespace-no-wrap border-b border-gray-200"
                            >
                              <div class="flex space-x-6">
                                <button
                                  :class="$colors.textPrimary"
                                  class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                  @click="addQuantity(index, 'Echange')"
                                >
                                  <span class="font-bold text-2xl text-white">
                                    <i class="material-icons mt-2">add</i>
                                  </span>
                                </button>
                                <span
                                  :class="$colors.textPrimary"
                                  class="text-gray-700 text-sm h-6 flex items-center focus:outline-none"
                                >
                                  <input
                                    class="focus:outline-none w-12 text-center"
                                    type="text"
                                    v-model="item.quantity"
                                  />
                                </span>
                                <button
                                  :class="$colors.textPrimary"
                                  @click="removeQuantity(index, 'Echange')"
                                  class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none"
                                >
                                  <span
                                    class="font-bold text-2xl text-white mt-1"
                                  >
                                    <i class="material-icons">remove</i>
                                  </span>
                                </button>
                              </div>
                              <div
                                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                              ></div>
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              class="px-2 py-2 whitespace-no-wrap border-b border-gray-200"
                            >
                              <div
                                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                              >
                                {{
                                  (item.unitPrice * item.quantity).toFixed(2)
                                }}
                              </div>
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              class="py-2 whitespace-no-wrap border-b border-gray-200"
                            >
                              <div class="flex justify-center">
                                <button
                                  @click="removeProduct(item, index, 'Echange')"
                                  :class="$colors.actionTable"
                                  class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1"
                                >
                                  <i class="material-icons mx-1">delete</i>
                                </button>
                              </div>
                            </td>
                            <!--  -->
                          </tr>
                        </tbody>
                        <!--  -->

                        <!--  -->
                        <tbody>
                          <tr>
                            <td
                              colspan="4"
                              class="px-2 text-right py-2 whitespace-no-wrap border-gray-200"
                            >
                              <div
                                class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900"
                              >
                                {{ $t('total_price') }}:
                                {{ TotalPrice('Echange').toFixed(2) }}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <!--  -->
                      </table>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="p-4 flex space-x-4 modal-footer">
            <!--  -->
            <a
              href="#"
              @click="OpenClosePopupModal('close', 'Echange')"
              class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm"
              >Cancel</a
            >
            <!--  -->
            <a
              href="#"
              @click="EmitActionNewShipp(newShipp.echange.type)"
              class="w-1/2 px-4 py-3 text-center text-orange-100 bg-orange-600 rounded-lg hover:bg-orange-700 hover:text-white font-bold text-sm relative loidingconfirm"
              :class="newShipp.loading ? 'noselect' : ''"
            >
              <!--  -->
              <loading
                :active.sync="newShipp.loading"
                :is-full-page="fullPage"
              ></loading>
              Confirme Echange
              <!--  -->
            </a>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'products'"
        name="ModalChangeQte"
        :headerOptions="{ title: $t('change_quantity') }"
        :noFooter="true"
        modalSize="lg"
        @on-close="OpenClosePopupModal('close')"
      >
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <div class="bg-white rounded-lg">
          <div class="rounded-lg flex" style="margin-bottom: 80px">
            <div class="w-full pt-9 px-4">
              <div
                v-if="selectProduct.name"
                class="py-3 px-5 mx-2 mb-6 bg-gray-100 text-gray-900 rounded-md text-sm border border-gray-200"
                role="alert"
              >
                <p>
                  <strong
                    >{{ $t('product') }}: {{ selectProduct.name }}
                  </strong>
                </p>

                <p class="mb-3">
                  <strong>{{ $t('current_quantity') }}: </strong>
                </p>

                <div class="flex flex-col md:flex-row item-center gap-4">
                  <div class="w-full md:w-2/6 text-center">
                    <div
                      class="bg-gray-300 p-2 rounded-lg flex items-center justify-center border border-gray-200"
                    >
                      <div
                        class="w-1/3 bg-transparent flex items-center justify-center icon-step"
                      >
                        {{ $t('quantity_in_stock') }}
                      </div>
                      <div
                        class="w-2/3 bg-gray-200 flex flex-col items-center justify-center px-1 rounded-r-lg body-step"
                      >
                        <h2 class="font-bold text-sm">
                          Total: {{ selectProduct.quantity.inStock }}
                        </h2>
                        <div class="py-1">
                          <div
                            v-for="(wharhouse, i) in producWarhouse"
                            :key="i"
                            v-if="
                              wharhouse.warehouse.country == idWharhouse.country
                            "
                            class="flex justify-center items-center py-1"
                          >
                            <div class="flex">
                              <svg
                                v-if="wharhouse.warehouse.is_primary"
                                class="fill-current mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"
                                />
                              </svg>
                              <img
                                class="w-4 h-4 rounded-full"
                                :src="wharhouse.warehouse.flag"
                              />
                            </div>
                            <div class="pl-1 flex">
                              {{ wharhouse.quantity.inStock }}
                              <span
                                class="mx-1 px-1 ware-name pt-1"
                                v-if="wharhouse.warehouse.parent"
                              >
                                ({{ wharhouse.warehouse.name }})</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-full md:w-2/6 text-center">
                    <div
                      class="bg-gray-300 p-2 rounded-lg flex items-center justify-center border border-gray-200"
                    >
                      <div
                        class="w-1/3 bg-transparent flex items-center justify-center icon-step"
                      >
                        {{ $t('quantity_total') }}
                      </div>
                      <div
                        class="w-2/3 bg-gray-200 flex flex-col items-center justify-center px-1 rounded-r-lg body-step"
                      >
                        <h2 class="font-bold text-sm">
                          Total: {{ selectProduct.quantity.total }}
                        </h2>
                        <div class="py-1">
                          <div
                            v-for="(wharhouse, i) in producWarhouse"
                            :key="i"
                            v-if="
                              wharhouse.warehouse.country == idWharhouse.country
                            "
                            class="flex justify-center items-center py-1"
                          >
                            <div class="flex">
                              <svg
                                v-if="wharhouse.warehouse.is_primary"
                                class="fill-current mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"
                                />
                              </svg>
                              <img
                                class="w-4 h-4 rounded-full"
                                :src="wharhouse.warehouse.flag"
                              />
                            </div>
                            <div class="pl-1 flex">
                              {{ wharhouse.quantity.total }}
                              <span
                                class="mx-1 px-1 ware-name pt-1"
                                v-if="wharhouse.warehouse.parent"
                              >
                                ({{ wharhouse.warehouse.name }})</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-full md:w-2/6 text-center">
                    <div
                      class="bg-gray-300 p-2 rounded-lg flex items-center justify-center border border-gray-200"
                    >
                      <div
                        class="w-1/3 bg-transparent flex items-center justify-center icon-step"
                      >
                        {{ $t('quantity_total') }}
                      </div>
                      <div
                        class="w-2/3 bg-gray-200 flex flex-col items-center justify-center px-1 rounded-r-lg body-step"
                      >
                        <h2 class="font-bold text-sm">
                          Defective: {{ selectProduct.quantity.defective }}
                        </h2>
                        <div class="py-1">
                          <div
                            v-for="(wharhouse, i) in producWarhouse"
                            :key="i"
                            v-if="
                              wharhouse.warehouse.country == idWharhouse.country
                            "
                            class="flex justify-center items-center py-1"
                          >
                            <div class="flex">
                              <svg
                                v-if="wharhouse.warehouse.is_primary"
                                class="fill-current mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"
                                />
                              </svg>
                              <img
                                class="w-4 h-4 rounded-full"
                                :src="wharhouse.warehouse.flag"
                              />
                            </div>
                            <div class="pl-1 flex">
                              {{ wharhouse.quantity.defective }}
                              <span
                                class="mx-1 px-1 ware-name pt-1"
                                v-if="wharhouse.warehouse.parent"
                                >({{ wharhouse.warehouse.name }})</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-4">
                <div class="w-full lg:w-1/3 px-2">
                  <div
                    class="mb-5 border hover:border-green-400 focus-within:border-green-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="status"
                          class="bg-white text-gray-700 px-1"
                          >{{ $t('type_operation') }}</label
                        >
                      </p>
                    </div>
                    <p>
                      <v-select
                        class="v-instock"
                        v-model="ChangeQte.operation"
                        :options="typeoperations"
                      ></v-select>
                    </p>
                  </div>
                </div>
                <div class="w-full lg:w-1/3 px-2">
                  <div
                    class="mb-1 border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="status" class="bg-white text-gray-700 px-1"
                          >Type stock</label
                        >
                      </p>
                    </div>
                    <p>
                      <v-select
                        class="v-instock"
                        v-model="ChangeQte.stock"
                        :options="typeostocks"
                      ></v-select>
                    </p>
                  </div>
                </div>
                <div class="w-full lg:w-1/3 px-2">
                  <div
                    class="mb-5 border hover:border-green-400 focus-within:border-green-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="quantity"
                          class="bg-white text-gray-700 px-1"
                          >{{ $t('quantity') }}</label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        id="quantity"
                        type="number"
                        min="0"
                        v-model="ChangeQte.quantity"
                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                    </p>
                  </div>
                </div>
              </div>
              <section
                class="warehouse"
                v-if="expeditionData.warhouseParent.exist"
              >
                <div class="flex mb-5 items-center text-center">
                  <hr class="border-gray-600 border-1 w-full rounded-md" />
                  <label
                    class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                    ><span
                      class="font-medium text-base text-primary-800 dark:text-primary-200"
                      >Choisir warehouse</span
                    >
                  </label>
                  <hr class="border-gray-600 border-1 w-full rounded-md" />
                </div>
                <div class="bg-ww">
                  <h2 class="text-sm font-bold truncate mb-5">
                    Définir le warehouse pour ce produit
                  </h2>
                  <div class="w-full">
                    <div
                      v-for="it in checkWarehousingParent"
                      :key="it._id"
                      :id="it._id"
                      @click="activateWarehouse(it)"
                      :class="{ active: it.fullOf }"
                      class="border border-gray-600 intro-y flex-1 box-1 cursor-pointer zoom-in p-2 mb-2 pl-10"
                    >
                      <div class="check-left">
                        <span class="feather-icon select-none relative"
                          ><svg
                            :class="
                              it.fullOf ? 'bg-primary-500' : 'bg-gray-500'
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-check p-1 w-5 h-5 text-white rounded-full shadow"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline></svg
                        ></span>
                      </div>
                      <div class="text-sm font-bold text-left">
                        {{ it.name }}
                        <span v-if="it.is_primary">(Principal)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!--services -->
              <section v-if="expeditionData.setting.exist">
                <div class="flex mt-10 mb-5 items-center text-center">
                  <hr class="border-gray-600 border-1 w-full rounded-md" />
                  <label
                    class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                    ><span
                      class="font-medium text-base text-primary-800 dark:text-primary-200"
                      >Choisir les services</span
                    >
                  </label>
                  <hr class="border-gray-600 border-1 w-full rounded-md" />
                </div>
                <div class="bg-ww">
                  <h2 class="text-sm font-bold truncate mb-5">
                    Définir les services pour le nouveau warehouse de ce seller
                  </h2>
                  <div class="flex flex-col lg:flex-row">
                    <div
                      id="confirmation"
                      @click="activate('confirmation')"
                      :class="{ active: expeditionData.setting.confirmation }"
                      class="border border-gray-600 intro-y flex-1 box-1 py-10 cursor-pointer zoom-in"
                    >
                      <div class="check">
                        <span class="feather-icon select-none relative"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline></svg
                        ></span>
                      </div>
                      <img
                        class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                        src="https://img.icons8.com/external-outline-lafs/64/000000/external-ic_support-menu-outline-lafs.png"
                      />
                      <div class="text-xl font-medium text-center mt-10">
                        Confirmation
                      </div>
                    </div>
                    <div
                      id="fulfillement"
                      @click="activate('fulfillement')"
                      :class="{ active: expeditionData.setting.fulfillement }"
                      class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 mb-5 lg:mb-0 cursor-pointer zoom-in"
                    >
                      <div class="check">
                        <span class="feather-icon select-none relative"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline></svg
                        ></span>
                      </div>
                      <img
                        class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                        src="https://img.icons8.com/external-becris-lineal-becris/64/000000/external-warehouse-business-intelligence-becris-lineal-becris.png"
                      />
                      <div class="text-xl font-medium text-center mt-10">
                        Warehouse
                      </div>
                    </div>
                    <div
                      id="shipping"
                      @click="activate('shipping')"
                      :class="{ active: expeditionData.setting.shipping }"
                      class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 cursor-pointer zoom-in"
                    >
                      <div class="check">
                        <span class="feather-icon select-none relative"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline></svg
                        ></span>
                      </div>
                      <img
                        class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                        src="https://img.icons8.com/external-bartama-glyph-64-bartama-graphic/64/000000/external-Shipping-e-commerce-glyph-bartama-glyph-64-bartama-graphic.png"
                      />
                      <div class="text-xl font-medium text-center mt-10">
                        Shipping
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div class="modal-footer px-5 border0-t text-right">
            <button
              @click="OpenClosePopupModal('close')"
              class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
            >
              {{ $t('cancel') }}
            </button>
            <button
              @click="confirmChangeQte"
              class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
              :class="ChangeQte.loading ? 'noselect' : ''"
            >
              <loading
                :active.sync="ChangeQte.loading"
                :is-full-page="fullPage"
              ></loading
              >{{ $t('confirm') }}
            </button>
          </div>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <dialog class="printingExcel" v-if="config.name == 'orders'">
        <modal-export-excel-orders :items="data" />
      </dialog>
      <!--  -->

      <!--  -->
      <dialog class="printingExcel" v-if="config.name == 'shippings'">
        <modal-export-excel-shippings :items="dataExcel.data" />
      </dialog>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'expeditions'"
        name="ModalChangeSetSettingsSeller"
        :headerOptions="{
          title: expeditionData.setting.exist
            ? `Définir les services pour le nouveau warehouse de ce seller`
            : 'Définir le warehouse pour chaque produit',
        }"
        :noFooter="true"
        modalSize="lg"
        @on-close="$vm2.close('ModalChangeSetSettingsSeller')"
      >
        <loading
          :active.sync="expeditionData.loading"
          :is-full-page="fullPage"
        ></loading>
        <div class="bg-white rounded-lg" style="margin-bottom: 60px">
          <div class="relative">
            <div class="rounded-lg flex">
              <div class="w-full p-4">
                <div
                  class="change-status border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1"
                >
                  <div
                    class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                  >
                    <p>
                      <label for="settings" class="bg-white text-gray-700 px-1"
                        >Country (warhousing)</label
                      >
                    </p>
                  </div>
                  <p>
                    <input
                      v-if="expeditionData.country"
                      type="text"
                      disabled
                      v-model="expeditionData.country"
                      class="py-2 text-xs px-2 outline-none block h-full w-full"
                    />
                  </p>
                </div>
                <section
                  class="warehouse"
                  v-if="expeditionData.warhouseParent.exist"
                >
                  <div class="flex my-5 items-center text-center">
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                    <label
                      class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                      ><span
                        class="font-medium text-base text-primary-800 dark:text-primary-200"
                        >Choisir warehouse</span
                      >
                    </label>
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                  </div>
                  <div class="bg-ww">
                    <h2 class="text-sm font-bold truncate mb-5">
                      Définir le warehouse pour chaque produit (<img
                        v-if="idWharhouse"
                        :src="idWharhouse.flag"
                        class="h-4 w-5 blob inline-block"
                        :alt="idWharhouse.country"
                      />)
                    </h2>
                    <div
                      v-for="(item, index) in expeditionData.data.details"
                      :key="index"
                      :value="item._id"
                      class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-600 mb-2"
                    >
                      <div>
                        <img
                          :alt="item.product.name"
                          :src="
                            item.product.picture ||
                              'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                          "
                          class="h-16 w-16 rounded-md mx-auto"
                        />
                      </div>
                      <div class="col-span-2 w-full">
                        <h3 class="text-gray-80">{{ item.product.name }}</h3>
                        <p>
                          <v-select
                            v-model="item.warehouseParent"
                            :options="checkWarehousingParent"
                            placeholder="Select warehouse"
                            label="name"
                            class="border border-gray-600"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                              <span v-if="option.is_primary">(Principal)</span>
                            </template>
                          </v-select>
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
                <!--services -->
                <section v-if="expeditionData.setting.exist">
                  <div class="flex mt-10 mb-5 items-center text-center">
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                    <label
                      class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                      ><span
                        class="font-medium text-base text-primary-800 dark:text-primary-200"
                        >Choisir les services</span
                      >
                    </label>
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                  </div>
                  <div class="bg-ww">
                    <h2 class="text-sm font-bold truncate mb-5">
                      Définir les services pour le nouveau warehouse de ce
                      seller
                    </h2>
                    <div class="flex flex-col lg:flex-row">
                      <div
                        id="confirmation"
                        @click="activate('confirmation')"
                        :class="{ active: expeditionData.setting.confirmation }"
                        class="border border-gray-600 intro-y flex-1 box-1 py-10 cursor-pointer zoom-in"
                      >
                        <div class="check">
                          <span class="feather-icon select-none relative"
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline></svg
                          ></span>
                        </div>
                        <img
                          class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                          src="https://img.icons8.com/external-outline-lafs/64/000000/external-ic_support-menu-outline-lafs.png"
                        />
                        <div class="text-xl font-medium text-center mt-10">
                          Confirmation
                        </div>
                      </div>
                      <div
                        id="fulfillement"
                        @click="activate('fulfillement')"
                        :class="{ active: expeditionData.setting.fulfillement }"
                        class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 mb-5 lg:mb-0 cursor-pointer zoom-in"
                      >
                        <div class="check">
                          <span class="feather-icon select-none relative"
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline></svg
                          ></span>
                        </div>
                        <img
                          class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                          src="https://img.icons8.com/external-becris-lineal-becris/64/000000/external-warehouse-business-intelligence-becris-lineal-becris.png"
                        />
                        <div class="text-xl font-medium text-center mt-10">
                          Warehouse
                        </div>
                      </div>
                      <div
                        id="shipping"
                        @click="activate('shipping')"
                        :class="{ active: expeditionData.setting.shipping }"
                        class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 cursor-pointer zoom-in"
                      >
                        <div class="check">
                          <span class="feather-icon select-none relative"
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline></svg
                          ></span>
                        </div>
                        <img
                          class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                          src="https://img.icons8.com/external-bartama-glyph-64-bartama-graphic/64/000000/external-Shipping-e-commerce-glyph-bartama-glyph-64-bartama-graphic.png"
                        />
                        <div class="text-xl font-medium text-center mt-10">
                          Shipping
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer px-5 border0-t text-right">
          <button
            @click="$vm2.close('ModalChangeSetSettingsSeller')"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Cancel
          </button>
          <button
            @click="confirmChangeExpedition"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
            :disabled="expeditionData.loading"
          >
            <loading
              :active.sync="expeditionData.loading"
              :is-full-page="fullPage"
            ></loading
            >Confirm
          </button>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'products'"
        name="ModaldeleteProduct"
        :headerOptions="{
          title:
            'Veuillez choisir les warehouses desquels vous souhaitez supprimer ce produit',
        }"
        :noFooter="true"
        modalSize="lg"
        @on-close="$vm2.close('ModaldeleteProduct')"
      >
        <loading
          :active.sync="expeditionData.loading"
          :is-full-page="fullPage"
        ></loading>
        <div class="bg-white rounded-lg" style="margin-bottom: 60px">
          <div class="relative">
            <div class="rounded-lg flex">
              <div class="w-full p-4">
                <section
                  class="warehouse"
                  v-if="productData.warehouses.length > 1"
                >
                  <div class="flex mb-5 items-center text-center">
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                    <label
                      class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                      ><span
                        class="font-medium text-base text-primary-800 dark:text-primary-200"
                        >Choisir warehouses</span
                      >
                    </label>
                    <hr class="border-gray-600 border-1 w-full rounded-md" />
                  </div>
                  <div class="bg-www">
                    <p>
                      <v-select
                        v-model="productData.selectWarehouses"
                        :options="productData.warehouses"
                        multiple
                        placeholder="Select warehouses"
                        label="name"
                        class="border border-gray-600"
                      >
                        <template slot="option" slot-scope="option"
                          ><img class="flag-img" :src="option.flag" />
                          {{ option.name }}
                          <span v-if="option.is_primary">(Principal)</span>
                        </template>
                      </v-select>
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer px-5 border0-t text-right">
          <button
            @click="$vm2.close('ModaldeleteProduct')"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Cancel
          </button>
          <button
            @click="removeWarehousesProduct"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
            :disabled="expeditionData.loading"
          >
            <loading
              :active.sync="expeditionData.loading"
              :is-full-page="fullPage"
            ></loading
            >Confirm
          </button>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        v-if="config.name == 'shippings'"
        name="Refund"
        :headerOptions="{ title: `Remboursement` }"
        :noFooter="true"
        modalSize="lg"
      >
        <div class="rounded-lg mb-14">
          <div
            class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative"
          >
            <div class="flex flex-row">
              <div class="flex w-full mb-5">
                <input
                  id="inputshipping"
                  @input="searchShippByTrack_01($event, 'Refund')"
                  placeholder="Scan qr code OR copier traking number here ..."
                  v-model="searchTextShipp"
                  type="search"
                  autofill="off"
                  class="border-t text-gray-700 border-gray-500 text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4"
                />
              </div>
            </div>
            <loading
              :active.sync="newShipp.loading"
              :is-full-page="fullPage"
            ></loading>
            <div v-if="newShipp.refund.data" style="overflow-x: auto">
              <div class="grid lg:grid-cols-2 gap-6">
                <div class="data-ss">
                  <div class="row-data">
                    <span class="title-1">Seller</span>
                    <div class="content-1">
                      {{ newShipp.refund.data.seller.fullName }}
                    </div>
                  </div>
                  <div class="row-data">
                    <span class="title-1">Order ID</span>
                    <div class="content-1">
                      {{ newShipp.refund.data.orderObjet.id }}
                    </div>
                  </div>
                  <div class="row-data">
                    <span class="title-1">Customer</span>
                    <div class="content-1">
                      {{ newShipp.refund.data.orderObjet.customer.fullName }}
                    </div>
                    <div class="content-1">
                      {{ newShipp.refund.data.orderObjet.customer.phone }}
                    </div>
                  </div>
                </div>
                <div class="data-ss">
                  <div class="row-data">
                    <span class="title-1">Traking number</span>
                    <div class="content-1">
                      {{ newShipp.refund.data.trackingNumber }}
                    </div>
                  </div>
                  <div class="row-data">
                    <span class="title-1">Shipping date</span>
                    <div class="content-1">
                      {{
                        $moment(newShipp.refund.data.date).format('DD-MM-YYYY')
                      }}
                    </div>
                  </div>
                  <div class="row-data">
                    <span class="title-1">Status</span>
                    <div
                      class="content-1 status"
                      :style="colorStatus(newShipp.refund.data.status)"
                    >
                      {{ newShipp.refund.data.status }}
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
              <div class="w-full data-ss">
                <div class="header-1">
                  <div class="content">
                    <span class="title">Orders details</span>
                    <div class="content-1">
                      TotalPrice:
                      {{
                        newShipp.refund.data.orderObjet.totalPrice.toFixed(2)
                      }}
                      <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                    </div>
                  </div>
                </div>
                <div class="header-table">
                  <div class="xz84dc7">
                    <div class="title">Product name</div>
                  </div>
                  <div class="x8yj6t5">
                    <div class="title">Quantity</div>
                  </div>
                  <div class="x8yj6t5">
                    <div class="title">total</div>
                  </div>
                </div>
                <div
                  v-for="(item, index) in newShipp.refund.data.order.details"
                  :key="index"
                  class="header-table"
                >
                  <div class="xz84dc7">
                    <div class="title title-1">{{ item.product.name }}</div>
                  </div>
                  <div class="x8yj6t5">
                    <div class="title title-1">{{ item.quantity }}</div>
                  </div>
                  <div class="x8yj6t5">
                    <div class="title title-1">
                      {{ item.quantity * item.unitPrice }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-4 flex space-x-4 modal-footer">
            <a
              href="#"
              @click="OpenClosePopupModal('close', 'Refund')"
              class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm"
              >Cancel</a
            >
            <a
              href="#"
              @click="EmitActionNewShipp('Refund')"
              class="w-1/2 px-4 py-3 text-center text-orange-100 bg-orange-600 rounded-lg hover:bg-orange-700 hover:text-white font-bold text-sm relative loidingconfirm"
              :class="newShipp.loading ? 'noselect' : ''"
            >
              <loading
                :active.sync="newShipp.loading"
                :is-full-page="fullPage"
              ></loading>
              Confirme Refund
            </a>
          </div>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        name="messages"
        :headerOptions="{ title: 'Info messages' }"
        :noFooter="true"
        modalSize="lg"
        @on-close="closePopup('messages')"
      >
        <div class="bg-white rounded-lg p-2">
          <div
            v-if="messagesInfo.length > 0"
            class="overflow-x-auto w-full px-4"
          >
            <table class="table w-full table-messages">
              <thead>
                <tr class="bg-gray-700 dark:bg-dark-1 text-white text-left">
                  <th class="whitespace-nowrap p-2">Order TrakingNumber</th>
                  <th class="whitespace-nowrap p-2">Message</th>
                  <th class="whitespace-nowrap p-2">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in messagesInfo"
                  :key="index"
                  :class="'bg-' + item.type"
                >
                  <td class="border-b dark:border-dark-5 p-2">
                    {{ item.EdcotrackingNumber }}
                  </td>
                  <td
                    class="border-b p-2 dark:border-dark-5"
                    :class="item.error ? 'error' : 'success'"
                  >
                    {{ item.message.Message || item.message }}
                  </td>
                  <td
                    class="border-b p-2 dark:border-dark-5"
                    :class="item.error ? 'error' : 'success'"
                  >
                    {{ item.error ? 'error' : 'success' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="px-4 py-2 flex float-right space-x-4">
            <a
              href="#"
              @click="closePopup('messages')"
              class="px-10 py-2 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm"
              >OK</a
            >
          </div>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        name="toShipp"
        :headerOptions="{ title: 'Orders to Shipp' }"
        :noFooter="true"
        modalSize="xl"
      >
        <div class="bg-white rounded-lg p-2 min-h-300">
          <div class="bg-white rounded-lg p-2 flex justify-center items-center">
            <div
              class="mb-2 w-1/2 border hover:border-green-400 focus-within:border-green-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="status" class="bg-white text-gray-700 px-1">{{
                    $t('Shipper')
                  }}</label>
                </p>
              </div>
              <p>
                <v-select
                  label="fullName"
                  v-model="newShipp.shipper.company"
                  :options="shippers"
                >
                  <template slot="option" slot-scope="option"
                    ><img
                      class="flag-img"
                      :src="option.apiShipping.logoLink"
                    />{{ option.fullName }}</template
                  >
                </v-select>
              </p>
            </div>
          </div>

          <div class="rounded-lg">
            <div class="overflow-x-auto w-full px-4">
              <table class="table w-full table-messages mb-90">
                <thead>
                  <tr class="bg-gray-700 dark:bg-dark-1 text-white text-left">
                    <th class="whitespace-nowrap p-2">Order ID</th>
                    <th class="whitespace-nowrap p-2">Seller</th>
                    <th class="whitespace-nowrap p-2">Customer</th>
                    <th class="whitespace-nowrap p-2">NB Products</th>
                    <th class="whitespace-nowrap p-2">Status</th>
                    <th class="whitespace-nowrap p-2">Shipper</th>
                    <th class="whitespace-nowrap p-2">État</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in newShipp.shipper.datas"
                    :key="index"
                    :class="[
                      item.order.traitBy ||
                      (item.sendData && item.sendData.send)
                        ? 'SEND'
                        : 'WAITING',
                      item.sendData &&
                      item.sendData.message &&
                      item.sendData.message == 'Duplicate Order'
                        ? 'DUP'
                        : '',
                    ]"
                  >
                    <td
                      class="border-b border-gray-900 dark:border-dark-5 p-2 py-1"
                    >
                      {{ item.order.id }}
                    </td>
                    <td
                      class="border-b border-gray-900 dark:border-dark-5 p-2 py-1"
                    >
                      {{ item.order.seller ? item.order.seller.fullName : '' }}
                    </td>
                    <td
                      class="px-3 border-gray-900 py-1 whitespace-no-wrap border-b"
                    >
                      <div
                        style="font-size: 10px; line-height: 15px"
                        class="leading-5 capitalize rounded-full text-gray-900"
                      >
                        <span>{{
                          item.order.customer
                            ? item.order.customer.fullName || ''
                            : ''
                        }}</span>
                        <span class="block">{{
                          item.order.customer
                            ? item.order.customer.phone || ''
                            : ''
                        }}</span>
                      </div>
                    </td>
                    <td
                      class="border-b border-gray-900 dark:border-dark-5 p-2 py-1"
                    >
                      {{ item.order.details ? item.order.details.length : 0 }}
                    </td>
                    <td
                      class="border-b border-gray-900 dark:border-dark-5 p-2 py-1"
                    >
                      {{ item.order.status ? item.order.status.name : '' }}
                    </td>
                    <td
                      class="border-b border-gray-900 p-2 dark:border-dark-5 py-1"
                    >
                      {{
                        newShipp.shipper.company
                          ? newShipp.shipper.company.fullName
                          : ''
                      }}
                    </td>
                    <td
                      class="border-b border-gray-900 p-2 dark:border-dark-5 py-1"
                      :class="[
                        item.order.traitBy
                          ? 'text-green-700'
                          : 'text-orange-800',
                      ]"
                    >
                      <span
                        class="flex"
                        v-if="!item.order.traitBy && !item.sendData"
                        ><svg
                          class="fill-current mr-1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M23 10v4h-22v-4h22zm1-1h-24v6h24v-6zm-20 2h-2v2h2v-2zm3 0h-2v2h2v-2zm3 0h-2v2h2v-2zm3 0h-2v2h2v-2zm3 0h-2v2h2v-2z"
                          />
                        </svg>
                        WAITING
                      </span>
                      <span v-else>
                        <span
                          class="flex"
                          v-if="item.sendData && item.sendData.send"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="fill-current mr-1"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M23 0l-4.5 16.5-6.097-5.43 5.852-6.175-7.844 5.421-5.411-1.316 18-9zm-11 12.501v5.499l2.193-3.323-2.193-2.176zm-2.789 3.857l.94.934c-.875.885-1.773 1.933-2.125 3.375l-1.286-.314c.434-1.774 1.491-3.004 2.471-3.995zm-1.565 7.642c-.715 0-1.353-.279-1.887-.83-1.458.515-2.844-.044-3.576-1.084-.575-.817-.703-1.853-.353-2.845-.552-.534-.83-1.166-.83-1.884 0-1.562 1.16-2.803 3.24-2.586l.195 1.117c-.664.062-1.277.097-1.674.494-.668.668-.467 2.063.787 2.433-.832.836-.751 2.037-.127 2.696.654.69 1.903.799 2.765-.059.385 1.305 1.798 1.422 2.433.787.392-.392.431-.995.492-1.649l1.125.229c.2 1.979-1.009 3.181-2.59 3.181zm-3.318-7.032l.314 1.287c1.755-.43 2.953-1.45 3.989-2.471l-.938-.931c-.876.866-1.927 1.764-3.365 2.115z"
                            />
                          </svg>
                          SEND
                        </span>
                        <span class="flex" v-else>
                          {{
                            item.sendData
                              ? item.sendData.message
                              : 'Already sent'
                          }}</span
                        >
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="modal-footer px-5 border0-t text-right">
          <a
            href="#"
            @click="closePopup('toShipp')"
            :class="newShipp.loading ? 'noselect' : ''"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
            >Close</a
          >
          <a
            href="#"
            @click="EmitActionNewShipp('toShipp')"
            :class="[
              newShipp.loading ? 'noselect' : '',
              newShipp.shipper.company ? '' : 'noselect',
            ]"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative"
          >
            <loading
              :active.sync="newShipp.loading"
              :is-full-page="fullPage"
            ></loading>
            {{ $t('Send all') }}
          </a>
        </div>
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        name="getProducts"
        :headerOptions="{ title: $t('add_products') }"
        :noFooter="true"
        modalSize="lg"
        @on-close="closePopUp('getProducts')"
      >
        <!--  -->
        <div class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
          <!--  -->
          <div class="flex w-full h-auto justify-center items-center">
            <!--  -->
            <div
              class="flex mb-2 w-full h-auto py-2 justify-center items-center text-2xl font-bold"
            >
              <!--  -->
              <span
                class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex"
              >
                <!--  -->
                <input
                  type="search"
                  name="search"
                  v-model="searchText"
                  placeholder="Search"
                  class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                />
                <!--  -->
                <i class="material-icons text-orange-400 m-2 mr-5 text-lg w-4 h-4"
                  >search</i
                >
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div>
            <!--  -->
            <div v-if="products.length <= 0" class="py-2">
              <!--  -->
              <span
                class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base"
              >
                <!--  -->
                <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                  <!--  -->
                  <span class=""> {{ $t('no_products_found') }}</span>
                  <!--  -->
                </p>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              v-for="(item, index) in resultSearchUsers"
              :key="index"
              :value="item._id"
              class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-300 mb-2"
            >
              <!--  -->
              <div>
                <!--  -->
                <input
                  type="checkbox"
                  v-model="item.check"
                  :class="'product-' + index"
                  class="form-checkbox checkallbbox mt-6 h-5 w-5 text-orange-500 border-orange-500"
                  @change="addProductsToTemp(item, index, 'Echange')"
                />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div>
                <!--  -->
                <img
                  :alt="item.name"
                  :src="
                    item.picture ||
                      'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                  "
                  class="h-16 w-16 rounded-md mx-auto"
                />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="w-full">
                <!--  -->
                <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
                <!--  -->
                <p class="text-gray-600 text-xs">
                  {{ exceptDes(item.description) }}
                </p>
                <!--  -->
                <p
                  v-if="
                    item.details &&
                      item.details.length > 0 &&
                      item.details[0].variantes &&
                      item.details[0].variantes.length > 0
                  "
                >
                  <!--  -->
                  <v-select
                    label="name"
                    placeholder="Sélectionnez variante ..."
                    :disabled="item.check"
                    v-model="item.source"
                    :options="item.details[0].variantes"
                    @input="selectAutoVariant(item, index)"
                    class="border border-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  ></v-select>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <button
            @click="closePopUp('getProducts')"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            <!--  -->
            {{ $t('cancel') }}
            <!--  -->
          </button>
          <!--  -->

          <!--  -->
          <button
            @click="ConfirmOperation('Echange')"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            <!--  -->
            {{ $t('confirm') }}
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->

      <!--  -->
      <vue-modal-2
        name="validateCity"
        :headerOptions="{ title: $t('validate_city') }"
        :noFooter="true"
        modalSize="md"
        @on-close="closePopUp('validateCity')"
      >
        <!--  -->
        <div
          v-if="validateCity"
          class="flex flex-col w-full h-auto p-5 pt-0 mb-12"
        >
          <!--  -->
          <div class="flex w-full h-auto justify-center items-center">
            <!--  -->
            <div
              class="flex mb-2 w-full h-auto py-2 justify-center items-center"
            >
              <!--  -->
              <span v-if="validateCity.message" class="text-base text-red-400">
                {{ validateCity.message }}</span
              >
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <router-link
            v-if="validateCity"
            :to="
              '/orders/edit/' +
                validateCity.item._id +
                '?' +
                $f.objectToQueryLink($f.QueryStringToobject()) +
                '&index=' +
                validateCity.item._id
            "
            class="flex text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            <!--  -->
            <svg
              class="inline mr-2"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3.994 12.964l3.106 3.105-4.112.931 1.006-4.036zm9.994-3.764l-5.84 5.921-3.202-3.202 5.841-5.919 3.201 3.2z"
                fill="currentColor"
              />
            </svg>
            <!--  -->
            <span> {{ $t('edit') }} </span>
            <!--  -->
          </router-link>
          <!--  -->

          <!--  -->
          <button
            @click="closePopUp('validateCity')"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            <!--  -->
            {{ $t('cancel') }}
            <!--  -->
          </button>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->

                    <!-- chatMessages -->
                    <vue-modal-2
                  :headerOptions="{ 
                    title: config.name === 'orders' 
                      ? `Messages de discussion (ID ORDER: ${orderData.data.id})` 
                      : config.name === 'shippings' 
                        ? `Messages de discussion (ID ORDER: ${orderData.data.order_id})` 
                        : '' 
                  }"
                  class="modal-backdrop "
                  v-if="config.name === 'orders' || config.name === 'shippings'"
                  name="chatMessages"
                  :noFooter="true"
                  modalSize="md"
                  @on-close="CloseModal('chatMessages')"
                >

                
                <div class="h-full m-0 p-0" >
                  <!-- Flex Container -->
                  <div class="flex flex-col h-full" >
                    <!-- Chat Messages Container -->
                    <div class=" p-4 chat-messages" ref="msgContainer">
                      <!-- Empty State -->
                      <div v-if="Object.entries(orderData.data.messages).length === 0" class="flex justify-center items-center h-full">
                        <span class="text-gray-500">Des questions? Discute avec nous!</span>
                      </div>

                      <!-- Messages List -->
                      <template v-for="(item, ind) in Object.entries(orderData.data.messages)" v-chat-scroll>
                        <!-- Date Separator -->
                        <div class="flex justify-center my-4">
                          <span class="px-3 py-1 bg-gray-200 text-sm text-gray-600 rounded-full">
                            {{ item[0] }}
                          </span>
                        </div>

                        <!-- Messages -->
                        <div
                          v-for="(mess, indd) in item[1]"
                          :key="item[0] + '-' + indd"
                          :ref="setMessageRef(ind, indd)"
                          class="flex mb-4 relative"
                        >
                          <!-- Left Aligned (Seller) -->
                          <div v-if="mess.access.fullName !== currentUser.fullName" class="flex items-start">
                            <div class="w-10 h-10 rounded-full overflow-hidden mr-3">
                              <img
                                src="https://storeno.b-cdn.net/stores/9-2024/1727428835050.png"
                                alt="User avatar"
                                class="w-full h-full object-cover"
                              />
                            </div>
                            <div class="bg-white p-3 rounded-lg shadow-sm max-w-md">
                              <p v-if="mess.type === 'text'" class="text-gray-800">{{ mess.message }}</p>
                              <expandable-image v-else :src="mess.message" alt="img-pr" class="rounded-lg" />
                              <span class="block text-xs text-gray-500 mt-1">{{ mess.__v }}</span>
                            </div>
                          </div>

                          <!-- Right Aligned (Current User) -->
                          <div v-else class="flex  items-end ml-auto">
                            <div class="bg-orange-500 p-3 rounded-lg shadow-sm max-w-md">
                              <p v-if="mess.type === 'text'" class="text-white">{{ mess.message }}</p>
                              <expandable-image v-else :src="mess.message" alt="img-pr" class="rounded-lg" />
                              <span class="block text-xs text-orange-200 mt-1">{{ mess.__v }}</span>
                            </div>
                            <div class="w-10 h-10 rounded-full overflow-hidden ml-3">
                              <img
                                src="https://img.icons8.com/color/96/circled-user-male-skin-type-1-2--v1.png"
                                alt="User avatar"
                                class="w-full h-full object-cover"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>

                    <!-- Chat Input  -->
                    <div class="p-4 bg-white border-t border-gray-200 sticky bottom-0 w-full">
                      <div class="flex items-center gap-2">
                        <!-- Attachment Button -->
                        <!-- <button @click="openPopup('ImageMessages')" class="p-2 text-gray-600 hover:text-orange-500">
                          <svg class="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path d="M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"/>
                          </svg>
                        </button> -->

                        <!-- Message Input -->
                        <div class="flex-1 relative">
                          <input
                            v-model="orderData.message"
                            class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
                            placeholder="Type message..."
                            @keyup.enter="addMessageTriger"
                          />
                        </div>

                        <!-- Send Button -->
                        <button
                          :disabled="orderData.loading"
                          @click="addMessage(config.name, 'message')"
                          class="p-2 bg-orange-500 text-white fill-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
                        >
                          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                  
              </vue-modal-2>
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { mixin as clickaway } from 'vue-clickaway';
import { dispatchShipment } from '../services/shipments.service';
import imageScanner from '@/assets/scanner.png';
import GeneratePDFButton from '../components/expedition/GeneratePDFButton.vue';
import ChangeStatusRoles from '../components/All/ChangeStatusRoles.vue';
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const PNF = require('google-libphonenumber').PhoneNumberFormat;

export default {
  name: 'CrazyTable',
  mixins: [clickaway],
  props: {
    config: { type: Object },
    data: { default: [] },
    element: { type: Object },
    loading: { required: false },
    CheckQteDefecteuseexist: { required: false },
    CheckQteReturnedexist: { required: false },
    CheckQteDefecteuseorderexist: { required: false },
    CheckExpeditionRecived: { required: false },
    name: { type: String, default: '' },
    paginate: { type: Object },
    statusOrder: { type: Array },
    zones: { type: Array },
    couriers: { type: Array },
    teleconsultants: { type: Array },
    limit: { type: Number },
    statusExpedition: { type: Array },
    statusShipp: { type: Array },
    statusShippChange: { type: Array },
    tabId: { type: Array },
    typesShipp: { type: Array },
    paidtatus: { type: Array },
    transports: { type: Array },
    isFilterCourier: { required: false },
    CourierInfo: { type: Object },
    selectProduct: { type: Object },
    producWarhouse: {
      type: Array,
      default() {
        return [];
      },
    },
    cch: [],
    chk: true,
  },
  components: {
    GeneratePDFButton,
    ChangeStatusRoles,
  },
  data() {
    return {
      orderData: { loading: false, data: { messages: [] }, message: '', picture: '' },
      loadingupdateorder: false,
      lastMessageRef: null,
      shippingCompanies: [
        'MAYLERZ',
        'CATHEDIS',
        'SPEEDSHIP',
        'OZON EXPRESS',
        'AMEEX',
        'ALTHIQUA',
        'ALTHIQUA',
        'DIGYLOG',
        'RUSHLIV',
      ],
      imageScannerShipp: imageScanner,
      showcourier: false,
      open: false,
      change_status: {
        statusTochange: '',
        courier: null,
      },
      shipping: {
        address: '',
        type: 'normal',
        date: '',
        status: 'to prepare',
        order: { type: Object },
        zone: { type: Object },
        courier: { type: Object },
      },
      shippingChange: {
        type: 'pendingchange',
        date: '',
        status: 'to prepare',
        order: { type: Object },
        zone: { type: Object },
        courier: { type: Object },
      },
      fullPage: false,
      loadingdatashipp: false,
      filters: [],
      actions: [],
      newSeller: {},
      roles: [],
      categories: [],
      currentUser: {},
      courier: [],
      checkQte: false,
      loadingChange: false,
      custumerTest: '',
      ShippCode: '',
      ChangeQte: {
        operation: 'Addition',
        stock: 'inStock-total',
        quantity: 0,
        loading: false,
        warehouse: null,
        seller: null,
        warhouseParent: null,
        settings: null,
      },
      typeoperations: ['Addition', 'Subtraction'],
      typeostocks: ['inStock', 'total', 'inStock-total', 'defective'],
      dataCountry: this.$countries,
      openLimit: false,
      openAnalytics: false,
      warehouses: [],
      currency: '',
      idWharhouse: null,
      limitdata: 0,
      filters: {},
      feesShipp: {},
      loadingcreateShipp: false,
      postponed: {
        data: {},
        _id: null,
        seller: null,
        date: null,
        comment: undefined,
        index: null,
        status: undefined,
      },
      expeditionData: {
        model: null,
        dataWhrahouseSetting: {},
        loading: false,
        data: {},
        country: null,
        warhouseParent: { exist: false, warehouse: null },
        setting: {
          exist: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
          warehouse: null,
        },
      },
      oldData: { data: {}, loading: false },
      checkSetting: null,
      checkWarehousingParent: [],
      cities: [],
      searchTextShipp: '',
      newShipp: {
        echange: {
          oldTrack: null,
          newTrack: null,
          type: 'Echange track',
          types: ['Echange track', 'Echange shipping'],
          data: { details: [] },
        },
        status: null,
        shippings: [],
        tabId: [],
        loading: false,
        refund: {
          data: null,
        },
        shipper: { datas: [], company: null },
      },
      dataExcel: { loading: false, data: [] },
      productData: { id: null, warehouses: [], selectWarehouses: [] },
      timer: 0,
      interval: null,
      messagesInfo: [],
      shippers: [],
      paymentData: { status: ['pending', 'valider'], loading: false, index: 0 },
      products: [],
      searchText: '',
      numberItemRepeated: 0,
      productselected: [],
      showVar: null,
      validateCity: null,
    };
  },
  async mounted() {
    await this.getwharhouseId();
    await this.getUser();
    await this.getWarehouses();
    await this.getCities();
    this.filters = this.$f.QueryStringToobject();
    if (this.filters && this.filters['limit']) {
      this.limitdata = this.filters['limit'];
    }
    
  },
  computed: {
ordersWithUnreadMessages() {
    return this.data.reduce((unreadOrders, order) => {
      if (this.hasUnreadMessages(order)) {
        unreadOrders.push(order._id);
      }
      return unreadOrders;
    }, []);
  },
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
    columnsHead() {
      return this.config.columns.filter(
        head => head.name !== 'shipper' || this.currentUser.type === 'CEO',
      );
    },
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter(product => {
          var regex = new RegExp(this.searchText, 'i');
          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {
      await this.getwharhouseId();
      await this.getCities();
    },
    data: {
      handler(newValue) {},
      deep: true,
    },
    data: async function(oldVal, newVal) {
      if (
        this.$route.query.index &&
        this.config.name == 'orders' &&
        this.currentUser.type &&
        this.currentUser.type != 'Seller' &&
        this.data &&
        this.data.length > 0
      ) {
        const findItemOrder = this.data.find(
          o => o._id.toString() === this.$route.query.index.toString(),
        );
        if (findItemOrder) {
          this.ShowPopUpInformation(
            this.$route.query.index,
            null,
            findItemOrder,
          );
        }
      }
    },
  },
  methods: {
hasUnreadMessages(order) {
    // Check if messages exist and is an array
    if (!order.messages || !Array.isArray(order.messages)) {
      return false;
    }

    // Check if any message is unread
    return order.messages.some(message => 
      message.access && 
      message.access._id !== this.currentUser._id && 
      message.access.vue === false
    );
  },
    exceptDes(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },
    closePopUp(name) {
      this.$vm2.close(name);
    },
    showProductsVariantes(index) {
      if (this.showVar !== this.data[index]._id) {
        this.showVar = this.data[index]._id;
      } else this.showVar = null;
    },
    openWhatsApp(customer) {
      let tel = phoneUtil.parse(customer.phone, this.idWharhouse.country);
      tel = phoneUtil.format(tel, PNF.E164);
      if (tel) {
        const whatsappLink = ` https://wa.me/${tel}`;
        window.open(whatsappLink, '_blank');
      } else {
        return this.$toast.warning(`Invalid phone number: ${customer.phone}`);
      }
    },
    checkDataByType(action, data) {
      if (action === 'variantes') {
        let res = null;
        const dataVra = data.find(
          item =>
            this.idWharhouse &&
            this.idWharhouse.country &&
            item.warehouse &&
            item.warehouse.country === this.idWharhouse.country,
        );
        if (dataVra.variantes && dataVra.variantes.length > 0)
          res = dataVra.variantes;
        return res;
      }
    },
    checkDataStock(data) {
      let res = 0;
      if (data.variantes && data.variantes.length > 0)
        res = data.variantes.reduce(
          (n, { quantity }) => n + parseInt(quantity.inStock),
          0,
        );
      else res = data.quantity.inStock;
      return res;
    },
    TotalPrice(name) {
      let Total = 0;
      if (name === 'Echange') {
        for (const element of this.newShipp.echange.data.details) {
          Total += element.unitPrice * element.quantity;
        }
        this.newShipp.echange.data.totalPrice = Total;
      }
      return Total;
    },
    addQuantity(index, name) {
      if (name === 'Echange')
        this.newShipp.echange.data.details[index].quantity++;
    },
    removeQuantity(index, name) {
      if (name === 'Echange') {
        if (this.newShipp.echange.data.details[index].quantity <= 1) {
        } else this.newShipp.echange.data.details[index].quantity--;
      }
    },
    removeProduct(data, index, name) {
      this.$confirm(this.$t('confirm_delete_product')).then(async res => {
        if (name === 'Echange') {
          var index = this.newShipp.echange.data.details.findIndex(function(o) {
            return o.product._id === data.product._id;
          });
          if (index !== -1) this.newShipp.echange.data.details.splice(index, 1);
          data.product.check = false;
        }
        alert(this.$t('product_deleted'), 'success');
      });
    },
    selectAutoVariant(data, id) {
      data.check = true;
      let column = document.querySelector('.product-' + id);
      column.checked = true;
      this.addProductsToTemp(data, id, 'Echange');
    },
    addProductsToTemp(data, id) {
      if (data.check) {
        if (
          data.details.length > 0 &&
          data.details[0].variantes &&
          data.details[0].variantes.length > 0 &&
          !data.source
        ) {
          this.$toast.warning('Svp sélectionner une variante');
          data.check = false;
          let column = document.querySelector('.product-' + id);
          column.checked = false;
          return false;
        }

        var detail = { product: data, unitPrice: 0, quantity: 1 };

        if (data.category) {
          if (data.category._id) {
            detail.category = data.category._id;
          }
        }

        let found = 0;

        if (name === 'Echange') {
          if (
            data.seller.toString() !==
            this.newShipp.echange.data.seller._id.toString()
          ) {
            alert(this.$t("Seller don't have this product"), 'warning');
            return false;
          }

          for (let i = 0; i < this.newShipp.echange.data.details.length; i++) {
            if (this.newShipp.echange.data.details[i].product._id == data._id) {
              if (
                (!this.newShipp.echange.data.details[i].product.source &&
                  !this.newShipp.echange.data.details[i].variante) ||
                (this.newShipp.echange.data.details[i].product.source &&
                  this.newShipp.echange.data.details[i].product.source.id ===
                    data.source.id) ||
                (this.newShipp.echange.data.details[i].variante &&
                  this.newShipp.echange.data.details[i].variante.id ===
                    data.source.id)
              ) {
                found = found + 1;
                this.numberItemRepeated = this.numberItemRepeated + 1;
              }
            }
          }
        }

        if (found < 1) {
          this.productselected.push(detail);
        }
      } else {
        let pos = this.productselected
          .map(function(e) {
            return e.product._id;
          })
          .indexOf(data._id);
        this.productselected.splice(pos, 1);
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    ConfirmOperation(name) {
      let fount = 0;
      for (let i = 0; i < this.productselected.length; i++) {
        if (name === 'Echange')
          this.newShipp.echange.data.details.push(this.productselected[i]);
      }
      this.productselected = [];
      if (this.numberItemRepeated > 0)
        alert(this.$t('product_already_added'), 'success');
      this.numberItemRepeated = 0;
      let modalId = 'getProducts';
      this.$vm2.close(modalId);
    },
    async getProducts(name) {
      if (this.newShipp.echange.data.seller) {
        const filters = {
          seller: this.newShipp.echange.data.seller._id,
          'details.warehouse': this.idWharhouse._id,
          limit: 1000,
        };
        const { content: res } = await this.$server.search('products', filters);
        if (res && res.results) {
          this.products = res.results;
          for (let i in this.products) {
            this.products[i].seller = this.products[i].seller._id;
            const resProductW = this.getElementInArray(
              this.products[i].details.filter(function(obj) {
                return obj.warehouse;
              }),
              this.idWharhouse._id,
            );
            if (resProductW && resProductW.price)
              this.products[i].price = resProductW.price;
          }
        } else this.products = [];
      }
      if (this.products.length > 0) {
        this.$vm2.open('getProducts');
      } else {
        if (this.currentUser.type != 'Seller')
          alert(this.$t('no_products_seller'), 'warning');
        else alert(this.$t('no_product_added'), 'warning');
      }
    },
    async ChangeStatus(dataToEdit, index, table) {
      dataToEdit.updateIntable = true;
      this.paymentData.loading = true;
      this.paymentData.index = index;
      const data = await this.$server.update(table, dataToEdit);
      this.paymentData.loading = false;
      if (data && data._id) {
        alert(table + ' updated', 'success');
      } else alert(data, 'warning');
    },
    getCourierClass(courier) {
      if (courier) {
        switch (courier.fullName.toUpperCase()) {
          case 'MAYLERZ':
            return 'maylerz';
          case 'CATHEDIS':
            return 'cathedis';
          case 'OZON EXPRESS':
            return 'ozon';
          case 'ARAMEX':
            return 'aramex';
          case 'AMEEX':
            return 'ameex';
          case 'ALTHIQUA':
            return 'althiqua';
          case 'SPEEDSHIP':
            return 'speedship';
          case 'DIGYLOG':
            return 'digylog';
          case 'RUSHLIV':
            return 'rushliv';
          default:
            return 'unkonwn';
        }
      }
      return 'unkonwn';
    },
    isNumeric(value) {
      return /^-?\d+$/.test(value);
    },
    DataParse(data) {
      if (typeof data !== 'undefined') {
        return JSON.parse(data);
      }
      return '';
    },
    searchShippByTrack_01: _.debounce(async function(e, name) {
      if (typeof this.searchTextShipp !== 'undefined' && this.searchTextShipp) {
        this.newShipp.loading = true;
        var { content: res } = await this.$server.get('shippings', {
          country: this.idWharhouse.country,
          trackingNumber: this.searchTextShipp.trim(),
        });
        this.newShipp.loading = false;
        if (res && res._id) {
          if (name === 'Refund') this.newShipp.refund.data = res;
          if (name === 'Echange') {
            if (res.status !== 'delivered' || JSON.parse(res.isProcessed)) {
              this.$toast.warning(
                'Echange seulement pour les orders delivered non processaid',
              );
              this.searchTextShipp = '';
              return false;
            }
            res.details = [];
            this.newShipp.echange.data = res;
          }
        } else {
          if (name === 'Refund') this.newShipp.refund.data = null;
          if (name === 'Echange') this.newShipp.echange.data = null;
        }
        this.searchTextShipp = '';
      }
    }, 500),
    colorStatus(status) {
      switch (status) {
        case 'to prepare':
          return 'color: rgb(233 147 19); border-color: rgb(233 147 19);';
        case 'prepared':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'shipped':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'delivered':
          return 'color:rgb(58 217 18); border-color: rgb(58 217 18);';
        case 'paid':
          return 'color:rgb(34, 150, 78); border-color: rgb(34, 150, 78);';
        case 'refunded':
          return 'color:rgb(150 15 227); border-color: rgb(150 15 227);';
        case 'processed':
          return 'color:rgb(10 10 10); border-color: rgb(10 10 10);';
        case 'cancelled':
          return 'color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);';
        case 'reprogram':
          return 'color: rgb(49, 120, 115); border-color: rgb(49, 120, 115);';
        case 'interested':
          return 'color: rgb(30, 144, 255); border-color: rgb(30, 144, 255);';
        case 'picked up':
          return 'color: rgb(75, 0, 130); border-color: rgb(75, 0, 130);';
        default:
          return 'color: rgb(0, 0, 0); border-color: rgb(0, 0, 0);';
      }
    },
    countDown(timer = null) {
      var self = this;
      if (timer) this.timer = timer;
      else this.timer = 0;

      var downloadTimer = setInterval(function() {
        if (self.paginate.total <= 500) self.timer += 10;
        if (self.paginate.total <= 1000 && self.paginate.total > 500)
          self.timer += 20;
        if (self.paginate.total > 1000) self.timer += 100;

        if (self.timer >= self.paginate.total) {
          self.timer = self.paginate.total;

          clearInterval(downloadTimer);
        }
      }, 1000);
    },
    getPriceByZone(zone, array) {
      let price = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].zone.toString() === zone.toString()) {
          price = array[i].price;
          break;
        }
      }
      return price;
    },
    getAccessUser(modelToCheck, accessToCheck) {
      if (this.currentUser && this.currentUser.role) {
        const permissions = this.currentUser.role.permissions;
        for (let i in permissions) {
          let model = permissions[i]['model'];
          let access = permissions[i]['access'];
          if (model == modelToCheck) {
            return access[accessToCheck];
          }
        }
      } else return false;
    },
    async getFeesShippBycity(seller = null, city) {
      this.feesShipp = { price: 0 };
      const res = await this.$server.search('zones', { cities: city });
      if (res.content.results) {
        this.feesShipp.price = res.content.results[0].price;
        this.feesShipp._id = res.content.results[0]._id;
        if (seller && seller.fees && seller.fees.length > 0) {
          const currentSettingSeller = this.getElementInArray(
            seller.fees,
            this.idWharhouse._id,
          );
          if (
            currentSettingSeller &&
            currentSettingSeller.shippingzones &&
            currentSettingSeller.shippingzones.length > 0
          ) {
            this.feesShipp.price = this.getPriceByZone(
              res.content.results[0]._id,
              currentSettingSeller.shippingzones,
            );
          }
        }
      }
    },
    async getCities() {
      const resCities = await this.$server.get('zones', {
        allCities: true,
        country: await this.warhouseSelected,
      });
      if (resCities.content.length > 0) this.cities = resCities.content;
      else this.cities = [];
    },
    activate: function(el) {
      this.expeditionData.setting[el] = !this.expeditionData.setting[el];
    },
    activateWarehouse: function(el) {
      this.checkWarehousingParent.forEach(function(warehouse) {
        if (warehouse._id.toString() == el._id.toString())
          warehouse.fullOf = true;
        else warehouse.fullOf = false;
      });
      this.expeditionData.warhouseParent.warehouse = el;
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    async getWarehouses() {
      const filter = { limit: 1000, is_primary: true };
      const res = await this.$server.search('warehouses', filter);
      if (res.content.results) {
        this.warehouses = res.content.results;
      } else this.warehouses = [];
    },
    setSelectedWharhouse(warehouse) {
      if (warehouse) {
        this.ChangeQte.warehouse = warehouse;
      }
    },
    away() {
      this.open = false;
    },
    awayLimit() {
      this.openLimit = false;
    },
    exceptText(text) {
      if (text && text.length > 40) text = text.substring(0, 40) + '...';
      return text;
    },
    serchsellerFilter() {
      this.debounce(function() {}, 500);
    },
    debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let warhouse = o.warehouse;
        if (o.warehouse._id) warhouse = o.warehouse._id;
        return warhouse == value.toString();
      });
      return result ? result[0] : null;
    },
    closePopup(name) {
      this.$vm2.close(name);
    },
    changedQte(event) {
      this.checkQte = false;
      if (
        this.ChangeQte.operation == 'Subtraction' &&
        parseInt(ExistWarhouse.quantity.inStock) <
          parseInt(this.ChangeQte.quantity)
      ) {
        this.checkQte = true;
      }
      if (
        this.ChangeQte.operation == 'Subtraction' &&
        parseInt(ExistWarhouse.quantity.total) <
          parseInt(this.ChangeQte.quantity)
      ) {
        this.checkQte = true;
      }
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    isEmpty(value) {
      if (value == null || value == '' || value == ' ') return true;
      else return false;
    },
    async getCurrentCourierZone() {
      if (this.shipping._id) {
        const filter = {
          type: 'Courier',
          zones: this.shipping.zone._id,
        };
        const res = await this.$server.search('users', filter);
        if (res.content.results) {
          this.courier = res.content.results;
        } else this.courier = [];
      }
    },
    async CheckDataShip(item) {
      if (item._id) {
        const editData = await this.$server.get('shippings', {
          order: item._id,
        });
        if (editData.content._id) {
          this.shipping = editData.content;
        } else {
          const nDate = new Date().toLocaleString('en-US', {
            timeZone: 'Africa/Casablanca',
          });
          let newdate = new Date(nDate);
          this.shipping = {};
          this.shipping.order = item._id;
          this.shipping.seller = item.seller;
          this.shipping.status = 'to prepare';
        }
      }
    },
    async getCourierZone(event) {
      this.courier = [];
      const filter = {
        type: 'Courier',
        zones: event.target.options[event.target.options.selectedIndex].id,
      };
      const res = await this.$server.search('users', filter);
      if (res.content.results) {
        this.courier = res.content.results;
      } else this.courier = [];
    },
    formattedDate(date, name) {
      let format = 'DD-MM-YYYY HH:mm';
      if (this.config.name == 'shippings' || this.config.name == 'products') {
        format = 'DD-MM-YYYY';
        if (this.config.name == 'shippings' && name === 'createdAt')
          format = 'DD-MM-YYYY HH:mm';
      }
      var date = this.$moment(date).format(format);
      if (date == 'Invalid date') return null;
      else return date;
    },
    async removeWarehousesProduct() {
      if (this.productData.selectWarehouses.length == 0) {
        alert('Select warehouses !!!', 'warning');
        return false;
      }
      await this.remove(
        this.productData.id,
        this.productData.selectWarehouses.map(i => i._id),
        this.productData.warehouses.map(i => i._id),
      );
    },
    setMessageRef(ind, indd) {
      return (el) => {
        if (ind === Object.entries(this.orderData.data.messages).length - 1 && indd === this.orderData.data.messages[ind].length - 1) {
          this.lastMessageRef = el; // Store the last message element
        }
      };
    },
    async emitFunction(action, id, data) {
      if (action === 'delete') {
        if (this.config.name == 'products') {
          if (data.details.length > 1) {
            this.productData.warehouses = data.details.map(i => i.warehouse);
            this.productData.id = id;
            this.$vm2.open('ModaldeleteProduct');
          } else this.remove(id);
        } else this.remove(id);
      }
      if (action === 'print') {
        this.generatePdf(id, data);
      }
      if (action === 'refresh') {
        this.oldData.data = data;
        data.refreshcChronodiali = true;
        this.oldData.loading = true;
        const dataUPP = await this.$server.update('shippings', data);
        this.oldData.loading = false;
        if (dataUPP && dataUPP._id) {
          const findItemOrder = this.data.findIndex(
            o => o._id.toString() === dataUPP._id.toString(),
          );
          if (findItemOrder != -1) {
            this.data[findItemOrder].externalId = dataUPP.externalId;
          } else
            return alert(
              'Une error est produit refresh page svp et try again',
              'warning',
            );
          return alert('Order send to Chronodiali', 'success');
        } else {
          return alert(
            Array.isArray(dataUPP)
              ? dataUPP.toString()
              : dataUPP.error
              ? dataUPP.error.message || dataUPP.error
              : dataUPP,
            'warning',
          );
        }
      }
      if (action === "messages") {
        this.orderData.data = data;
        this.orderData.loading = true;
         this.orderData.loading = false;

         this.orderData.data.messages = this.groupedMessage(this.orderData.data.messages);

         this.orderData.message = "";
         this.$vm2.open('chatMessages');
         
          this.scrollToLastMessage();
         
       }
      
    },
    scrollToLastMessage() {
  this.$nextTick(() => {
    const container = this.$refs.msgContainer;
    if (container) {
      // Force reflow
      container.style.overflow = 'hidden';
      container.scrollTop = container.scrollHeight;
      container.style.overflow = 'auto';
    }
  });
},

    groupedMessage(data) {
      let finalObj = {}
      if (Array.isArray(data)) {
        data.forEach((games) => {
          games.__v = this.$moment(games.date).format('HH:mm a');
          const date = this.$moment(games.date).lang("fr").format('LL');
          if (finalObj[date]) {
            finalObj[date].push(games);
          } else {
            finalObj[date] = [games];
          }
        })
        return finalObj;
      } else return data

    },
    CloseModal(name, isSave = null) {
      if (this.orderData.loading) return false;
      if(this.orderData.loading) return false;

      this.$vm2.close(name);
      this.orderData.picture="";

      // if (name === 'modalConfirm' && !isSave) {
      //   this.$toast.warning("La commande pas ajouter dans la listes");
      //   this.newShipp.enterLivruers.newStatus = "reprogrammer"
      //   this.newShipp.enterLivruers.data = null
      //   return false;
      // }
    },
    OpenModal(name) {
      this.$vm2.open(name);
    },

    addMessageTriger() {
      this.addMessage(this.config.name, 'message');
      this.scrollToLastMessage(); 

    },

    async addMessage(name, type) {
  if (name === 'orders') {
    if (!this.orderData.message && type === 'message') return false;

    if (!this.orderData.picture && type === 'image') {
      this.$toast.warning("No image upload");
      return false;
    }

    if (this.orderData.picture && type === 'image' && !this.checkSize('chat')) {
      this.$toast.warning("la taille de image doit pas dépasser 500 ko !!");
      return false;
    }

    if (!this.orderData.data._id) {
      this.$toast.warning("order data not Found");
      return false;
    }

    this.orderData.loading = true;
    let bodyData = {
      _id: this.orderData.data._id,
      message: this.orderData.message,
      type: type === 'image' ? 'image' : 'text',
    };

    if (type === 'image') {
      bodyData.picture = this.orderData.picture;
    }
    const data = await this.$server.addMessage("orders", bodyData);
    this.orderData.loading = false;

    if (data && data._id) {
      this.orderData.data.messages = this.groupedMessage(data.messages);
      await this.markMessagesAsRead("orders",this.orderData.data);
      this.orderData.message = "";
      if (type === 'image') this.CloseModal('ImageMessages');
      this.scrollToLastMessage(); 
    } else return this.$toast.warning(data);
  }

  if (name === 'shippings') {
    if (!this.orderData.message && type === 'message') return false;

    if (!this.orderData.picture && type === 'image') {
      this.$toast.warning("No image upload");
      return false;
    }

    if (this.orderData.picture && type === 'image' && !this.checkSize('chat')) {
      this.$toast.warning("la taille de image doit pas dépasser 500 ko !!");
      return false;
    }

    if (!this.orderData.data._id) {
      this.$toast.warning("order data not Found");
      return false;
    }

    this.orderData.loading = true;
    let bodyData = {
      _id: this.orderData.data._id,
      message: this.orderData.message,
      type: type === 'image' ? 'image' : 'text',
    };

    if (type === 'image') {
      bodyData.picture = this.orderData.picture;
    }
    const data = await this.$server.addShippingMessage("shippings", bodyData);
    this.orderData.loading = false;

    if (data && data._id) {
      this.orderData.data.messages = this.groupedMessage(data.messages);
      await this.markMessagesAsRead("shippings",this.orderData.data);

      this.orderData.message = "";
      if (type === 'image') this.CloseModal('ImageMessages');
      this.scrollToLastMessage(); 
    } else return this.$toast.warning(data);
  }
},


async markMessagesAsRead(name,order) {  
  try {
    if (!order || !order._id || !order.messages || typeof order.messages !== 'object') {
      console.error("Invalid order data");
      return;
    }

    const unreadMessages = [];
    
    // Iterate through each date group in messages
    Object.values(order.messages).forEach(dateMessages => {
      // Check if dateMessages is an array
      if (Array.isArray(dateMessages)) {
        // Filter unread messages from this date
        const unreadInDate = dateMessages.filter(message => {
          if (!message || !message.access) {
            console.warn("Invalid message object:", message);
            return false;
          }
          // Check if message is unread and from another user
          return !message.access.vue && message.access._id !== this.currentUser._id;
        });
        
        unreadMessages.push(...unreadInDate);
      }
    });
    if ( name === 'orders' && unreadMessages.length > 0) {
      // Mark the unread messages as read
      const dataOrder = await this.$server.markOrderMessagesAsRead("orders", {
        _id: order._id,
        messageIds: unreadMessages.map(message => message._id),
        user: this.currentUser,
      });

      if (dataOrder) {
        // Update the messages in the UI
        order.messages = this.groupedMessage(dataOrder.messages);
        order.Nb_views = 0;
      }
    }

    if (name === 'shippings' && unreadMessages.length > 0) {
      const dataShipping = await this.$server.markShippingMessagesAsRead("shippings", {
        _id: order._id,
        messageIds: unreadMessages.map(message => message._id),
        user: this.currentUser,
      });

      if (dataShipping) {
        order.messages = this.groupedMessage(dataShipping.messages);
      }
    }
  } catch (error) {
    console.error("Error marking messages as read:", error);
    this.$toast.warning("Failed to mark messages as read. Please try again.");
  }
},


    paginatation: function(val) {
      this.$emit('paginatation', val);
    },
    refresh: function() {
      this.$emit('refresh');
    },
    reset: function(val) {
      (this.newShipp = {
        echange: {
          oldTrack: null,
          newTrack: null,
          type: 'Echange track',
          types: ['Echange track', 'Echange shipping'],
          data: { details: [] },
        },
        status: null,
        shippings: [],
        tabId: [],
        loading: false,
        refund: {
          data: null,
        },
        shipper: { datas: [], company: null },
      }),
        document.querySelectorAll('.rowCheckbox').forEach(column => {
          column.checked = false;
        });
      this.$emit('reset', val);
    },
    filtrer: function(val) {
      this.$emit('filtrer', val);
    },
    search: function(val) {
      this.$emit('search', val);
    },
    showSousTable: function(val) {
      this.$emit('showProducts', val);
    },
    CheckQteDefecteuse: function(val) {
      this.$emit('CheckQteDefecteuse', val);
    },
    CheckQteReturned: function(val) {
      this.$emit('CheckQteReturned', val);
    },
    CheckQteDefecteuseOrder: function(val) {
      this.$emit('CheckQteDefecteuseOrder', val);
    },
    CheckQteSentExist: function(val) {
      this.$emit('CheckQteSentExist', val);
    },
    generateListPdf: function() {
      this.$emit('generateListPdf');
    },
    downloadAnalytics: function() {
      this.$emit('downloadAnalytics');
    },
    downloadCsv: function() {
      if (this.config.name == 'orders') this.$emit('downloadOrders');
      if (this.config.name == 'shippings') this.$emit('downloadShippings');
    },
    downloadExcel: async function() {
      var nameTable = 'shippings';
      if (this.config.name == 'orders') nameTable = 'orders';
      if (this.config.name == 'expeditions') nameTable = 'expeditions';

      var htmls = '';
      var uri = 'data:application/vnd.ms-excel;base64,';

      var template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';

      var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };

      var format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      };

      let table = document.getElementById('p-table');
      if (
        nameTable == 'shippings' ||
        nameTable == 'orders' ||
        nameTable == 'expeditions'
      ) {
        this.dataExcel.data = [];
        table = '';

        let dataCities = [];
        this.dataExcel.loading = true;

        let filters = { country: this.idWharhouse.country };

        if (this.$f.QueryStringToobject()) {
          filters = this.$f.QueryStringToobject();
        }

        filters.country = this.idWharhouse.country;

        if (this.config.name == 'orders') {
          filters['customer.country'] = this.idWharhouse.country;
          delete filters.country;

          if (
            filters['customer.city'] &&
            (typeof filters['customer.city'] === 'undefined' ||
              (typeof filters['customer.city'] === 'string' &&
                filters['customer.city'] === 'undefined'))
          ) {
            delete filters['customer.city'];
          }
        }

        if (this.config.name == 'expeditions') {
          filters.country_to = this.idWharhouse.country;
          delete filters.country;
        }

        var itemsCounts = 1000;
        filters.limit = itemsCounts;
        filters.page = 1;

        var count = Math.ceil(this.paginate.total / itemsCounts);
        var close = false;

        for (var i = 0; i < count; i++) {
          if (close) return;
          const { content } = await this.$server.search(
            this.config.name,
            filters,
          );
          const resAllshipp = content.results || [];

          if (resAllshipp) {
            this.timer += resAllshipp.length;
            filters.page++;

            if (this.config.name == 'shippings') {
              for (const shipp of resAllshipp) {
                if (shipp.orderObjet && shipp.orderObjet.feesShipp == -1) {
                  let priceCity = 0;
                  if (
                    shipp.orderObjet.customer &&
                    shipp.orderObjet.customer.city
                  ) {
                    if (
                      !dataCities.find(
                        o =>
                          o.name ===
                          shipp.orderObjet.customer.city.toLowerCase(),
                      )
                    ) {
                      const res = await this.$server.search('zones', {
                        cities: shipp.orderObjet.customer.city.toLowerCase(),
                      });

                      if (res.content.results) {
                        priceCity = res.content.results[0].price;
                        if (
                          shipp.seller &&
                          shipp.seller.fees &&
                          shipp.seller.fees.length > 0
                        ) {
                          const currentSettingSeller = this.getElementInArray(
                            shipp.seller.fees,
                            this.idWharhouse._id,
                          );

                          if (
                            currentSettingSeller &&
                            currentSettingSeller.shippingzones &&
                            currentSettingSeller.shippingzones.length > 0
                          ) {
                            priceCity = this.getPriceByZone(
                              res.content.results[0]._id,
                              currentSettingSeller.shippingzones,
                            );
                          }
                        }
                      }

                      dataCities.push({
                        name: shipp.orderObjet.customer.city.toLowerCase(),
                        price: priceCity,
                      });
                    } else {
                      priceCity = dataCities.find(
                        o =>
                          o.name ===
                          shipp.orderObjet.customer.city.toLowerCase(),
                      ).price;
                    }
                  }

                  shipp.orderObjet.feesShipp = priceCity;
                }
              }
            }

            if (this.config.name == 'orders') {
              const orderIds = resAllshipp
                .filter(
                  ({ status }) =>
                    status && ['To fulfill', 'Confirmed'].includes(status.name),
                )
                .map(({ _id }) => _id);

              if (orderIds.length > 0) {
                const {
                  content: { results: shippings = [] } = {},
                } = await this.$server.search('shippings', {
                  ids: orderIds,
                  limit: 300,
                });

                const shippingStatusMap = shippings.reduce(
                  (map, { order, status, trackingNumber }) => {
                    if (order && order._id && status && trackingNumber) {
                      map[order._id] = { status, trackingNumber };
                    }
                    return map;
                  },
                  {},
                );

                resAllshipp.forEach(order => {
                  const shippingData = shippingStatusMap[order._id];
                  if (shippingData) {
                    const { status, trackingNumber } = shippingData;
                    order.trackingNumber = trackingNumber;
                    order.shippingStatus = status;
                  }
                });
              }
            }

            this.dataExcel.data.push(...resAllshipp);
          } else close = true;

          if (close) {
            this.timer = 0;
            this.dataExcel.loading = false;
            alert(
              'An error occurred, please reload the page and try again !!',
              'error',
            );
          }
        }

        if (this.dataExcel.data.length > 0) {
          this.timer = 0;
          this.dataExcel.loading = false;

          if (this.config.name == 'shippings') {
            table = `
            <table id="p-table" class="table w-full text-left whitespace-no-wrap">
              <thead class="bg-gray-200">
                <tr class="text-left">
                  <th class="border p-1 text-center ">${this.$t(
                    'order_id',
                  )}</th>
                  <th class="border p-1 text-center ">${this.$t('seller')}</th>
                  <th class="border p-1 text-center ">${this.$t(
                    'shipping_address',
                  )}</th>
                  <th class="border p-2 text-center">${this.$t(
                    'shipping_date',
                  )}</th>
                  <th class="border p-2 text-center">${this.$t('customer')}</th>
                  <th class="border p-2 text-center">${this.$t('phone')}</th>
                  <th class="border p-2 text-center">${this.$t('city')}</th>
                  <th class="border p-2 text-center">${this.$t(
                    'shipping_fees',
                  )}</th>
                  <th class="border p-2 text-center">${this.$t(
                    'order_products',
                  )}</th> 
                  <th class="border p-2 text-center">Quantites</th> 
                  <th class="border p-2 text-center">${this.$t(
                    'totalPrice',
                  )}</th>
                  <th class="border p-2 text-center">${this.$t(
                    'trakingnumber',
                  )}</th>
                  <th class="border p-2 text-center">${this.$t('status')}</th>`;

            if (this.currentUser.type !== 'Seller') {
              table += `<th class="border p-2 text-center">${this.$t(
                'Post confirmed',
              )}</th>`;
            }

            table += `</tr></thead><tbody>`;

            if (this.dataExcel.data.length == 0) {
              table += `<tr><th class="border p-3 bg-gray-100" colspan="12">${this.$t(
                'no_record_found',
              )}</th></tr>`;
            }

            for (const item of this.dataExcel.data) {
              table += `
              <tr class="text-center">
                <td class="border p-2 bg-primary-100">${
                  item.orderObjet ? item.orderObjet.id : ''
                }</td>
                <td class="border p-2 bg-primary-100">${
                  item.seller ? item.seller.company : ''
                }</td>
                <td class="border p-2"><span class="flex items-center">${item.address ||
                  ''}</span></td>
                <td class="border p-2"><span class="flex items-center">${this.$moment(
                  item.date,
                ).format('DD-MM-YYYY')}</span></td>
                <td class="border p-2"><span class="flex items-center">${
                  item.order.customer ? item.order.customer.fullName : ''
                }</span></td>
                <td class="border p-2"><span class="flex items-center">${
                  item.order.customer ? item.order.customer.phone : ''
                }</span></td>
                <td class="border p-2 bg-primary-100">${
                  item.orderObjet.customer ? item.orderObjet.customer.city : ''
                }</td>
                <td class="border p-2 bg-primary-100">${
                  item.orderObjet ? item.orderObjet.feesShipp : ''
                }</td>
                <td class="border p-2 bg-primary-100">${this.sumProduct(
                  item.order.details,
                )}</td>
                <td class="border p-2 bg-primary-100">${this.productsQuantities(
                  item.order.details,
                )}</td>
                <td class="border p-2 bg-primary-100">${
                  item.orderObjet ? item.orderObjet.totalPrice : ''
                }</td>
                <td class="border p-2 bg-primary-100">${item.trackingNumber ||
                  ''}</td>
                <td class="border p-2 bg-primary-100">${item.status ||
                  ''}</td>`;
              if (this.currentUser.type !== 'Seller') {
                table += `<th class="border p-2 text-center">
                    ${
                      item.orderObjet.teleConsultantConfirm
                        ? item.orderObjet.teleConsultantConfirm.fullName
                        : ''
                    }
                  </th>`;
              }
              table += ` </tr>`;
            }
          }

          if (this.config.name == 'orders') {
            table = `
            <table id="p-table" class="table w-full text-left whitespace-no-wrap">
                <thead class="bg-gray-200">
                  <tr class="text-left">
                    <th class="border p-1 text-center">${this.$t(
                      'order_id',
                    )}</th>
                    <th class="border p-1 text-center">${this.$t('seller')}</th>
                    <th class="border p-1 text-center">${this.$t(
                      'customer',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t('phone')}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'address',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t('city')}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'order_date',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'order_products',
                    )}</th> 
                    <th class="border p-2 text-center">Quantities</th> 
                    <th class="border p-2 text-center">${this.$t(
                      'totalPrice',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'comment',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t('status')}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'trakingnumber',
                    )}</th>
                    <th class="border p-2 text-center">${this.$t(
                      'statusshipping',
                    )}</th>
                  </tr>
                </thead>
            <tbody>`;

            if (this.dataExcel.data.length == 0) {
              table += `<tr><th class="border p-3 bg-gray-100" colspan="12">${this.$t(
                'no_record_found',
              )}</th></tr>`;
            }

            for (const item of this.dataExcel.data) {
              table += `
              <tr class="text-center">
                  <td class="border p-2 bg-primary-100">${item.id}</td>
                  <td class="border p-2 bg-primary-100">${
                    item.seller ? item.seller.company : ''
                  }</td>
                  <td class="border p-2"><span class="flex items-center">${
                    item.customer ? item.customer.fullName : ''
                  }</span></td>
                  <td class="border p-2"><span class="flex items-center">${
                    item.customer ? item.customer.phone : ''
                  }</span></td>
                  <td class="border p-2"><span class="flex items-center">${
                    item.customer ? item.customer.address : ''
                  }</span></td>
                  <td class="border p-2"><span class="flex items-center">${
                    item.customer ? item.customer.city : ''
                  }</span></td>
                  <td class="border p-2"><span class="flex items-center">${this.$moment(
                    item.date,
                  ).format('DD-MM-YYYY')}</span></td>
                  <td class="border p-2 bg-primary-100">${this.sumProduct(
                    item.details,
                  )}</td>
                  <td class="border p-2 bg-primary-100">${this.productsQuantities(
                    item.details,
                  )}</td>
                  <td class="border p-2 bg-primary-100">${item.totalPrice ||
                    ''}</td>
                  <td class="border p-2 bg-primary-100">${item.comment ||
                    ''}</td>
                  <td class="border p-2 bg-primary-100">${
                    item.status ? item.status.name : ''
                  }</td>
                  <td class="border p-2 bg-primary-100">${item.trackingNumber ||
                    ''}</td>
                  <td class="border p-2 bg-primary-100">${item.shippingStatus ||
                    ''}</td>
              </tr>`;
            }
          }

          if (this.config.name == 'expeditions') {
            table = `
              <table id="p-table" class="table w-full text-left whitespace-no-wrap">
                  <thead class="bg-gray-200">
                    <tr class="text-left">
                      <th class="border p-1 text-center">${this.$t('id')}</th>
                      <th class="border p-1 text-center">${this.$t(
                        'seller',
                      )}</th>
                      <th class="border p-1 text-center">${this.$t(
                        'transport_mode',
                      )}</th>
                      <th class="border p-2 text-center">${this.$t('from')}</th>
                      <th class="border p-2 text-center">${this.$t(
                        'expedition_date',
                      )}</th>
                      <th class="border p-2 text-center">${this.$t(
                        'products',
                      )}</th>
                      <th class="border p-2 text-center">${this.$t('fees')}</th>
                      <th class="border p-2 text-center">${this.$t(
                        'status',
                      )}</th> 
                    </tr>
                  </thead>
              <tbody>`;

            if (this.dataExcel.data.length == 0) {
              table += `<tr><th class="border p-3 bg-gray-100" colspan="12">${this.$t(
                'no_record_found',
              )}</th></tr>`;
            }

            for (const item of this.dataExcel.data) {
              table += `
                <tr class="text-center">
                    <td class="border p-2 bg-primary-100">${item.id}</td>
                    <td class="border p-2 bg-primary-100">${item.seller
                      .fullName || ''}</td>
                    <td class="border p-2"><span class="flex items-center">${
                      item.transportMode
                    }</span></td>
                    <td class="border p-2"><span class="flex items-center">${this.$f.getCountryNameByCode(
                      this.dataCountry,
                      item.country_to,
                    )}</span></td>
                    <td class="border p-2"><span class="flex items-center">${this.$moment(
                      item.date,
                    ).format('DD-MM-YYYY')}</span></td>
                    <td class="border p-2"><span class="flex items-center">${this.ProductGroupName(
                      item.details,
                    )}</span></td>
                    <td class="border p-2"><span class="flex items-center">${item.fees ||
                      0}</span></td>
                    <td class="border p-2 bg-primary-100">${item.status}</td>
                </tr>`;
            }
          }

          table += `</tbody> </table>`;
          let parser = new DOMParser();

          let doc = parser.parseFromString(table, 'text/html');
          table = doc.body;
        } else {
          this.dataExcel.loading = false;
        }
      }

      htmls = table.outerHTML;
      var ctx = {
        worksheet: nameTable,
        table: htmls,
      };

      var link = document.createElement('a');
      link.download = nameTable + '.xls';

      link.href = uri + base64(format(template, ctx));
      link.click();
    },
    ProductGroupName(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return '';
      }

      const product = data
        .filter(
          item =>
            item.product &&
            item.product.name &&
            item.quantity &&
            item.quantity.sent !== undefined &&
            item.quantity.received !== undefined,
        )
        .map(
          item =>
            `${item.product.name} (quantity sent: ${item.quantity.sent}, quantity received: ${item.quantity.received})`,
        )
        .join(' | ');

      return product;
    },
    sumQteProduct(data) {
      let sum = 0;
      for (let i in data) {
        sum = sum + data[i].quantity;
      }
      return sum;
    },
    sumProduct(data) {
      let product = '';
      for (let i in data) {
        if (data[i].product && data[i].product.name) {
          product += data[i].product.name;
          if (data.length - 1 != i) product += ' ,';
        }
      }
      return product;
    },
    productsQuantities(data) {
      let quantity = '';
      for (let product in data) {
        quantity += data[product].quantity;
        if (data.length - 1 != product) quantity += ' ,';
      }
      return quantity;
    },
    showPrConfirmOperationUpdateoducts: function(data, index) {
      this.$emit('ConfirmOperationUpdate', val);
    },
    selectAllCheckbox: function($event) {
      this.$emit('selectAllCheckbox', $event);
    },
    getRowDetail: function(data, id) {
      this.$emit('getRowDetail', data, id);
    },
    emtyTabId: function() {
      this.$emit('emtyTabId');
    },
    searchSellers: function(value, event) {
      this.$emit('searchSellers', value, event);
    },
    searchCouriers: function(value, type) {
      this.$emit('searchCouriers', value, type);
    },
    Changelimit: function(val) {
      this.openLimit = false;
      this.$emit('Changelimit', val);
    },
    setSelectedCity: function(id, city) {
      this.$emit('setSelectedCity', id, city);
    },
    closePopup(name) {
      this.$vm2.close(name);
    },
    async openPopup(name) {
      this.$vm2.open(name);
    },
    EmitMethodAction(action) {
      if (action == 'addPay') this.$router.push('/payments/new');

      if (action == 'printdInvoice') this.generatePdf();

      if (action == 'print') {
        const hasItemWithoutCourier = this.tabId.some(item => !item.courier);
        if (
          (hasItemWithoutCourier === true || this.tabId.length === 0) &&
          this.currentUser.type === 'Seller'
        ) {
          alert(
            "You should refrain from printing a delivery note if the order hasn't been sent to the shipping company for dispatch.",
            'warning',
          );
          return false;
        } else {
          this.generateListPdf();
          return false;
        }
      }

      if (action == 'changestatus') this.OpenClosePopupModal('open');

      if (action == 'printdDelivry') {
        const hasItemWithoutCourier = this.tabId.some(item => !item.courier);
        if (
          (hasItemWithoutCourier === true || this.tabId.length === 0) &&
          this.currentUser.type === 'Seller'
        ) {
          alert(
            "You should refrain from printing a delivery note if the order hasn't been sent to the shipping company for dispatch.",
            'warning',
          );
          return false;
        } else {
          this.generatePdf();
          return false;
        }
      }

      if (action == 'addPrd') {
        this.$router.push('/products/new');
      }

      if (action == 'addqte') {
        this.OpenClosePopupModal('open');
      }

      if (action == 'newOrder') {
        this.$router.push('/orders/new');
      }

      if (action == 'importOrders') {
        this.$router.push('/orders/import');
      }
    },
    async ConfirmReporte(action) {
      if (!this.postponed.date) {
        alert(
          this.config.name == 'shippings'
            ? this.$t('postponed_date_required')
            : 'Remind date required',
          'warning',
        );
        return false;
      }
      if (this.config.name == 'shippings') {
        this.postponed.status = 'postponed';
        this.loadingcreateShipp = true;
        const res = await this.$server.update('shippings', this.postponed);
        this.loadingcreateShipp = false;

        if (res) {
          this.closePopUpInformation(this.postponed.index);
          this.OpenClosePopupModalReporte('close', 'postponed');
          alert(this.$t('shippings_updated'), 'success');
        }
      } else {
        this.loadingcreateShipp = true;
        this.postponed.data.remind = this.postponed.date;

        if (this.postponed.comment)
          this.postponed.data.comment = this.postponed.comment;
        else delete this.postponed.data.comment;
        const data = await this.$server.update(
          this.config.name,
          this.postponed.data,
        );

        this.loadingcreateShipp = false;
        if (data && data._id) {
          this.OpenClosePopupModalReporte('close', 'postponed');
          this.closePopUpInformation(this.postponed.index, data);
          alert(this.config.title + ' updated', 'success');
        } else alert(data, 'warning');
      }
    },
    displayCourier() {
      this.showcourier = !this.showcourier;

      if (!this.showcourier) {
        this.change_status.courier = null;
        return;
      }

      const rushlivCourier = this.couriers.find(
        ({ fullName }) => fullName === 'RushLiv',
      );
      this.change_status.courier = rushlivCourier || null;
    },
    async confirmChange() {
      if (
        !this.change_status.statusTochange ||
        (this.config.name === 'orders' &&
          (!this.change_status.statusTochange ||
            (this.change_status.statusTochange &&
              !this.change_status.statusTochange.name)))
      ) {
        return alert(this.$t('no_status_selected'), 'warning');
      } else {
        if (this.config.name == 'orders') {
          this.tabId = this.tabId.map(el => ({
            id: el.order ? el.order._id : el.id,
            status: el.order ? el.order.status : el.status,
            seller: el.order ? el.order.seller._id : el.seller,
          }));

          if (
            this.tabId.filter(
              obj =>
                obj.status.name === 'Pending' ||
                obj.status.name === 'Unreached',
            ).length !== this.tabId.length &&
            this.change_status.statusTochange.name == 'Pending'
          ) {
            return alert(
              'Please sélectionner seulement les ordres de status Unreached or Pending traits !',
              'warning',
            );
          }
        }

        this.$confirm(
          `You are sure to do this action, Total orders to ${this.change_status
            .statusTochange.name || this.change_status.statusTochange} : ${
            this.tabId.length
          }`,
        ).then(async action => {
          if (action) {
            if (this.config.name === 'orders') {
              let message = null;
              var itemsCounts = 50;

              var count = Math.ceil(this.tabId.length / itemsCounts);
              var close = false;

              this.loadingChange = true;
              for (var o = 0; o < count; o++) {
                if (close) return;
                var s = this.tabId.slice(
                  o * itemsCounts,
                  o * itemsCounts + itemsCounts,
                );

                const data = {
                  ids: s,
                  status: this.change_status.statusTochange,
                  warhouse: this.idWharhouse._id,
                  country: this.idWharhouse.country,
                };

                const res = await this.$server.updateMany(
                  this.config.name,
                  data,
                );

                if (!res || (res && !res.nModified)) {
                  close = true;
                  message =
                    "Une erreur c'est produite svp essaie encore: " + res;
                }

                if (close) this.loadingChange = false;
              }

              this.loadingChange = false;
              if (message) return alert(message, 'warning');
              else {
                alert(this.$t('orders_updated'), 'success');
                this.open = false;

                this.change_status.statusTochange = '';
                this.emtyTabId();

                this.OpenClosePopupModal('close');
                await this.refresh();
              }
            } else {
              this.loadingChange = true;
              const data = {
                ids: this.tabId,
                status: this.change_status.statusTochange,
                courier: this.change_status.courier,
                warhouse: this.idWharhouse._id,
                country: this.idWharhouse.country,
              };

              if (
                this.change_status.courier &&
                this.shippingCompanies.includes(
                  this.change_status.courier.fullName.toUpperCase(),
                ) &&
                this.change_status.statusTochange.toUpperCase() === 'TO PREPARE'
              ) {
                const dispatchResult = await dispatchShipment(data);
                if (dispatchResult && dispatchResult.content.success) {
                  if (dispatchResult.content.success) {
                    this.$toast.success(dispatchResult.content.message);
                  }
                } else {
                  this.$toast(
                    dispatchResult.content.message ||
                      dispatchResult.content.exception,
                  );
                }

                this.loadingChange = false;
                this.open = false;

                this.change_status.statusTochange = '';
                this.change_status.courier = null;

                this.showcourier = false;
                this.emtyTabId();

                this.OpenClosePopupModal('close');
                await this.refresh();
              } else {
                const res = await this.$server.updateMany('shippings', data);
                this.loadingChange = false;

                if (res && !res.error) {
                  this.open = false;
                  this.change_status.statusTochange = '';

                  this.change_status.courier = null;
                  this.showcourier = false;

                  this.emtyTabId();
                  this.OpenClosePopupModal('close');

                  await this.refresh();
                  if (res.length > 0) {
                    if (res[0].message) {
                      this.$vm2.open('messages');
                      this.messagesInfo = res;
                    } else alert(res, 'warning');
                  } else alert(this.$t('shippings_updated'), 'success');
                } else alert(res.error ? res.error.message : res, 'warning');
              }
            }
          }
        });
      }
    },
    async confirmChangeQte() {
      this.ChangeQte.warehouse = this.idWharhouse;
      this.ChangeQte.seller = this.selectProduct.seller;

      let data = {
        _id: this.tabId[0],
        seller: this.selectProduct.seller,
        actionInstock: this.ChangeQte,
        dataWhrahouseSetting: this.expeditionData.dataWhrahouseSetting,
      };
      if (!this.ChangeQte.warehouse) {
        alert('Warehouse not detected (svp actualiser la page)', 'warning');
        return false;
      }
      if (
        this.expeditionData.setting.exist &&
        !this.expeditionData.setting.confirmation &&
        !this.expeditionData.setting.fulfillement &&
        !this.expeditionData.setting.shipping
      ) {
        alert('Les services de cette seller est obligatoir', 'warning');
        return false;
      }
      if (
        this.expeditionData.warhouseParent.exist &&
        !this.expeditionData.warhouseParent.warehouse
      ) {
        alert('Warehouse est obligatoir', 'warning');
        return false;
      }
      this.ChangeQte.loading = true;
      if (this.expeditionData.setting.exist) {
        this.ChangeQte.settings = this.expeditionData.setting;
        this.ChangeQte.settings.warehouse = this.ChangeQte.warehouse._id;
        data.dataWhrahouseSetting = this.expeditionData.setting;
      }
      if (this.expeditionData.warhouseParent.exist)
        this.ChangeQte.warhouseParent = this.expeditionData.warhouseParent.warehouse;

      const res = await this.$server.update('products', data);
      this.ChangeQte.loading = false;
      if (res) {
        //this.loading = false;
        this.checkSetting = null;
        (this.expeditionData.setting = {
          exist: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
          warehouse: null,
        }),
          (this.expeditionData.warhouseParent = {
            exist: false,
            warehouse: null,
          }),
          (this.ChangeQte = {
            operation: 'Addition',
            stock: 'inStock-total',
            quantity: 0,
            loading: false,
            warehouse: null,
            seller: null,
            warhouseParent: null,
            settings: null,
          });
        this.emtyTabId();
        this.OpenClosePopupModal('close');
        await this.refresh();
        alert(this.$t('product_updated'), 'success');
      }
    },
    getRowDetailShipp(item, id) {
      let itemInRow = this.tabId.filter(item => item.id === id);
      let isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        let pos = this.newShipp.tabId
          .map(function(e) {
            return e.id;
          })
          .indexOf(id);
        this.newShipp.tabId.splice(pos, 1);
      } else {
        this.newShipp.tabId.push({
          id: id,
          typeshipp: item.type,
          courier: item.courier,
          trackingNumber: item.trackingNumber,
          date: item.date,
          source: item.seller.source
            ? item.seller.source
            : item.seller.company || 'nosource',
          externalId: item.order.externalId || item.externalId,
          order: item.order._id,
          status: item.status,
          orderobjet: JSON.stringify(item.order),
        });
      }
      if (this.newShipp.tabId.length === 0) {
        let columns = document.querySelectorAll('.checkallbboxShipp');
        columns.forEach(column => {
          column.checked = false;
        });
      }
    },
    selectAllCheckboxShipp($event) {
      let columns = document.querySelectorAll('.rowCheckboxShipp');
      this.newShipp.tabId = [];
      if ($event.target.checked == true) {
        columns.forEach(column => {
          column.checked = true;
          this.newShipp.tabId.push({
            id: column.id,
            source: column.getAttribute('seller'),
            externalId: column.getAttribute('externalId'),
            courier: column.getAttribute('courier'),
            trackingNumber: column.getAttribute('trackingNumber'),
            date: column.getAttribute('date'),
            typeshipp: column.getAttribute('typeshipp'),
            order: column.getAttribute('order'),
            status: column.getAttribute('status'),
            orderobjet: column.getAttribute('orderobjet'),
          });
        });
      } else {
        columns.forEach(column => {
          column.checked = false;
        });
        this.newShipp.tabId = [];
      }
    },
    searchShippByTrack: _.debounce(async function(e) {
      if (typeof this.searchTextShipp !== 'undefined' && this.searchTextShipp) {
        const filters = {
          limit: 500,
          trackingNumber: this.searchTextShipp.trim(),
        };
        let index = this.newShipp.shippings.findIndex(
          element => element.trackingNumber === this.searchTextShipp,
        );

        if (index == -1) {
          this.newShipp.loading = true;
          const res = await this.$server.search('shippings', filters);
          this.newShipp.loading = false;
          if (res.content.results) {
            this.newShipp.shippings.push(res.content.results[0]);
            this.searchTextShipp = '';
          } else {
            alert('No data found', 'warning');
          }
        } else {
          this.searchTextShipp = '';
        }
      }
    }, 500),
    async EmitActionNewShipp(name) {
      if (name == 'Refund') {
        if (this.newShipp.refund.data) {
          if (this.newShipp.refund.data.refund) {
            alert('Cette order est deja remboursé !', 'warning');
            return false;
          }

          if (
            ['delivered']
              .toString()
              .indexOf(this.newShipp.refund.data.status) == -1
          ) {
            alert('Seulement pour les shipping delivered) !', 'warning');
            return false;
          } else {
            if (this.newShipp.refund.data.type != 'paid') {
              alert(
                'Seulement pour les shipping paid or processaid) !',
                'warning',
              );
              return false;
            }
          }

          this.$confirm(`You are sure to do this action`).then(async action => {
            if (action) {
              try {
                this.newShipp.loading = true;
                this.newShipp.refund.data.Isrefund = true;
                const res = await this.$server.create(
                  'shippings',
                  this.newShipp.refund.data,
                );

                this.newShipp.loading = false;
                if (res && res._id) {
                  this.OpenClosePopupModal('close', 'Refund');
                  alert('Shipping rembourser created', 'success');
                  let routeData = this.$router.resolve({
                    name: 'shippings',
                    query: {
                      name: res.trackingNumber,
                      country: this.idWharhouse.country,
                    },
                  });
                  this.newShipp.refund.data = null;
                  window.open(routeData.href, '_blank');
                } else alert(res, 'warning');
              } catch (error) {
                this.newShipp.loading = false;
                alert(error, 'warning');
              }
            }
          });
        } else
          alert(
            'Data order not found, please refresh page and try again !',
            'warning',
          );
      } else if (['Echange track', 'Echange shipping'].includes(name)) {
        if (name === 'Echange track') {
          if (!this.newShipp.echange.oldTrack) {
            alert('ANCIEN TRACKINGNUMBER is required !', 'warning');
            return false;
          }
          if (!this.newShipp.echange.newTrack) {
            alert('NOUVEAU TRACKINGNUMBER is required !', 'warning');
            return false;
          }
        } else {
          if (!this.newShipp.echange.data) {
            alert('data is required', 'warning');
            return false;
          }
          if (
            !['delivered'].includes(this.newShipp.echange.data.status) ||
            this.newShipp.echange.data.isProcessed
          ) {
            alert(
              "Seulement pour les shipping: (delivered non processed') !",
              'warning',
            );
            return false;
          }

          if (this.newShipp.echange.data.details.length === 0) {
            alert('Please select a product', 'warning');
            return false;
          }

          // if(!parseFloat(this.newShipp.echange.data.totalPrice)) {
          //     alert('Price order required !', 'warning');
          //     return false;
          // }
        }

        this.$confirm(`You are sure to do this action`).then(async action => {
          if (action) {
            try {
              this.newShipp.loading = true;
              const res = await this.$server.update('shippings', {
                echange: this.newShipp.echange,
              });
              this.newShipp.loading = false;
              if (res && res._id) {
                this.OpenClosePopupModal('close', 'Echange');
                alert(
                  name === 'Echange track'
                    ? 'Tracking updated avec success'
                    : 'Echange craeted avec success',
                  'success',
                );
                this.newShipp.echange.oldTrack = null;
                this.newShipp.echange.newTrack = null;
                this.newShipp.echange.data = { details: [] };
                let routeData = this.$router.resolve({
                  name: 'shippings',
                  query: {
                    name: res.trackingNumber,
                    country: this.idWharhouse.country,
                  },
                });
                window.open(routeData.href, '_blank');
              } else alert(res, 'warning');
            } catch (error) {
              this.newShipp.loading = false;
              alert(error, 'warning');
            }
          }
        });
      } else if (name == 'toShipp') {
        if (this.newShipp.shipper.datas.length > 0) {
          this.newShipp.loading = true;
          const data = {
            ids: this.newShipp.shipper.datas,
            company: this.newShipp.shipper.company,
            warhouse: this.idWharhouse._id,
            country: this.idWharhouse.country,
          };

          const res = await this.$server.updateMany('orders', data);
          this.newShipp.loading = false;
          if (res) {
            this.$toast(res);
            await this.refresh();
            alert('Orders send', 'success');
          } else alert(res, 'warning');
          this.$vm2.close('toShipp');
        } else alert('No Orders selected !', 'warning');
      } else {
        if (this.newShipp.tabId.length > 0) {
          this.loadingdatashipp = true;
          const data = {
            ids: this.newShipp.tabId,
            status: this.newShipp.status,
            warhouse: this.idWharhouse._id,
            country: this.idWharhouse.country,
          };

          const res = await this.$server.updateMany('shippings', data);
          this.loadingdatashipp = false;
          if (res) {
            this.newShipp.shippings = [];
            this.newShipp.status = null;
            await this.refresh();
            if (res.length > 0) alert(res, 'warning');
            else alert(this.$t('shippings_updated'), 'success');
            this.$vm2.close('ModalChangeStatusByDauchette');
            let columns = document.querySelectorAll('.checkallbboxShipp');
            columns.forEach(column => {
              column.checked = false;
            });
          }
          alert(res, 'warning');
        } else alert('No shippings selected !', 'warning');
      }
    },
    ClosePopupModal(name) {
      this.$vm2.close(name);
    },
    checkboxes() {
      return this.tabId.length;
    },
    async OpenClosePopupModal(action, method = '') {
      let modal_id = 'ModalChangeStatus';
      if (this.config.name == 'products') modal_id = 'ModalChangeQte';
      if (method === 'dauchette') modal_id = 'ModalChangeStatusByDauchette';
      if (method === 'Refund') modal_id = 'Refund';
      if (method == 'toShipp') modal_id = 'toShipp';
      if (method == 'Echange') modal_id = 'Echange';
      if (action === 'open') {
        if (
          method === 'dauchette' ||
          method === 'Refund' ||
          method === 'Echange'
        ) {
          if (
            method === 'Echange' &&
            this.newShipp.echange &&
            this.newShipp.echange.type === 'Echange track'
          ) {
            if (this.tabId.length > 0) {
              this.newShipp.echange.oldTrack = this.tabId[0].trackingNumber;
            } else {
              this.newShipp.echange.oldTrack = null;
            }
          }

          this.$vm2.open(modal_id);
        } else {
          if (this.tabId.length > 0) {
            if (
              this.config.name == 'orders' &&
              this.tabId.filter(function(order) {
                return order.order.status.name === 'Confirmed';
              }).length > 0
            ) {
              alert(
                `Please select seulment les orders non Confirmed`,
                'warning',
              );
              return false;
            }

            if (method == 'toShipp') {
              this.newShipp.shipper.datas = [];
              this.newShipp.shipper.datas = this.tabId;

              const resUss = await this.$server.search('users', {
                type: 'Courier',
                status: 'active',
                warehouseSettingsConfirmation: this.idWharhouse._id,
              });
              if (resUss && resUss.content) this.shippers = resUss.content;
            }

            this.$vm2.open(modal_id);

            if (
              this.config.name == 'products' &&
              modal_id === 'ModalChangeQte'
            ) {
              const resW = await this.$server.search('warehouses', {
                country: this.idWharhouse.country,
                limit: 100,
              });

              if (resW.content && resW.content.results) {
                this.checkWarehousingParent = resW.content.results.sort(
                  (a, b) => (a._id > b._id ? 1 : b._id > a._id ? -1 : 0),
                );
                this.checkWarehousingParent.forEach(x => {
                  x.fullOf = false;
                });
              } else this.checkWarehousingParent = [];

              this.checkSetting = this.getElementInArray(
                this.selectProduct.seller.settings,
                this.idWharhouse._id,
              );

              if (
                this.checkWarehousingParent.length > 1 ||
                !this.checkSetting ||
                (this.checkSetting &&
                  !this.checkSetting.confirmation &&
                  !this.checkSetting.fulfillement &&
                  !this.checkSetting.shipping)
              ) {
                if (
                  !this.checkSetting ||
                  (this.checkSetting &&
                    !this.checkSetting.confirmation &&
                    !this.checkSetting.fulfillement &&
                    !this.checkSetting.shipping)
                ) {
                  this.expeditionData.setting.exist = true;
                }

                if (this.checkWarehousingParent.length > 1) {
                  this.expeditionData.warhouseParent.exist = true;
                }
              }

              if (!this.expeditionData.setting.exist) {
                this.expeditionData.dataWhrahouseSetting = this.checkSetting;
              }
            }
          } else alert(`No ${this.config.name} selected !`, 'warning');
        }
      } else this.$vm2.close(modal_id);
    },
    OpenClosePopupModalReporte(action, method, Shipp = null, index = null) {
      if (Shipp) {
        this.postponed.data = Shipp;
        this.postponed._id = Shipp._id;
        this.postponed.seller = Shipp.seller;
        this.postponed.index = index;
        if (method == 'postponed') {
          let modal_id = 'ModalReporteShipp';
          if (action === 'open') {
            this.$vm2.open(modal_id);
          } else {
            this.$vm2.close(modal_id);
          }
        } else {
          //unrached shipping
          this.$confirm(this.$t('confirm_unreachable_shipping')).then(
            async res => {
              if (res) {
                if (this.postponed.seller) {
                  this.loadingcreateShipp = true;
                  const nDate = new Date().toLocaleString('en-US', {
                    timeZone: 'Africa/Casablanca',
                  });
                  let newdate = new Date(nDate);
                  this.postponed.date = newdate.setDate(newdate.getDate() + 1);
                  this.postponed.status = 'unreachable';
                  const data_ship = await this.$server.update(
                    'shippings',
                    this.postponed,
                  );
                  this.loadingcreateShipp = false;
                  if (data_ship && data_ship._id) {
                    this.postponed.date = null;
                    this.postponed.seller = null;
                    this.postponed.comment = undefined;
                    this.postponed.status = undefined;
                    this.closePopUpInformation(this.postponed.index);
                    alert(this.$t('shippings_updated'), 'success');
                  } else alert(data_ship, 'warning');
                } else {
                  alert('seller required', 'warning');
                }
              }
            },
          );
        }
      } else this.$vm2.close('ModalReporteShipp');
    },
    async ShowPopUpInformation(index, status = null, data = null) {
      if (data) this.oldData.data = data;
      if (this.config.name == 'statusHistories') return false;
      if (this.config.name == 'shippings') {
        if (
          data.orderObjet &&
          data.orderObjet.feesShipp &&
          data.orderObjet.feesShipp == -1
        )
          await this.getFeesShippBycity(data.seller, data.order.customer.city);
        this.CheckQteDefecteuse(data);
        this.CheckQteReturned(data);
        if (
          this.currentUser.type == 'Courier' &&
          (status == 'delivered' ||
            status == 'cancelled' ||
            status == 'processed')
        ) {
          return false;
        }
        // if (
        //   this.currentUser.type == 'StockManager' &&
        //   (status == 'delivered' ||
        //     status == 'shipped' ||
        //     status == 'processed')
        // ) {
        //   return false;
        // }
        if (this.currentUser.type == 'Accountant' && data.type == 'normal') {
          return false;
        }
        if (this.currentUser.type == 'Seller') {
          return false;
        }
      }
      if (
        this.config.name == 'expeditions' ||
        this.config.name == 'internalexpeditions'
      ) {
        this.CheckQteSentExist(data);
        if (data && data.arrivalDate)
          data.arrivalDate = this.$moment(data.arrivalDate).format(
            'yyyy-MM-DD',
          );
        if (
          !['Admin', 'CEO', 'Courier', 'StockManager'].includes(
            this.currentUser.type,
          )
        ) {
          if (this.currentUser.type === 'Seller') return false;
          else {
            if (!this.getAccess('update', status, null, true)) return false;
          }
        }
      }
      if (this.config.name == 'orders') {
        this.oldData.loading = true;

        if (data.feesShipp && data.feesShipp == -1)
          await this.getFeesShippBycity(data.seller, data.customer.city);
        this.CheckQteDefecteuseOrder(data);
        if (
          this.currentUser.type != 'Admin' &&
          this.currentUser.type != 'CEO' &&
          this.currentUser.type != 'TeleConsultant' &&
          this.currentUser.type != 'Accountant' &&
          this.currentUser.type != 'CallcenterManager'
        ) {
          if (
            this.currentUser.type == 'Seller' ||
            !this.getAccessUser('orders', 'update')
          ) {
            this.oldData.loading = false;
            return false;
          }
        }
        await this.CheckDataShip(data);
        index = data._id;
        data.reason_unreached = '';

        if (
          this.currentUser.type != 'Seller' &&
          data &&
          data.status &&
          data.status.name == 'Pending'
        ) {
          const CheckDataOrder = await this.$server.get('orders', {
            id: data._id,
          });

          if (CheckDataOrder.content && CheckDataOrder.content.upsel)
            data.upsel = CheckDataOrder.content.upsel;
          if (CheckDataOrder.content)
            data.teleConsultant = CheckDataOrder.content.teleConsultant;

          if (!data.teleConsultant) {
            data.teleConsultant = this.currentUser;
            data.setteleConsultant = true;
            data.onlyCommentedit = true;
            await this.$server.update('orders', data);
            delete data.setteleConsultant;
            delete data.onlyCommentedit;
          }
          this.oldData.data = data;
        }

        this.oldData.loading = false;
      }
      // await this.assign(index);
      let modal_id = 'modal1_' + index;

      //  this.$refs[modal_id][0].showModal();
      this.$vm2.open(modal_id);
    },
    async confirmChangeExpedition() {
      if (
        this.expeditionData.setting.exist &&
        !this.expeditionData.setting.confirmation &&
        !this.expeditionData.setting.fulfillement &&
        !this.expeditionData.setting.shipping
      ) {
        alert('Les services est obligatoir', 'warning');
        return false;
      }
      if (this.expeditionData.warhouseParent.exist) {
        //check warehouse if select
        for (
          let index = 0;
          index < this.expeditionData.data.details.length;
          index++
        ) {
          const expeditionLine = this.expeditionData.data.details[index];
          if (!expeditionLine.warehouseParent) {
            alert(
              `Warehouse est obligatoir pour ce produit : ${expeditionLine.product.name}`,
              'warning',
            );
            return false;
            break;
          } else
            expeditionLine.warehouseParentName =
              expeditionLine.warehouseParent.name ||
              expeditionLine.warehouseParent;
        }
      }

      // return false;
      this.expeditionData.loading = true;
      const data = await this.$server.update(
        'expeditions',
        this.expeditionData,
      );
      this.expeditionData.loading = false;
      if (data && data._id) {
        this.checkSetting = null;
        (this.expeditionData.setting = {
          exist: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
          warehouse: null,
        }),
          (this.expeditionData.warhouseParent = {
            exist: false,
            warehouse: null,
          }),
          this.$vm2.close('ModalChangeSetSettingsSeller');
        this.closePopUpInformation(this.expeditionData.model);
        alert('expeditions updated', 'success');
      } else alert(data, 'warning');
    },
    async ConfirmOperationUpdate(dataToEdit, index) {
      if (this.config.name == 'orders') {
        let query = Object.assign({}, this.$route.query);
        delete query.index;
        this.$router.replace({ query });
        if (dataToEdit.zone) {
          if (
            this.feesShipp &&
            this.feesShipp._id &&
            dataToEdit.zone.toString() != this.feesShipp._id.toString()
          )
            dataToEdit.zone = this.feesShipp._id;
        } else {
          if (this.feesShipp && this.feesShipp._id)
            dataToEdit.zone = this.feesShipp._id;
        }
      }
      if (this.config.name == 'shippings') {
        let statusTochange = dataToEdit.status;

        if (
          (dataToEdit.status == 'cancelled' ||
            dataToEdit.status == 'refused') &&
          dataToEdit.type == 'return'
        )
          statusTochange = 'Return';

        if (dataToEdit.status == 'delivered' && dataToEdit.type == 'paid')
          statusTochange = 'Paid';

        this.$confirm(
          'Are you sure to update status to ' + statusTochange,
        ).then(async res => {
          if (res) {
            dataToEdit.order.onlyCommentedit = true;
            this.loadingcreateShipp = true;
            await this.$server.update('orders', dataToEdit.order);
            delete dataToEdit.order.onlyCommentedit;

            if (
              dataToEdit.courier &&
              this.shippingCompanies.includes(
                dataToEdit.courier.fullName.toUpperCase(),
              ) &&
              dataToEdit.status.toUpperCase() === 'TO PREPARE'
            ) {
              const dispatchResult = await dispatchShipment(dataToEdit, true);
              if (dispatchResult && dispatchResult.content) {
                if (dispatchResult.content.success) {
                  this.$toast.success(dispatchResult.content.message);
                  this.closePopUpInformation(index);
                } else {
                  if (!dispatchResult.content.success) {
                    this.$toast.error(
                      dispatchResult.content.message.except ||
                        dispatchResult.content.exception ||
                        dispatchResult.content.message,
                    );
                  }
                }
              } else {
                this.$toast.warning(
                  dispatchResult.content.message ||
                    dispatchResult.content.exception,
                );
              }
            } else {
              const data = await this.$server.update(
                this.config.name,
                dataToEdit,
              );
              if (data && data._id) {
                this.closePopUpInformation(index);
                alert(this.config.title + ' updated', 'success');
              } else {
                alert(
                  data.error ? data.error.message || data.error : data,
                  'warning',
                );
                if (data.token)
                  dataToEdit.courier.apiShipping.token = data.token;
              }
            }
            this.loadingcreateShipp = false;
          }
          await this.refresh();
        });
      } else if (
        this.config.name == 'orders' &&
        dataToEdit.status.name &&
        dataToEdit.status.name == 'ToRemind'
      ) {
        dataToEdit.teleConsultant = null;
        dataToEdit.reminded = true;
        if (!dataToEdit.comment) dataToEdit.comment = '';
        dataToEdit.lastUnreachedDate = null;
        dataToEdit.remind = Date.now();
        //dataToEdit.timeConsumed = "0";
        dataToEdit.time = 0;
        dataToEdit.dateDebut = Date.now();
        this.postponed.data = dataToEdit;
        this.postponed._id = dataToEdit._id;
        this.postponed.seller = dataToEdit.seller;
        this.postponed.index = index;
        this.$vm2.open('ModalReporteShipp');
        //this.loadingcreateShipp=true;
        // dataToEdit.status = await this.getStatusByName('Pending');
        //     const data = await this.$server.update(this.config.name, dataToEdit);
        //     this.loadingcreateShipp=false;
        //    if (data && data._id) {
        //       this.closePopUpInformation(index);
        //       alert(this.config.title+" updated", "success");
        //     }else  alert(data, "warning");
      } else if (
        this.config.name == 'orders' &&
        dataToEdit.status.name &&
        dataToEdit.status.name == 'pending_unrached'
      ) {
        if (!dataToEdit.reason_unreached) {
          alert(`Reason unreached obligatoire`, 'warning');
          this.loadingcreateShipp = false;
          return false;
        }
        //return false;
        dataToEdit.teleConsultant = null;
        dataToEdit.dateUnrash = this.$momentTimezone
          .tz(this.$moment(), 'UTC')
          .format();
        dataToEdit.lastUnreachedDate = this.$momentTimezone
          .tz(this.$moment(), 'UTC')
          .format();
        const element = {
          user: this.currentUser._id,
          date: this.$momentTimezone.tz(this.$moment(), 'UTC').format(),
        };
        dataToEdit.unreachedBy.push(element);
        if (dataToEdit.remind != null) dataToEdit.isReminded = true;
        dataToEdit.dateDebut = this.$momentTimezone
          .tz(this.$moment(), 'UTC')
          .format();
        dataToEdit.pending_unrached = true;
        dataToEdit.comment = dataToEdit.reason_unreached;
        //dataToEdit.timeConsumed = "0";
        this.loadingcreateShipp = true;
        const data = await this.$server.update(this.config.name, dataToEdit);
        this.loadingcreateShipp = false;
        if (data && data._id) {
          this.closePopUpInformation(index, data);
          alert(this.config.title + ' updated', 'success');
        } else alert(data, 'warning');
      } else if (
        this.config.name == 'orders' &&
        dataToEdit.status.name &&
        dataToEdit.status.name == 'To fulfill'
      ) {
        this.loadingcreateShipp = true;
        if (!this.shipping._id) {
          if (!dataToEdit.customer.city) {
            alert(`City obligatoire`, 'warning');
            this.loadingcreateShipp = false;
            return false;
          }
          const checkDataShipp = await this.$server.get('orders', {
            id: this.shipping.order,
          });
          if (checkDataShipp.content.status.name == 'To fulfill') {
            this.loadingcreateShipp = false;
            alert('Shipping already created for this order !!', 'warning');
            await this.refresh();
            return false;
          }
          if (checkDataShipp.content.status.name != 'Fulfill OutOfStock') {
            this.loadingcreateShipp = false;
            alert(
              'La confirmation uniquement pour les orders Fulfill OutOfStock !!',
              'warning',
            );
            return false;
          }
          //check warehouse parent if city change
          if (dataToEdit.customer.city) {
            if (
              checkDataShipp.content.customer.city !=
                dataToEdit.customer.city ||
              !dataToEdit.zone
            ) {
              const resZone = await this.$server.search('zones', {
                cities: dataToEdit.customer.city,
              });
              if (resZone.content.results)
                dataToEdit.zone = res.content.results[0]._id;
            }
            if (dataToEdit.zone) {
              const resWarehouses = await this.$server.search('warehouses', {
                'zones.id': dataToEdit.zone,
                country: dataToEdit.customer.country,
                parent: true,
                is_primary: false,
              });
              if (resWarehouses.content.results)
                dataToEdit.warehousesParent = resWarehouses.content.results;
              else dataToEdit.warehousesParent = [];
            }
          }

          let dataWhrahouseSettingS = null;
          if (
            dataToEdit.seller &&
            dataToEdit.seller._id &&
            dataToEdit.seller.settings.length > 0
          )
            dataWhrahouseSettingS = this.getElementInArray(
              dataToEdit.seller.settings,
              this.idWharhouse._id,
            );

          //check stock if exist
          if (dataWhrahouseSettingS.fulfillement) {
            for (let index = 0; index < dataToEdit.details.length; index++) {
              const orderLine = dataToEdit.details[index];
              const product = await this.$server.get('products', {
                _id: orderLine.product._id,
              });
              let dataWhrahouse = this.getElementInArray(
                product.content.details,
                this.idWharhouse._id,
              );
              orderLine.warehouseParent = this.idWharhouse._id;
              orderLine.warehouseParentName = this.idWharhouse.name;

              if (
                dataToEdit.warehousesParent &&
                dataToEdit.warehousesParent.length > 0
              ) {
                const dtaW = this.getElementInArray(
                  product.content.details,
                  dataToEdit.warehousesParent[0]._id,
                );
                if (
                  dtaW &&
                  dtaW.quantity.inStock > 0 &&
                  orderLine.quantity <= dtaW.quantity.inStock
                ) {
                  dataWhrahouse = dtaW;
                  orderLine.warehouseParent =
                    dataToEdit.warehousesParent[0]._id;
                  orderLine.warehouseParentName =
                    dataToEdit.warehousesParent[0].name;
                }
              }
              if (
                (dataWhrahouse && dataWhrahouse.outOfStock) ||
                (dataWhrahouse &&
                  orderLine.quantity > dataWhrahouse.quantity.inStock) ||
                !dataWhrahouse
              ) {
                this.loadingcreateShipp = false;
                return alert(
                  `Quantité en stock insuffisante pour ce produit: ${product.content.name} !!`,
                  'warning',
                );
                break;
              }
            }
          }

          const data_order = await this.$server.update('orders', dataToEdit);

          this.loadingcreateShipp = false;
          if (data_order && data_order._id) {
            alert(this.$t('shipping_created'), 'success');
            this.closePopUpInformation(index);
          } else alert(data_order, 'warning');
        } else {
          if (!dataToEdit.customer.city) {
            alert(`City obligatoire`, 'warning');
            this.loadingcreateShipp = false;
            return false;
          }
          const data_order = await this.$server.update('orders', dataToEdit);
          this.loadingcreateShipp = false;
          if (data_order && data_order._id) {
            this.closePopUpInformation(index);
            alert('order updated', 'success');
          } else alert(data_order, 'warning');
        }
      } else if (
        this.config.name == 'orders' &&
        dataToEdit.status.name &&
        dataToEdit.status.name == 'Confirmed'
      ) {
        this.loadingcreateShipp = true;

        if (this.shipping._id) {
          if (!dataToEdit.customer.city) {
            alert(`City obligatoire`, 'warning');
            this.loadingcreateShipp = false;
            return false;
          }

          const data_order = await this.$server.update('orders', dataToEdit);
          this.loadingcreateShipp = false;

          if (data_order && data_order._id) {
            this.closePopUpInformation(index);
            alert(this.$t('shipping_order_updated'), 'success');
          } else {
            alert(data_order, 'warning');
          }
        } else {
          if (this.checkDataShipping()) {
            this.shipping.seller = dataToEdit.seller._id;
            this.shipping.country = dataToEdit.customer.country;
            this.shipping.totalPrice = dataToEdit.totalPrice;

            if (!dataToEdit.customer.city) {
              alert(`City obligatoire`, 'warning');
              this.loadingcreateShipp = false;
              return false;
            }

            const checkCity = await this.$server.checkValidateCity('orders', {
              city: dataToEdit.customer.city,
            });
            if (checkCity.invalid) {
              this.validateCity = { ...checkCity, item: dataToEdit };
              this.loadingcreateShipp = false;
              this.$vm2.open('validateCity');
              return false;
            }

            const checkDataShipp = await this.$server.get('orders', {
              id: this.shipping.order,
            });

            if (checkDataShipp.content.status.name == 'Confirmed') {
              this.loadingcreateShipp = false;
              alert('Shipping already created for this order !!', 'warning');
              await this.refresh();
              return false;
            }

            dataToEdit['shipping'] = this.shipping;
            dataToEdit.creatShipInAdmin = true;

            dataToEdit.Confirmation = true;
            const data_order = await this.$server.update('orders', dataToEdit);

            this.loadingcreateShipp = false;
            if (data_order && data_order._id) {
              alert(this.$t('shipping_created'), 'success');
              this.closePopUpInformation(index);
              this.validateCity = null;
            } else {
              alert(data_order, 'warning');
            }
          } else {
            alert(this.$t('all_required_field'), 'warning');
          }
        }
      } else {
        if (
          (this.config.name == 'expeditions' ||
            this.config.name == 'internalexpeditions') &&
          dataToEdit.status == 'received'
        ) {
          if (!dataToEdit.arrivalDate) {
            alert('Arrival Date required !!', 'warning');
            this.loadingcreateShipp = false;
            return false;
          }

          //dataToEdit.seller=dataToEdit.seller;
          //if(dataToEdit.arrivalDate == "Invalid date") dataToEdit.arrivalDate=null;
          if (this.config.name == 'expeditions') {
            this.loadingcreateShipp = true;
            const resW = await this.$server.search('warehouses', {
              country: dataToEdit.country_to,
              limit: 100,
            });
            if (resW.content && resW.content.results) {
              this.checkWarehousingParent = resW.content.results.sort((a, b) =>
                a._id > b._id ? 1 : b._id > a._id ? -1 : 0,
              );
              this.checkWarehousingParent.forEach(x => {
                x.fullOf = false;
              });
            } else this.checkWarehousingParent = [];

            this.checkSetting = this.getElementInArray(
              dataToEdit.seller.settings,
              this.idWharhouse._id,
            );

            if (
              dataToEdit.status == 'received' &&
              (this.checkWarehousingParent.length > 1 ||
                !this.checkSetting ||
                (this.checkSetting &&
                  !this.checkSetting.confirmation &&
                  !this.checkSetting.fulfillement &&
                  !this.checkSetting.shipping))
            ) {
              if (
                !this.checkSetting ||
                (this.checkSetting &&
                  !this.checkSetting.confirmation &&
                  !this.checkSetting.fulfillement &&
                  !this.checkSetting.shipping)
              )
                this.expeditionData.setting.exist = true;
              if (this.checkWarehousingParent.length > 1)
                this.expeditionData.warhouseParent.exist = true;
              this.expeditionData.country = this.$f.getCountryNameByCode(
                this.dataCountry,
                dataToEdit.country_to,
              );
              this.expeditionData.data = dataToEdit;
              this.expeditionData.model = index;
              this.$vm2.open('ModalChangeSetSettingsSeller');
              let exist = false;
              dataToEdit.details.forEach(function(element) {
                if (
                  element.warehouseParentName &&
                  element.warehouseParent &&
                  !element.warehouseParent._id
                ) {
                  exist = true;
                  element.warehouseParent = {
                    _id: element.warehouseParent,
                    name: element.warehouseParentName,
                  };
                }
              });
              if (exist) {
                const indexPP = this.data.findIndex(
                  expedition =>
                    expedition._id.toString() === dataToEdit._id.toString(),
                );
                if (indexPP != -1)
                  this.data[indexPP].details = dataToEdit.details;
              }

              this.loadingcreateShipp = false;
              return false;
            }
          }
        }
        this.$confirm('Are you sure ?').then(async res => {
          if (res) {
            let oldDataOrder = null;
            this.loadingcreateShipp = true;
            if (this.config.name == 'orders' && dataToEdit._id)
              oldDataOrder = await this.$server.get('orders', {
                id: dataToEdit._id,
              });
            const data = await this.$server.update(
              this.config.name,
              dataToEdit,
            );
            this.loadingcreateShipp = false;
            if (data && data._id) {
              //

              if (
                this.config.name == 'orders' &&
                oldDataOrder &&
                oldDataOrder.content &&
                data.status.toString() ==
                  oldDataOrder.content.status._id.toString()
              ) {
                this.closePopUpInformation(index, data);
              } else this.closePopUpInformation(index);
              alert(this.config.title + ' updated', 'success');
            } else alert(data, 'warning');
          } else this.loadingcreateShipp = false;
        });
      }
    },
    async closePopUpInformation(index, data = null) {
      let modal_id = 'modal1_' + index;
      this.$vm2.close(modal_id);

      const filter = this.$f.QueryStringToobject();
      if (filter.index) {
        delete filter.index;
        this.$f.objectToQueryString(filter);
      }

      // Update same data id
      if (
        data &&
        data._id &&
        this.oldData.data &&
        this.oldData.data._id &&
        data._id.toString() == this.oldData.data._id.toString()
      ) {
        const findItemOrder = this.data.findIndex(
          o => o._id.toString() === this.oldData.data._id.toString(),
        );

        if (findItemOrder != -1) {
          this.oldData.loading = true;
          const dataOld = await this.$server.get(this.config.name, {
            id: data._id,
          });

          this.oldData.loading = false;
          if (dataOld.content) {
            if (dataOld.content.status) {
              this.data[findItemOrder].status = dataOld.content.status;
            }

            // Check teleconsultant is same and set null
            let UpdateTel = false;
            if (
              this.config.name == 'orders' &&
              dataOld.content.teleConsultant &&
              dataOld.content.teleConsultant._id.toString() ==
                this.currentUser._id.toString()
            ) {
              const dataUPP = await this.$server.update('orders', {
                _id: dataOld.content._id,
                teleConsultant: null,
                customer: dataOld.content.customer,
                onlyCommentedit: true,
              });
              this.data[findItemOrder].teleConsultant = null;
              UpdateTel = true;
            }

            if (this.config.name == 'orders') {
              this.data[findItemOrder].upsel = dataOld.content.upsel;
              this.data[findItemOrder].remind = dataOld.content.remind;
              this.data[findItemOrder].lastUnreachedDate =
                dataOld.content.lastUnreachedDate;
              this.data[findItemOrder].sameOrderUnreached =
                dataOld.content.sameOrderUnreached;
              this.data[findItemOrder].sameOrderUnreached =
                dataOld.content.sameOrderUnreached;
              if (!UpdateTel) {
                this.data[findItemOrder].teleConsultant =
                  dataOld.content.teleConsultant;
              }
            }

            if (this.config.name == 'shippings') {
              this.data[findItemOrder].courier =
                dataOld.content.courier || null;
              this.data[findItemOrder].date = dataOld.content.date;
            }
          }
        }
      } else {
        await this.refresh();
      }
    },
    async OrderChange(index, order) {
      let modal_id = 'modal1_' + index;
      //  this.$refs[modal_id][0].close();
      this.$vm2.close(modal_id);
      const DataShipp = await this.$server.get('shippings', {
        order: order._id,
        type: 'normal',
      });
      if (DataShipp.content._id) {
        //
        const nDate = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Casablanca',
        });
        let newdate = new Date(nDate);
        this.shippingChange.address = DataShipp.content.address;
        this.shippingChange.order = order._id;
        this.shippingChange.totalPrice = order.totalPrice;
        this.shippingChange.courier = DataShipp.content.courier._id;
        this.shippingChange.zone = DataShipp.content.zone._id;
        this.shippingChange.seller = DataShipp.content.seller;
        this.shippingChange.date = newdate;
        this.shippingChange.country = order.customer.country;
        this.$confirm(this.$t('confirm_craete_shipping_change')).then(
          async res => {
            if (res) {
              const data_ship = await this.$server.create(
                'shippings',
                this.shippingChange,
              );
              if (data_ship._id) {
                this.$router.push('/shippings');
                alert(this.$t('shipping_created'), 'success');
              }
            }
          },
        );
      } else {
        alert(this.$t('no_shipping'), 'error');
      }
    },
    async getCategories() {
      const res = await this.$server.search('categories');
      if (res.content) this.categories = res.content.results;
      else this.categories = [];
    },
    async getRoles() {
      const res = await this.$server.search('roles');
      if (res.content) this.roles = res.content.results;
      else this.roles = [];
    },
    async remove(id, warehousesProduct = [], warehouses = []) {
      let filters = { _id: id };
      if (warehousesProduct.length > 0 && warehouses.length > 0) {
        filters.warehousesProduct = warehousesProduct;
        filters.warehouses = warehouses;
      }

      this.$confirm(this.$t('you_sure')).then(async res => {
        if (res) {
          const data = await this.$server.delete(this.config.name, filters);

          if (data && this.config.name == 'orders') {
            // await this.$server.deleteMany('statusHistories', { order: id });
            // const res= await this.$server.delete('shippings', { order: id });
            // if(res) await this.$server.deleteMany('shippingsHistories', { shipping: res._id });
          }
          if (data && this.config.name == 'shippings') {
            //  await this.$server.deleteMany('shippingsHistories', { shipping: id });
            //  await this.$server.delete('orders', { _id: data.order });
            //  await this.$server.deleteMany('statusHistories', { order: data.order });
          }
          if (data && (data._id || data.nModified)) {
            alert(`${this.name} deleted !`, 'success');
            this.productData = {
              id: null,
              warehouses: [],
              selectWarehouses: [],
            };
            this.$vm2.close('ModaldeleteProduct');
            await this.refreshChild();
          } else alert(data, 'warning');
        }
      });
    },
    async refreshChild() {
      await this.refresh();
    },
    getAccessLinks(action) {
      const modelToCheck = this.config.name;

      const user = this.currentUser;

      if (modelToCheck == 'shippings' && user.type == 'Seller') {
        const dataWhrahouseSetting = this.getElementInArray(
          user.settings,
          this.idWharhouse._id,
        );
        if (
          dataWhrahouseSetting.fulfillement ||
          (action && action == 'changestatus')
        )
          return false;
      }

      if (
        modelToCheck == 'products' &&
        user.type == 'Seller' &&
        action == 'addqte'
      )
        return false;

      if (
        modelToCheck == 'payments' &&
        user.type == 'Seller' &&
        action == 'addPay'
      )
        return false;

      if (
        modelToCheck == 'orders' &&
        user.type == 'TeleConsultant' &&
        action == 'importOrders'
      )
        return false;

      return true;
    },
    getAccess(accessToCheck, status = null, type = null, role = null) {
      if (!this.currentUser.role) return false;

      const modelToCheck = this.config.name;
      const permissions = this.currentUser.role.permissions;
      // let productExist=false;
      if (!role) {
        return false;
      }

      if (
        (modelToCheck == 'shippings' || modelToCheck == 'payments') &&
        accessToCheck == 'print'
      )
        return true;

      // if (
      //   (modelToCheck == 'orders') &&
      //   accessToCheck == 'message'
      // )
      //   return true;

      for (let i in permissions) {
        let model = permissions[i]['model'];
        let access = permissions[i]['access'];
        if (model == modelToCheck) {
          if (
            modelToCheck == 'expeditions' &&
            (accessToCheck == 'update' || accessToCheck == 'delete') &&
            (status == 'received' || status == 'cancelled')
          ) {
            if (
              this.currentUser.type == 'Admin' ||
              this.currentUser.type == 'CEO'
            ) {
              return true;
            } else {
              return false;
            }
          }
          if (
            modelToCheck == 'shippings' &&
            type !== null &&
            this.currentUser.type == 'Accountant' &&
            accessToCheck == 'update' &&
            type == 'normal'
          ) {
            return false;
          }
          if (
            modelToCheck == 'shippings' &&
            status !== null &&
            this.currentUser.type == 'Accountant' &&
            accessToCheck == 'update' &&
            (status.name == 'Processed' ||
              status.name == 'OutOfStock' ||
              status.name == 'Cancelled' ||
              status.name == 'Skipped' ||
              status.name == 'Pending' ||
              status.name == 'Unreached')
          ) {
            return false;
          }
          if (
            modelToCheck == 'orders' &&
            status !== null &&
            this.currentUser.type == 'Seller' &&
            (accessToCheck == 'update' || accessToCheck == 'delete') &&
            status.name !== 'Pending'
          ) {
            return false;
          }

          if (
            modelToCheck == 'shippings' &&
            status !== null &&
            this.currentUser.type == 'Courier' &&
            accessToCheck == 'update' &&
            (status == 'delivered' ||
              status == 'cancelled' ||
              status == 'processed')
          ) {
            return false;
          }
          //  if(modelToCheck=="shippings" && status !== null && this.currentUser.type=='StockManager' && accessToCheck=="update"){
          //     if(status!="cancelled") return true;
          //     else return false;

          //  }
          return access[accessToCheck];
        }
      }
    },
    checkNewSellerData() {
      if (
        this.newSeller.role &&
        this.newSeller.username &&
        this.newSeller.password &&
        this.newSeller.email &&
        this.newSeller.company &&
        this.newSeller.type &&
        this.newSeller.category
      )
        return true;
      else return false;
    },
    checkDataShipping() {
      if (this.shipping.address && this.shipping.order && this.shipping.date)
        return true;
      else {
        this.loadingcreateShipp = false;
        return false;
      }
    },
    QuantityTotalProductOrder(data) {
      var qte = 0;
      for (let i in data) {
        qte += data[i].quantity;
      }
      return qte;
    },
    QuantityTotalProductOrderOnly(data) {
      var qte = 0;
      for (let i in data) {
        qte += data[i].quantity;
      }
      return qte;
    },
    getTotalAmoutPayemnt(data) {
      let total = 0;
      for (let i in data) {
        total += data[i].amount;
      }
      return total;
    },
    async getStatusByName(name) {
      const result = await this.$server.get('status', { name: name });
      return result.content;
    },
    async generatePdf(id, content) {
      if (this.config.name != 'payments') {
        if (this.tabId.length == 0) {
          alert(`No Shipping selected !`, 'warning');
          return false;
        }

        let printContents = '';
        let style = '';
        if (this.tabId.length > 1)
          style =
            'height: 101%; border: 1px solid white; page-break-after: avoid; page-break-before: avoid;';
        else
          style =
            'height: 99%; border: 1px solid white; page-break-after: avoid; page-break-before: avoid;';

        for (let i in this.tabId) {
          let modalPr_id = 'Modalprint_' + this.tabId[i].id;
          printContents +=
            '<div class="container shipp-print" style="height: 99%; border: 1px solid white; page-break-after: avoid; page-break-before: avoid;">';
          printContents += document.getElementById(modalPr_id).innerHTML;
          printContents += '</div>';
        }

        //
        let mywindow = window.open('', 'PRINT', 'height=400,width=600');
        mywindow.document.write(
          '<html lang="en"><head><meta charset="utf-8"><title>DELIVRY NOTE</title>',
        );

        mywindow.document.write(
          `<style type="text/css">
                    .flex {
                      display: flex;
                    }

                    .d-flex {
                      display: flex !important;
                    }
                    
                    .flex-col {
                      flex-direction: column;
                    }

                    .flex-1 {
                      flex: 1 1 0%;
                    }

                    .items-center {
                      align-items: center;
                    }

                    .justify-center {
                      justify-content: center;
                    }

                    .justify-between {
                      justify-content: space-between;
                    }

                    .block {
                        display: block;
                    }

                    .gap-1 {
                      gap: 4px;
                    }

                    .gap-2 {
                      gap: 8px;
                    }

                    .gap-3 {
                      gap: 12px;
                    }

                    .gap-4 {
                      gap: 16px;
                    }

                    .border {
                      border-width: 1px;
                    }

                    .border-0 {
                      border-width: 0;
                    }

                    .border-2 {
                      border-width: 2px;
                    }

                    .border-b-2 {
                      border-bottom-width: 2px;
                    }
                    
                    .border-l-2 {
                      border-left-width: 2px;
                    }

                    .border-r-2 {
                      border-right-width: 2px;
                    }

                    .border-solid {
                      border-style: solid;
                    }

                    .border-black {
                      border-color: #000;
                    }

                    .h-4 {
                      height: 16px;
                    }

                    .h-5 {
                      height: 20px;
                    }

                    .h-6 {
                      height: 24px;
                    }

                    .h-8 {
                      height: 32px;
                    }

                    .h-10 {
                      height: 40px;
                    }

                    .h-12 {
                      height: 48px;
                    }

                    .h-14 {
                      height: 56px;
                    }

                    .h-16 {
                      height: 64px;
                    }

                    .h-20 {
                      height: 80px;
                    }

                    .h-full {
                      height: 100%;
                    }

                    .h-fit {
                      height: fit-content;
                    }

                    .w-full {
                      width: 100%;
                    }

                    .w-quarter {
                      width: 33.333333%;
                    }

                    .w-sixth {
                      width: 66.666667%;
                    }

                    .w-half {
                      width: 50%;
                    }

                    .object-cover {
                      object-fit: cover;
                    }

                    .object-contain {
                      object-fit: contain;
                    }

                    .text-center {
                        text-align: center;
                    }

                    .text-base {
                      font-size: 16px;
                    }

                    .text-lg {
                      font-size: 18px;
                    }

                    .text-xl {
                      font-size: 20px;
                    }

                    .text-2xl {
                      font-size: 24px;
                    }

                    .font-medium {
                        font-weight: 500;
                    }

                    .font-semibold {
                        font-weight: 600;
                    }

                    .font-bold {
                      font-weight: 700;
                    }

                    .pt-8 {
                      padding-top: 32px;
                    }

                    .px-2 {
                        padding-left: .5rem;
                        padding-right: .5rem;
                    }

                    .px-4 {
                      padding-left: 16px;
                      padding-right: 16px;
                    }

                    .py-2 {
                      padding-top: 8px;
                      padding-bottom: 8px;
                    }

                    .bg-black {
                      background-color: #000;
                    }

                    .text-white {
                      color: #fff;
                    }

                    .mt-2 {
                      margin-top: 8px;
                    }

                    .mt-4 {
                      margin-top: 16px;
                    }
                    
                    .capitalize {
                      text-transform: capitalize;
                    }

                    p {
                        margin: 0;
                    }

                    .border-collapse {
                      border-collapse: collapse;
                    }

                    .text-right {
                        text-align: right;
                    }

                    .w-40 {
                        width: 10rem;
                    }

                    .py-1 {
                        padding-top: .25rem;
                        padding-bottom: .25rem;
                    }

                    .inline-block {
                        display: inline-block;
                    }

                    .mb-3 {
                        margin-bottom: .75rem;
                    }

                    .ml-auto {
                        margin-left: auto;
                    }

                    .whitespace-no-wrap {
                        white-space: nowrap;
                    }

                    .text-left {
                        text-align: left;
                    }

                    .min-w-full {
                        min-width: 100%;
                    }

                    .mb-5 {
                        margin-bottom: 1.25rem;
                    }

                    .px-1 {
                        padding-left: .25rem;
                        padding-right: .25rem;
                    }

                    .mt-8 {
                      margin-top: 32px;
                    }

                    .mx-2 {
                      margin-left: 8px;
                      margin-right: 8px;
                    }

                    .mx-auto {
                        margin-left: auto;
                        margin-right: auto;
                    }

                    body {
                        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                        font-size: 1em;
                    }

                    .uppercase {
                        text-transform: uppercase;
                    }

                    .mb-2 {
                        margin-bottom: 0.5rem;
                    }

                    .mb-3 {
                        margin-bottom: 0.75rem;
                    }

                    .size-m {
                        font-size: 12px;
                        font-weight: 500;
                    }

                    @media print {
                        body {
                          -webkit-print-color-adjust: exact;
                        }

                        @page {
                            size: auto;
                            margin: 0mm;
                        }
                    }
                  </style>`,
        );

        mywindow.document.write(
          '</head><body style="margin-top:2mm;margin-left:8mm;margin-right:8mm">',
        );

        mywindow.document.write(printContents);
        mywindow.document.write('</body></html>');

        mywindow.document.close();
        mywindow.focus();

        setTimeout(function() {
          mywindow.print();
          mywindow.close();
        }, 500);
        return false;
      } else {
        if (this.tabId.length == 0) {
          alert(this.$t('no_payement_selected'), 'warning');
          return false;
        }

        const doc = new jsPDF('p', 'pt');
        const fontSizes = {
          TitleFontSize: 14,
          SubTitleFontSize: 12,
          NormalFontSize: 10,
          SmallFontSize: 9,
        };

        const lineSpacing = 12;
        let items;

        let expeditions;
        for (let k in this.tabId) {
          const filter = {
            _id: this.tabId[k],
          };

          const res = await this.$server.search('payments', filter);
          if (res.content.results) {
            items = res.content.results[0].details;
            expeditions = res.content.results[0].expeditions;
          }

          let expeditionsCount = 0;
          for (let i in expeditions) {
            expeditionsCount++;
          }

          let data = [];
          let dataExp = [];

          let i = 1;
          items.forEach(el => {
            let obj = [
              i,
              el.order.id,
              el.order.customer.fullName,
              el.order.totalPrice,
              el.confirmation_vat,
              el.shipping_vat,
              el.shipping_refund_vat,
              el.shipping_change_vat,
              el.amount,
            ];
            i++;
            data.push(obj);
          });

          doc.autoTable({
            headerStyles: { fillColor: [0, 0, 0] },
            theme: 'grid',
            head: [
              [
                '#',
                'ID',
                this.$t('customer'),
                this.$t('total_price'),
                this.$t('confirmation_fees'),
                this.$t('shipping_fees'),
                this.$t('refund_fees'),
                this.$t('change_fees'),
                this.$t('total'),
              ],
            ],
            margin: { top: 150 },
            body: data,
          });

          //Expedition fees
          if (expeditionsCount > 0) {
            doc.setFont('normal');
            doc.setFontSize(fontSizes.SubTitleFontSize);
            doc.text('Expeditions: ', 40, doc.autoTable.previous.finalY + 15);
            let j = 1;
            expeditions.forEach(el => {
              let obj = [
                j,
                el.id.numberOfPackages,
                el.id.transportMode,
                el.id.details.length + ' ' + this.$t('products'),
                el.id.carrier.name,
                el.id.country,
                el.fees,
              ];
              j++;
              dataExp.push(obj);
            });
            doc.autoTable({
              // headerStyles: {fillColor: [0, 0, 0]},
              theme: 'striped',
              head: [
                [
                  '#',
                  this.$t('nb_packages'),
                  this.$t('transport_mode'),
                  this.$t('details'),
                  this.$t('carrier'),
                  this.$t('country'),
                  this.$t('expedition_fees'),
                ],
              ],
              margin: { top: doc.autoTable.previous.finalY + 30 },
              body: dataExp,
            });
          }

          let startX = 40;
          const pageWidth = doc.internal.pageSize.width;
          const endX = pageWidth - startX;
          doc.setFont('arial');
          doc.setFontSize(fontSizes.SubTitleFontSize);

          // set fix value for Y to bring title in alignment with folding marks
          let startY = 50;
          doc.text(this.$t('payement_no') + ' ', startX, startY);
          doc.setFont('bold');

          startX +=
            doc.getStringUnitWidth('Payement NO: ') *
            fontSizes.SubTitleFontSize;
          doc.text(res.content.results[0].id, startX, startY);

          doc.setFont('normal');
          doc.text(
            this.$moment(res.content.results[0].date).format('yyyy-MM-DD'),
            endX,
            startY,
            'right',
          );

          startY = 33;
          startY += lineSpacing * 2;

          startX = 40;
          doc.text(
            this.$t('seller') + ': ' + res.content.results[0].seller.email,
            startX,
            (startY += lineSpacing + 2),
          );

          doc.text(
            this.$t('payement_methode') + ': ' + res.content.results[0].method,
            startX,
            (startY += lineSpacing * 2),
          );

          //total amount orders
          startY += lineSpacing * 2;
          doc.text(
            this.$t('total') +
              ': ' +
              this.getTotalAmoutPayemnt(res.content.results[0].details),
            endX,
            doc.autoTable.previous.finalY + 20,
            'right',
          );

          doc.text(
            this.$t('tva') + ': ' + res.content.results[0].vat + ' %',
            endX,
            doc.autoTable.previous.finalY + 40,
            'right',
          );

          doc.text(
            this.$t('transfert_fees') +
              ': ' +
              res.content.results[0].transfert_fees,
            endX,
            doc.autoTable.previous.finalY + 60,
            'right',
          );

          doc.text(
            this.$t('grand_total') + ': ' + res.content.results[0].amount,
            endX,
            doc.autoTable.previous.finalY + 80,
            'right',
          );

          doc.setLineWidth(0.5);
          startY += 4;

          doc.line(startX - 1, startY, endX + 1, startY);
          startY += 2;

          doc.line(startX - 2, startY, endX + 2, startY);
          startY += 20;

          doc.text(this.$t('orders') + ': ', startX, startY);
          doc.addPage();
        }

        var pageCount = doc.internal.getNumberOfPages();
        doc.deletePage(pageCount);
        doc.save('Payement.pdf');
      }
    },
  },
};
</script>

<style scoped>
.sticky-table-body-right {
  background-color: #f8fafc;
}

.sticky-table-header-right,
.sticky-table-body-right {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 2;
}

.sticky-table-header-right-first:after,
.sticky-table-body-right-first:after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.05);
}

.call-post {
  border: 2px solid #959292;
  border-style: dashed;
  padding: 1px;
  border-radius: 5%;
  font-size: 10px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  line-height: 1px;
  margin-top: 2px;
}

.px-1-imp {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.statusP {
  border-radius: 10px;
  padding: 4px 6px;
  font-size: 13px;
}

.mttt-18 {
  margin-top: 18px;
}

.statusP.status-inactive {
  color: white;
  background-color: #e52f0e;
}

.statusP.status-active {
  color: #57585a;
  background-color: #0aca6e;
}

.v-instock .vs__search {
  display: contents;
}

.label-accept {
  background: #e22ae6;
}

.text-left-imp {
  text-align: left !important;
}

.dropdown-limit {
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}

.parent-warehouse {
  border-left: 1px solid #000;
  padding-left: 20px;
  position: relative;
  margin-left: 18px;
  line-height: 24px;
}

.primary-warehouse::before {
  height: 1px;
  background: #000;
  width: 15px;
  left: 0;
  top: 11px;
  display: inline-block;
  content: '';
  position: absolute;
}

.ware-name {
  background-color: #dbdbdb;
  border-radius: 5px;
  font-size: 10px;
}

.mb-20 {
  margin-bottom: 5rem;
}

.mb-16 {
  margin-bottom: 4rem;
}

.vs-dropdown--limit--after {
  top: 0;
  right: 10px;
  position: absolute;
  width: 10px;
  height: 10px;
  display: block;
  background: #fff;
  transform: rotate(45deg) translate(-7px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  box-sizing: border-box;
}

.prova:after {
  content: attr(data-ribbon);
  position: absolute;
  width: 90px;
  height: 40px;
  background: #428bca;
  color: white;
  top: -5px;
  text-align: center;
  line-height: 50px;
  right: -34px;
  transform: rotate(45deg);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}

.empty-row {
  background: repeating-linear-gradient(
    53deg,
    #bfc0c2 4%,
    #fcfcff 11px 6%,
    #ffffff 10px 7%,
    #9d9c9c 15px
  );
}

.dropdown-action {
  width: max-content;
}

.border-teal {
  border-color: #4dc0b5;
}

.bg-teal-lightest {
  background-color: #e8fffe;
}

.text-red {
  color: #e3342f;
}

i.tiny {
  font-size: 12px;
  line-height: 20px;
}

i.small {
  font-size: 2rem;
}

.table-shipp,
.table-shipp thead {
  border: 2px solid #2c84c7;
}

.bg-light-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(186, 230, 253, var(--tw-bg-opacity));
  border-bottom: 1px solid #fff;
}

#loading {
  position: relative;
}

dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  /* backdrop-filter: blur(3px); */
}

.chat-messages {
  height: 400px; /* Set a fixed height */
  overflow-y: auto; /* Enable vertical scrolling */
  /* scroll-behavior: smooth;
  scroll-padding-block-end: 100%; */
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.modal-backdrop {
  /* background-color: rgba(0, 0, 0, 0.1) !important; */

}


@keyframes gentle-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }
}

.animate-gentle-pulse {
  animation: gentle-pulse 1.5s infinite;
}
</style>
